var _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _g5, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _g6, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _g7, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 458,
    viewBox: "0 0 422 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0417,
    d: "M323.222 428.013C351.661 428.013 374.715 415.097 374.715 399.165C374.715 383.233 351.661 370.317 323.222 370.317C294.783 370.317 271.729 383.233 271.729 399.165C271.729 415.097 294.783 428.013 323.222 428.013Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0833,
    d: "M323.222 427.447C351.103 427.447 373.705 414.785 373.705 399.165C373.705 383.545 351.103 370.883 323.222 370.883C295.341 370.883 272.739 383.545 272.739 399.165C272.739 414.785 295.341 427.447 323.222 427.447Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M323.222 426.881C350.545 426.881 372.695 414.472 372.695 399.165C372.695 383.858 350.545 371.449 323.222 371.449C295.899 371.449 273.749 383.858 273.749 399.165C273.749 414.472 295.899 426.881 323.222 426.881Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1667,
    d: "M323.222 426.315C349.987 426.315 371.685 414.16 371.685 399.165C371.685 384.17 349.987 372.014 323.222 372.014C296.457 372.014 274.759 384.17 274.759 399.165C274.759 414.16 296.457 426.315 323.222 426.315Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2083,
    d: "M323.222 425.75C349.43 425.75 370.675 413.847 370.675 399.165C370.675 384.483 349.43 372.58 323.222 372.58C297.014 372.58 275.769 384.483 275.769 399.165C275.769 413.847 297.014 425.75 323.222 425.75Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M323.222 425.184C348.872 425.184 369.665 413.535 369.665 399.165C369.665 384.795 348.872 373.146 323.222 373.146C297.572 373.146 276.779 384.795 276.779 399.165C276.779 413.535 297.572 425.184 323.222 425.184Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2917,
    d: "M323.222 424.618C348.314 424.618 368.655 413.222 368.655 399.165C368.655 385.108 348.314 373.712 323.222 373.712C298.13 373.712 277.789 385.108 277.789 399.165C277.789 413.222 298.13 424.618 323.222 424.618Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M323.222 424.052C347.757 424.052 367.646 412.91 367.646 399.165C367.646 385.42 347.757 374.277 323.222 374.277C298.688 374.277 278.798 385.42 278.798 399.165C278.798 412.91 298.688 424.052 323.222 424.052Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M323.222 423.487C347.199 423.487 366.635 412.597 366.635 399.165C366.635 385.733 347.199 374.843 323.222 374.843C299.245 374.843 279.808 385.733 279.808 399.165C279.808 412.597 299.245 423.487 323.222 423.487Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4167,
    d: "M323.222 422.921C346.641 422.921 365.626 412.285 365.626 399.165C365.626 386.045 346.641 375.409 323.222 375.409C299.803 375.409 280.818 386.045 280.818 399.165C280.818 412.285 299.803 422.921 323.222 422.921Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4583,
    d: "M323.222 422.355C346.083 422.355 364.616 411.972 364.616 399.165C364.616 386.357 346.083 375.975 323.222 375.975C300.361 375.975 281.828 386.357 281.828 399.165C281.828 411.972 300.361 422.355 323.222 422.355Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M323.222 421.789C345.525 421.789 363.606 411.66 363.606 399.165C363.606 386.67 345.525 376.541 323.222 376.541C300.919 376.541 282.838 386.67 282.838 399.165C282.838 411.66 300.919 421.789 323.222 421.789Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5417,
    d: "M323.222 421.224C344.968 421.224 362.596 411.348 362.596 399.165C362.596 386.982 344.968 377.106 323.222 377.106C301.476 377.106 283.848 386.982 283.848 399.165C283.848 411.348 301.476 421.224 323.222 421.224Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5833,
    d: "M323.222 420.658C344.41 420.658 361.586 411.035 361.586 399.165C361.586 387.295 344.41 377.672 323.222 377.672C302.034 377.672 284.858 387.295 284.858 399.165C284.858 411.035 302.034 420.658 323.222 420.658Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M323.222 420.092C343.852 420.092 360.576 410.723 360.576 399.165C360.576 387.607 343.852 378.238 323.222 378.238C302.592 378.238 285.868 387.607 285.868 399.165C285.868 410.723 302.592 420.092 323.222 420.092Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M323.222 419.526C343.294 419.526 359.566 410.41 359.566 399.165C359.566 387.92 343.294 378.804 323.222 378.804C303.15 378.804 286.878 387.92 286.878 399.165C286.878 410.41 303.15 419.526 323.222 419.526Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7083,
    d: "M323.222 418.96C342.737 418.96 358.557 410.098 358.557 399.165C358.557 388.232 342.737 379.369 323.222 379.369C303.707 379.369 287.888 388.232 287.888 399.165C287.888 410.098 303.707 418.96 323.222 418.96Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M323.222 418.395C342.179 418.395 357.547 409.785 357.547 399.165C357.547 388.545 342.179 379.935 323.222 379.935C304.265 379.935 288.898 388.545 288.898 399.165C288.898 409.785 304.265 418.395 323.222 418.395Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7917,
    d: "M323.222 417.829C341.621 417.829 356.537 409.473 356.537 399.165C356.537 388.857 341.621 380.501 323.222 380.501C304.823 380.501 289.907 388.857 289.907 399.165C289.907 409.473 304.823 417.829 323.222 417.829Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8333,
    d: "M323.222 417.263C341.064 417.263 355.527 409.16 355.527 399.165C355.527 389.17 341.064 381.067 323.222 381.067C305.381 381.067 290.917 389.17 290.917 399.165C290.917 409.16 305.381 417.263 323.222 417.263Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M323.222 416.697C340.506 416.697 354.517 408.848 354.517 399.165C354.517 389.482 340.506 381.633 323.222 381.633C305.938 381.633 291.927 389.482 291.927 399.165C291.927 408.848 305.938 416.697 323.222 416.697Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9167,
    d: "M323.222 416.132C339.948 416.132 353.507 408.535 353.507 399.165C353.507 389.795 339.948 382.198 323.222 382.198C306.496 382.198 292.937 389.795 292.937 399.165C292.937 408.535 306.496 416.132 323.222 416.132Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9583,
    d: "M323.222 415.566C339.39 415.566 352.497 408.223 352.497 399.165C352.497 390.107 339.39 382.764 323.222 382.764C307.054 382.764 293.947 390.107 293.947 399.165C293.947 408.223 307.054 415.566 323.222 415.566Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.222 415C338.832 415 351.487 407.91 351.487 399.165C351.487 390.419 338.832 383.33 323.222 383.33C307.612 383.33 294.957 390.419 294.957 399.165C294.957 407.91 307.612 415 323.222 415Z",
    fill: "#190C00"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0417,
    d: "M135.597 248.488C164.036 248.488 187.09 235.572 187.09 219.64C187.09 203.708 164.036 190.792 135.597 190.792C107.158 190.792 84.1042 203.708 84.1042 219.64C84.1042 235.572 107.158 248.488 135.597 248.488Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0833,
    d: "M135.597 247.922C163.478 247.922 186.08 235.26 186.08 219.64C186.08 204.02 163.478 191.358 135.597 191.358C107.716 191.358 85.1143 204.02 85.1143 219.64C85.1143 235.26 107.716 247.922 135.597 247.922Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M135.597 247.356C162.92 247.356 185.07 234.947 185.07 219.64C185.07 204.333 162.92 191.924 135.597 191.924C108.274 191.924 86.1241 204.333 86.1241 219.64C86.1241 234.947 108.274 247.356 135.597 247.356Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1667,
    d: "M135.597 246.79C162.362 246.79 184.06 234.635 184.06 219.64C184.06 204.645 162.362 192.489 135.597 192.489C108.832 192.489 87.1339 204.645 87.1339 219.64C87.1339 234.635 108.832 246.79 135.597 246.79Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2083,
    d: "M135.597 246.224C161.805 246.224 183.05 234.322 183.05 219.64C183.05 204.958 161.805 193.055 135.597 193.055C109.389 193.055 88.1439 204.958 88.1439 219.64C88.1439 234.322 109.389 246.224 135.597 246.224Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M135.597 245.659C161.247 245.659 182.04 234.01 182.04 219.64C182.04 205.27 161.247 193.621 135.597 193.621C109.947 193.621 89.1538 205.27 89.1538 219.64C89.1538 234.01 109.947 245.659 135.597 245.659Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2917,
    d: "M135.597 245.093C160.689 245.093 181.03 233.697 181.03 219.64C181.03 205.582 160.689 194.187 135.597 194.187C110.505 194.187 90.1636 205.582 90.1636 219.64C90.1636 233.697 110.505 245.093 135.597 245.093Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M135.597 244.527C160.131 244.527 180.021 233.385 180.021 219.64C180.021 205.895 160.131 194.752 135.597 194.752C111.063 194.752 91.1734 205.895 91.1734 219.64C91.1734 233.385 111.063 244.527 135.597 244.527Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M135.597 243.961C159.574 243.961 179.01 233.072 179.01 219.64C179.01 206.207 159.574 195.318 135.597 195.318C111.62 195.318 92.1835 206.207 92.1835 219.64C92.1835 233.072 111.62 243.961 135.597 243.961Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4167,
    d: "M135.597 243.396C159.016 243.396 178.001 232.76 178.001 219.64C178.001 206.52 159.016 195.884 135.597 195.884C112.178 195.884 93.1933 206.52 93.1933 219.64C93.1933 232.76 112.178 243.396 135.597 243.396Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4583,
    d: "M135.597 242.83C158.458 242.83 176.991 232.447 176.991 219.64C176.991 206.832 158.458 196.45 135.597 196.45C112.736 196.45 94.2031 206.832 94.2031 219.64C94.2031 232.447 112.736 242.83 135.597 242.83Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.597 242.264C157.9 242.264 175.981 232.135 175.981 219.64C175.981 207.145 157.9 197.016 135.597 197.016C113.294 197.016 95.2131 207.145 95.2131 219.64C95.2131 232.135 113.294 242.264 135.597 242.264Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5417,
    d: "M135.597 241.698C157.343 241.698 174.971 231.822 174.971 219.64C174.971 207.457 157.343 197.581 135.597 197.581C113.851 197.581 96.223 207.457 96.223 219.64C96.223 231.822 113.851 241.698 135.597 241.698Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5833,
    d: "M135.597 241.133C156.785 241.133 173.961 231.51 173.961 219.64C173.961 207.77 156.785 198.147 135.597 198.147C114.409 198.147 97.2328 207.77 97.2328 219.64C97.2328 231.51 114.409 241.133 135.597 241.133Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M135.597 240.567C156.227 240.567 172.951 231.198 172.951 219.64C172.951 208.082 156.227 198.713 135.597 198.713C114.967 198.713 98.2428 208.082 98.2428 219.64C98.2428 231.198 114.967 240.567 135.597 240.567Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M135.597 240.001C155.669 240.001 171.941 230.885 171.941 219.64C171.941 208.395 155.669 199.279 135.597 199.279C115.525 199.279 99.2526 208.395 99.2526 219.64C99.2526 230.885 115.525 240.001 135.597 240.001Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7083,
    d: "M135.597 239.435C155.112 239.435 170.931 230.573 170.931 219.64C170.931 208.707 155.112 199.844 135.597 199.844C116.082 199.844 100.262 208.707 100.262 219.64C100.262 230.573 116.082 239.435 135.597 239.435Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M135.597 238.87C154.554 238.87 169.921 230.26 169.921 219.64C169.921 209.02 154.554 200.41 135.597 200.41C116.64 200.41 101.273 209.02 101.273 219.64C101.273 230.26 116.64 238.87 135.597 238.87Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7917,
    d: "M135.597 238.304C153.996 238.304 168.912 229.948 168.912 219.64C168.912 209.332 153.996 200.976 135.597 200.976C117.198 200.976 102.282 209.332 102.282 219.64C102.282 229.948 117.198 238.304 135.597 238.304Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8333,
    d: "M135.597 237.738C153.438 237.738 167.902 229.635 167.902 219.64C167.902 209.644 153.438 201.542 135.597 201.542C117.756 201.542 103.292 209.644 103.292 219.64C103.292 229.635 117.756 237.738 135.597 237.738Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M135.597 237.172C152.881 237.172 166.892 229.323 166.892 219.64C166.892 209.957 152.881 202.108 135.597 202.108C118.313 202.108 104.302 209.957 104.302 219.64C104.302 229.323 118.313 237.172 135.597 237.172Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9167,
    d: "M135.597 236.606C152.323 236.606 165.882 229.01 165.882 219.64C165.882 210.269 152.323 202.673 135.597 202.673C118.871 202.673 105.312 210.269 105.312 219.64C105.312 229.01 118.871 236.606 135.597 236.606Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9583,
    d: "M135.597 236.041C151.765 236.041 164.872 228.698 164.872 219.64C164.872 210.582 151.765 203.239 135.597 203.239C119.429 203.239 106.322 210.582 106.322 219.64C106.322 228.698 119.429 236.041 135.597 236.041Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.597 235.475C151.207 235.475 163.862 228.385 163.862 219.64C163.862 210.894 151.207 203.805 135.597 203.805C119.986 203.805 107.332 210.894 107.332 219.64C107.332 228.385 119.986 235.475 135.597 235.475Z",
    fill: "#190C00"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0417,
    d: "M282.618 280.162C311.056 280.162 334.11 267.247 334.11 251.314C334.11 235.382 311.056 222.467 282.618 222.467C254.179 222.467 231.125 235.382 231.125 251.314C231.125 267.247 254.179 280.162 282.618 280.162Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0833,
    d: "M282.618 279.596C310.499 279.596 333.1 266.934 333.1 251.314C333.1 235.695 310.499 223.032 282.618 223.032C254.737 223.032 232.135 235.695 232.135 251.314C232.135 266.934 254.737 279.596 282.618 279.596Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M282.618 279.031C309.941 279.031 332.091 266.622 332.091 251.315C332.091 236.007 309.941 223.598 282.618 223.598C255.295 223.598 233.145 236.007 233.145 251.315C233.145 266.622 255.295 279.031 282.618 279.031Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1667,
    d: "M282.618 278.465C309.383 278.465 331.081 266.309 331.081 251.314C331.081 236.32 309.383 224.164 282.618 224.164C255.852 224.164 234.155 236.32 234.155 251.314C234.155 266.309 255.852 278.465 282.618 278.465Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2083,
    d: "M282.618 277.899C308.825 277.899 330.071 265.997 330.071 251.314C330.071 236.632 308.825 224.73 282.618 224.73C256.41 224.73 235.165 236.632 235.165 251.314C235.165 265.997 256.41 277.899 282.618 277.899Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M282.618 277.333C308.268 277.333 329.061 265.684 329.061 251.314C329.061 236.944 308.268 225.295 282.618 225.295C256.968 225.295 236.175 236.944 236.175 251.314C236.175 265.684 256.968 277.333 282.618 277.333Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2917,
    d: "M282.618 276.768C307.71 276.768 328.051 265.372 328.051 251.315C328.051 237.257 307.71 225.861 282.618 225.861C257.526 225.861 237.184 237.257 237.184 251.315C237.184 265.372 257.526 276.768 282.618 276.768Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M282.618 276.202C307.152 276.202 327.041 265.059 327.041 251.314C327.041 237.569 307.152 226.427 282.618 226.427C258.083 226.427 238.194 237.569 238.194 251.314C238.194 265.059 258.083 276.202 282.618 276.202Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M282.618 275.636C306.594 275.636 326.031 264.747 326.031 251.314C326.031 237.882 306.594 226.993 282.618 226.993C258.641 226.993 239.204 237.882 239.204 251.314C239.204 264.747 258.641 275.636 282.618 275.636Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4167,
    d: "M282.618 275.07C306.037 275.07 325.021 264.434 325.021 251.314C325.021 238.194 306.037 227.558 282.618 227.558C259.199 227.558 240.214 238.194 240.214 251.314C240.214 264.434 259.199 275.07 282.618 275.07Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4583,
    d: "M282.618 274.505C305.479 274.505 324.012 264.122 324.012 251.315C324.012 238.507 305.479 228.124 282.618 228.124C259.757 228.124 241.224 238.507 241.224 251.315C241.224 264.122 259.757 274.505 282.618 274.505Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M282.618 273.939C304.921 273.939 323.002 263.81 323.002 251.315C323.002 238.82 304.921 228.69 282.618 228.69C260.314 228.69 242.234 238.82 242.234 251.315C242.234 263.81 260.314 273.939 282.618 273.939Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5417,
    d: "M282.618 273.373C304.363 273.373 321.992 263.497 321.992 251.314C321.992 239.132 304.363 229.256 282.618 229.256C260.872 229.256 243.244 239.132 243.244 251.314C243.244 263.497 260.872 273.373 282.618 273.373Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5833,
    d: "M282.618 272.807C303.806 272.807 320.982 263.184 320.982 251.314C320.982 239.444 303.806 229.822 282.618 229.822C261.43 229.822 244.254 239.444 244.254 251.314C244.254 263.184 261.43 272.807 282.618 272.807Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M282.618 272.241C303.248 272.241 319.972 262.872 319.972 251.314C319.972 239.757 303.248 230.387 282.618 230.387C261.988 230.387 245.264 239.757 245.264 251.314C245.264 262.872 261.988 272.241 282.618 272.241Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M282.618 271.676C302.69 271.676 318.962 262.56 318.962 251.315C318.962 240.069 302.69 230.953 282.618 230.953C262.545 230.953 246.273 240.069 246.273 251.315C246.273 262.56 262.545 271.676 282.618 271.676Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7083,
    d: "M282.618 271.11C302.132 271.11 317.952 262.247 317.952 251.314C317.952 240.382 302.132 231.519 282.618 231.519C263.103 231.519 247.283 240.382 247.283 251.314C247.283 262.247 263.103 271.11 282.618 271.11Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M282.618 270.544C301.575 270.544 316.942 261.935 316.942 251.314C316.942 240.694 301.575 232.085 282.618 232.085C263.661 232.085 248.293 240.694 248.293 251.314C248.293 261.935 263.661 270.544 282.618 270.544Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7917,
    d: "M282.618 269.978C301.017 269.978 315.932 261.622 315.932 251.314C315.932 241.007 301.017 232.651 282.618 232.651C264.219 232.651 249.303 241.007 249.303 251.314C249.303 261.622 264.219 269.978 282.618 269.978Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8333,
    d: "M282.618 269.413C300.459 269.413 314.923 261.31 314.923 251.315C314.923 241.319 300.459 233.216 282.618 233.216C264.776 233.216 250.313 241.319 250.313 251.315C250.313 261.31 264.776 269.413 282.618 269.413Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M282.618 268.847C299.901 268.847 313.913 260.997 313.913 251.315C313.913 241.632 299.901 233.782 282.618 233.782C265.334 233.782 251.323 241.632 251.323 251.315C251.323 260.997 265.334 268.847 282.618 268.847Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9167,
    d: "M282.618 268.281C299.344 268.281 312.903 260.685 312.903 251.314C312.903 241.944 299.344 234.348 282.618 234.348C265.892 234.348 252.333 241.944 252.333 251.314C252.333 260.685 265.892 268.281 282.618 268.281Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9583,
    d: "M282.618 267.715C298.786 267.715 311.893 260.372 311.893 251.314C311.893 242.256 298.786 234.914 282.618 234.914C266.45 234.914 253.343 242.256 253.343 251.314C253.343 260.372 266.45 267.715 282.618 267.715Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.618 267.149C298.228 267.149 310.883 260.06 310.883 251.314C310.883 242.569 298.228 235.479 282.618 235.479C267.007 235.479 254.353 242.569 254.353 251.314C254.353 260.06 267.007 267.149 282.618 267.149Z",
    fill: "#190C00"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0417,
    d: "M216.715 368.783C245.154 368.783 268.208 355.868 268.208 339.935C268.208 324.003 245.154 311.088 216.715 311.088C188.277 311.088 165.223 324.003 165.223 339.935C165.223 355.868 188.277 368.783 216.715 368.783Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0833,
    d: "M216.715 368.217C244.596 368.217 267.198 355.555 267.198 339.935C267.198 324.316 244.596 311.653 216.715 311.653C188.835 311.653 166.233 324.316 166.233 339.935C166.233 355.555 188.835 368.217 216.715 368.217Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M216.715 367.652C244.039 367.652 266.188 355.243 266.188 339.935C266.188 324.628 244.039 312.219 216.715 312.219C189.392 312.219 167.243 324.628 167.243 339.935C167.243 355.243 189.392 367.652 216.715 367.652Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1667,
    d: "M216.715 367.086C243.481 367.086 265.178 354.93 265.178 339.935C265.178 324.941 243.481 312.785 216.715 312.785C189.95 312.785 168.252 324.941 168.252 339.935C168.252 354.93 189.95 367.086 216.715 367.086Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2083,
    d: "M216.715 366.52C242.923 366.52 264.168 354.618 264.168 339.935C264.168 325.253 242.923 313.351 216.715 313.351C190.508 313.351 169.262 325.253 169.262 339.935C169.262 354.618 190.508 366.52 216.715 366.52Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M216.715 365.954C242.365 365.954 263.159 354.305 263.159 339.935C263.159 325.565 242.365 313.916 216.715 313.916C191.066 313.916 170.272 325.565 170.272 339.935C170.272 354.305 191.066 365.954 216.715 365.954Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2917,
    d: "M216.715 365.388C241.808 365.388 262.149 353.993 262.149 339.935C262.149 325.878 241.808 314.482 216.715 314.482C191.623 314.482 171.282 325.878 171.282 339.935C171.282 353.993 191.623 365.388 216.715 365.388Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M216.715 364.823C241.25 364.823 261.139 353.68 261.139 339.935C261.139 326.19 241.25 315.048 216.715 315.048C192.181 315.048 172.292 326.19 172.292 339.935C172.292 353.68 192.181 364.823 216.715 364.823Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M216.715 364.257C240.692 364.257 260.129 353.368 260.129 339.935C260.129 326.503 240.692 315.614 216.715 315.614C192.739 315.614 173.302 326.503 173.302 339.935C173.302 353.368 192.739 364.257 216.715 364.257Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4167,
    d: "M216.715 363.691C240.134 363.691 259.119 353.055 259.119 339.935C259.119 326.815 240.134 316.179 216.715 316.179C193.296 316.179 174.312 326.815 174.312 339.935C174.312 353.055 193.296 363.691 216.715 363.691Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4583,
    d: "M216.715 363.125C239.577 363.125 258.109 352.743 258.109 339.935C258.109 327.128 239.577 316.745 216.715 316.745C193.854 316.745 175.322 327.128 175.322 339.935C175.322 352.743 193.854 363.125 216.715 363.125Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M216.715 362.56C239.019 362.56 257.099 352.43 257.099 339.935C257.099 327.44 239.019 317.311 216.715 317.311C194.412 317.311 176.332 327.44 176.332 339.935C176.332 352.43 194.412 362.56 216.715 362.56Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5417,
    d: "M216.715 361.994C238.461 361.994 256.089 352.118 256.089 339.935C256.089 327.753 238.461 317.877 216.715 317.877C194.97 317.877 177.341 327.753 177.341 339.935C177.341 352.118 194.97 361.994 216.715 361.994Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5833,
    d: "M216.715 361.428C237.903 361.428 255.08 351.805 255.08 339.935C255.08 328.065 237.903 318.443 216.715 318.443C195.527 318.443 178.351 328.065 178.351 339.935C178.351 351.805 195.527 361.428 216.715 361.428Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M216.715 360.862C237.346 360.862 254.07 351.493 254.07 339.935C254.07 328.378 237.346 319.008 216.715 319.008C196.085 319.008 179.361 328.378 179.361 339.935C179.361 351.493 196.085 360.862 216.715 360.862Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M216.715 360.297C236.788 360.297 253.06 351.181 253.06 339.935C253.06 328.69 236.788 319.574 216.715 319.574C196.643 319.574 180.371 328.69 180.371 339.935C180.371 351.181 196.643 360.297 216.715 360.297Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7083,
    d: "M216.715 359.731C236.23 359.731 252.05 350.868 252.05 339.935C252.05 329.003 236.23 320.14 216.715 320.14C197.201 320.14 181.381 329.003 181.381 339.935C181.381 350.868 197.201 359.731 216.715 359.731Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M216.715 359.165C235.672 359.165 251.04 350.556 251.04 339.935C251.04 329.315 235.672 320.706 216.715 320.706C197.759 320.706 182.391 329.315 182.391 339.935C182.391 350.556 197.759 359.165 216.715 359.165Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7917,
    d: "M216.715 358.599C235.115 358.599 250.03 350.243 250.03 339.935C250.03 329.628 235.115 321.271 216.715 321.271C198.316 321.271 183.401 329.628 183.401 339.935C183.401 350.243 198.316 358.599 216.715 358.599Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8333,
    d: "M216.715 358.034C234.557 358.034 249.02 349.931 249.02 339.935C249.02 329.94 234.557 321.837 216.715 321.837C198.874 321.837 184.411 329.94 184.411 339.935C184.411 349.931 198.874 358.034 216.715 358.034Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M216.715 357.468C233.999 357.468 248.01 349.618 248.01 339.935C248.01 330.253 233.999 322.403 216.715 322.403C199.432 322.403 185.421 330.253 185.421 339.935C185.421 349.618 199.432 357.468 216.715 357.468Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9167,
    d: "M216.715 356.902C233.441 356.902 247 349.306 247 339.935C247 330.565 233.441 322.969 216.715 322.969C199.99 322.969 186.43 330.565 186.43 339.935C186.43 349.306 199.99 356.902 216.715 356.902Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9583,
    d: "M216.715 356.336C232.884 356.336 245.991 348.993 245.991 339.935C245.991 330.877 232.884 323.535 216.715 323.535C200.547 323.535 187.44 330.877 187.44 339.935C187.44 348.993 200.547 356.336 216.715 356.336Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.715 355.77C232.326 355.77 244.981 348.681 244.981 339.935C244.981 331.19 232.326 324.1 216.715 324.1C201.105 324.1 188.45 331.19 188.45 339.935C188.45 348.681 201.105 355.77 216.715 355.77Z",
    fill: "#190C00"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M329.324 252.86V256.873C330.774 257.001 332.256 256.684 333.548 255.905L387.754 223.206C389.402 222.209 390.13 216.769 388.899 215.477C388.725 215.658 387.989 219.042 387.754 219.186L333.548 251.892C332.256 252.671 330.774 252.996 329.324 252.86Z",
    fill: "#2B2E3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M242.924 207.405L326.467 255.966C327.359 256.487 328.334 256.782 329.324 256.873V252.86C330.774 252.996 332.256 252.671 333.548 251.893L387.754 219.186C387.989 219.042 388.193 218.876 388.367 218.695C388.178 218.498 387.958 218.324 387.709 218.181L340.788 190.908L303.358 169.151C301.461 168.048 299.111 168.063 297.229 169.204L244.906 199.377C244.589 199.573 240.975 199.211 241.634 200.591C240.44 202.027 241.179 206.392 242.924 207.405Z",
    fill: "#525575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M242.085 202.682C242.305 202.953 242.592 203.195 242.924 203.392L326.467 251.946C327.359 252.459 328.334 252.769 329.324 252.86C330.774 252.996 332.256 252.671 333.548 251.893L387.754 219.186C387.989 219.042 388.193 218.876 388.366 218.695C389.613 217.387 389.394 215.143 387.709 214.168L347.695 190.908L303.358 165.138C301.461 164.035 299.111 164.05 297.229 165.184L242.879 197.974C241.163 199.009 240.899 201.268 242.085 202.682Z",
    fill: "url(#paint0_linear_7_1850)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M254.587 201.886L323.284 241.954C324.433 242.621 325.854 242.61 326.992 241.923L355.399 224.786C356.395 224.186 356.383 222.738 355.377 222.153L286.258 181.84C285.262 181.261 284.031 181.271 283.045 181.866L254.564 199.048C253.49 199.695 253.503 201.256 254.587 201.886Z",
    fill: "#525575"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M338.788 218.947L341.109 217.543C341.189 217.494 341.289 217.493 341.371 217.539L343.874 218.988C343.956 219.035 343.957 219.152 343.876 219.201L341.561 220.602C341.469 220.658 341.353 220.66 341.259 220.606L338.79 219.177C338.702 219.126 338.701 219 338.788 218.947Z",
    fill: "#3D415B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M337.537 218.248C337.444 218.305 337.329 218.306 337.235 218.252L334.766 216.823C334.678 216.773 334.677 216.647 334.764 216.593L337.085 215.189C337.165 215.141 337.265 215.139 337.347 215.186L339.85 216.634C339.932 216.681 339.933 216.799 339.852 216.848L337.537 218.248Z",
    fill: "#3D415B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M333.513 215.895C333.421 215.951 333.305 215.953 333.211 215.899L330.742 214.47C330.654 214.419 330.653 214.293 330.74 214.24L333.061 212.836C333.141 212.787 333.242 212.786 333.323 212.832L335.826 214.281C335.908 214.328 335.909 214.445 335.828 214.494L333.513 215.895Z",
    fill: "#3D415B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M329.489 213.542C329.397 213.598 329.281 213.599 329.187 213.546L326.718 212.117C326.63 212.066 326.629 211.94 326.717 211.886L329.037 210.483C329.118 210.434 329.218 210.433 329.299 210.479L331.802 211.927C331.884 211.974 331.885 212.092 331.804 212.141L329.489 213.542Z",
    fill: "#3D415B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M325.465 211.188C325.373 211.244 325.257 211.246 325.164 211.192L322.695 209.763C322.606 209.713 322.605 209.586 322.693 209.533L325.013 208.129C325.094 208.08 325.194 208.079 325.275 208.126L327.779 209.574C327.86 209.621 327.861 209.738 327.78 209.788L325.465 211.188Z",
    fill: "#3D415B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M321.442 208.835C321.349 208.891 321.233 208.892 321.14 208.839L318.671 207.41C318.582 207.359 318.581 207.233 318.669 207.18L320.989 205.776C321.07 205.727 321.17 205.726 321.251 205.772L323.755 207.221C323.837 207.268 323.838 207.385 323.756 207.434L321.442 208.835Z",
    fill: "#3D415B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M317.418 206.481C317.325 206.537 317.209 206.539 317.116 206.485L314.647 205.056C314.558 205.006 314.557 204.879 314.645 204.827L316.965 203.422C317.046 203.374 317.146 203.372 317.227 203.419L319.731 204.868C319.813 204.914 319.814 205.032 319.732 205.081L317.418 206.481Z",
    fill: "#3D415B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M313.394 204.128C313.301 204.184 313.185 204.186 313.092 204.132L310.623 202.703C310.534 202.652 310.533 202.526 310.621 202.473L312.941 201.069C313.022 201.02 313.122 201.019 313.203 201.066L315.707 202.514C315.789 202.561 315.79 202.678 315.708 202.727L313.394 204.128Z",
    fill: "#3D415B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M309.37 201.775C309.277 201.831 309.161 201.832 309.068 201.778L306.599 200.35C306.511 200.299 306.509 200.173 306.597 200.12L308.918 198.716C308.998 198.667 309.098 198.666 309.179 198.712L311.683 200.161C311.765 200.208 311.765 200.325 311.684 200.374L309.37 201.775Z",
    fill: "#3D415B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M305.346 199.421C305.253 199.477 305.138 199.479 305.044 199.425L302.575 197.996C302.487 197.946 302.486 197.819 302.573 197.766L304.894 196.362C304.974 196.313 305.075 196.312 305.156 196.359L307.659 197.807C307.741 197.854 307.742 197.971 307.661 198.02L305.346 199.421Z",
    fill: "#3D415B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M301.322 197.068C301.23 197.124 301.114 197.125 301.02 197.072L298.551 195.643C298.463 195.592 298.462 195.466 298.549 195.413L300.87 194.009C300.95 193.96 301.051 193.959 301.132 194.005L303.635 195.454C303.717 195.501 303.718 195.618 303.637 195.667L301.322 197.068Z",
    fill: "#3D415B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M297.298 194.714C297.206 194.77 297.09 194.772 296.996 194.718L294.527 193.289C294.439 193.239 294.438 193.113 294.526 193.059L296.846 191.655C296.926 191.607 297.027 191.605 297.108 191.652L299.611 193.1C299.693 193.147 299.694 193.265 299.613 193.314L297.298 194.714Z",
    fill: "#3D415B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M293.274 192.361C293.182 192.417 293.066 192.419 292.972 192.365L290.503 190.936C290.415 190.886 290.414 190.759 290.502 190.706L292.822 189.302C292.903 189.253 293.003 189.252 293.084 189.298L295.587 190.747C295.669 190.794 295.67 190.911 295.589 190.96L293.274 192.361Z",
    fill: "#3D415B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M289.25 190.007C289.158 190.063 289.042 190.065 288.948 190.011L286.48 188.583C286.391 188.532 286.39 188.406 286.478 188.353L288.798 186.948C288.879 186.9 288.979 186.899 289.06 186.945L291.564 188.394C291.645 188.441 291.646 188.558 291.565 188.607L289.25 190.007Z",
    fill: "#3D415B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M334.17 221.729L336.49 220.325C336.571 220.276 336.671 220.275 336.752 220.321L339.255 221.77C339.337 221.817 339.338 221.934 339.257 221.983L336.943 223.384C336.85 223.44 336.734 223.441 336.641 223.388L334.172 221.959C334.083 221.908 334.082 221.782 334.17 221.729Z",
    fill: "#3D415B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M332.728 217.968L335.232 219.416C335.314 219.463 335.315 219.581 335.233 219.63L332.919 221.03C332.826 221.086 332.71 221.088 332.617 221.034L330.148 219.605C330.06 219.555 330.058 219.429 330.146 219.375L332.466 217.971C332.547 217.923 332.647 217.921 332.728 217.968Z",
    fill: "#3D415B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M328.593 218.681L326.124 217.252C326.036 217.202 326.035 217.075 326.122 217.022L328.443 215.618C328.523 215.569 328.623 215.568 328.705 215.614L331.208 217.063C331.29 217.11 331.291 217.227 331.21 217.276L328.895 218.677C328.802 218.733 328.686 218.734 328.593 218.681Z",
    fill: "#3D415B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M324.681 213.261L327.184 214.71C327.266 214.757 327.266 214.874 327.186 214.923L324.871 216.324C324.778 216.38 324.662 216.381 324.569 216.328L322.1 214.899C322.011 214.848 322.01 214.722 322.098 214.669L324.418 213.265C324.499 213.216 324.599 213.215 324.681 213.261Z",
    fill: "#3D415B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M320.657 210.908L323.16 212.356C323.242 212.403 323.243 212.521 323.162 212.57L320.847 213.97C320.754 214.026 320.639 214.028 320.545 213.974L318.076 212.546C317.988 212.495 317.987 212.368 318.074 212.316L320.395 210.911C320.475 210.862 320.576 210.861 320.657 210.908Z",
    fill: "#3D415B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M316.633 208.554L319.136 210.003C319.218 210.05 319.219 210.167 319.138 210.216L316.823 211.616C316.731 211.672 316.615 211.674 316.521 211.62L314.052 210.192C313.964 210.141 313.963 210.015 314.05 209.962L316.371 208.557C316.451 208.509 316.552 208.508 316.633 208.554Z",
    fill: "#3D415B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M312.609 206.201L315.112 207.649C315.194 207.696 315.195 207.814 315.114 207.863L312.8 209.263C312.707 209.319 312.591 209.321 312.498 209.267L310.029 207.838C309.94 207.788 309.939 207.661 310.027 207.608L312.347 206.204C312.427 206.156 312.528 206.154 312.609 206.201Z",
    fill: "#3D415B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M308.585 203.847L311.088 205.296C311.17 205.343 311.171 205.46 311.09 205.509L308.775 206.91C308.683 206.966 308.567 206.968 308.474 206.914L306.005 205.485C305.916 205.435 305.915 205.308 306.003 205.255L308.323 203.851C308.403 203.802 308.504 203.801 308.585 203.847Z",
    fill: "#3D415B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M304.561 201.494L307.064 202.942C307.146 202.989 307.147 203.107 307.066 203.156L304.752 204.556C304.659 204.613 304.543 204.614 304.45 204.56L301.981 203.131C301.892 203.081 301.891 202.955 301.979 202.901L304.299 201.497C304.38 201.449 304.48 201.447 304.561 201.494Z",
    fill: "#3D415B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M300.537 199.14L303.04 200.589C303.122 200.636 303.123 200.753 303.042 200.802L300.728 202.203C300.635 202.259 300.519 202.261 300.426 202.207L297.957 200.778C297.869 200.727 297.867 200.601 297.955 200.548L300.275 199.144C300.356 199.096 300.456 199.094 300.537 199.14Z",
    fill: "#3D415B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M296.513 196.787L299.017 198.236C299.099 198.282 299.1 198.4 299.018 198.449L296.704 199.85C296.611 199.906 296.496 199.907 296.402 199.854L293.933 198.425C293.845 198.374 293.843 198.248 293.931 198.195L296.252 196.791C296.332 196.742 296.432 196.741 296.513 196.787Z",
    fill: "#3D415B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M292.49 194.434L294.993 195.882C295.075 195.929 295.076 196.047 294.995 196.096L292.68 197.496C292.587 197.552 292.472 197.554 292.378 197.5L289.909 196.071C289.821 196.02 289.82 195.894 289.907 195.841L292.228 194.437C292.308 194.389 292.408 194.388 292.49 194.434Z",
    fill: "#3D415B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M285.883 193.488L288.204 192.084C288.284 192.035 288.385 192.034 288.466 192.081L290.969 193.529C291.051 193.576 291.052 193.693 290.971 193.743L288.656 195.143C288.564 195.199 288.448 195.201 288.354 195.147L285.885 193.718C285.797 193.667 285.796 193.541 285.883 193.488Z",
    fill: "#3D415B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M286.947 191.389L284.632 192.789C284.54 192.845 284.424 192.847 284.33 192.793L281.861 191.365C281.773 191.314 281.772 191.188 281.86 191.135L284.18 189.73C284.26 189.682 284.361 189.681 284.442 189.727L286.945 191.176C287.027 191.222 287.028 191.34 286.947 191.389Z",
    fill: "#3D415B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M325.53 222.388C325.441 222.337 325.44 222.21 325.528 222.157L327.848 220.753C327.929 220.704 328.029 220.703 328.11 220.75L329.056 221.297C329.061 221.3 329.067 221.298 329.073 221.301L330.052 221.873L330.613 222.198C330.615 222.199 330.614 222.202 330.616 222.203L334.637 224.552C334.719 224.598 334.72 224.716 334.639 224.765L332.325 226.166C332.232 226.222 332.116 226.223 332.023 226.17L327.486 223.519L325.53 222.388Z",
    fill: "#3D415B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M324.277 221.459C324.184 221.515 324.068 221.516 323.975 221.463L321.506 220.034C321.417 219.983 321.417 219.857 321.504 219.804L323.825 218.4C323.905 218.351 324.005 218.35 324.086 218.396L326.59 219.845C326.671 219.892 326.672 220.009 326.591 220.058L324.277 221.459Z",
    fill: "#3D415B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M320.062 216.043L322.566 217.492C322.647 217.538 322.648 217.656 322.567 217.705L320.253 219.105C320.16 219.161 320.044 219.163 319.951 219.109L317.482 217.681C317.393 217.63 317.392 217.504 317.48 217.451L319.8 216.046C319.881 215.998 319.981 215.997 320.062 216.043Z",
    fill: "#3D415B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M316.038 213.689L318.542 215.138C318.623 215.185 318.624 215.302 318.543 215.351L316.229 216.752C316.136 216.808 316.02 216.81 315.927 216.756L313.458 215.327C313.37 215.276 313.369 215.15 313.456 215.097L315.777 213.693C315.857 213.645 315.957 213.643 316.038 213.689Z",
    fill: "#3D415B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M312.014 211.336L314.518 212.785C314.6 212.831 314.601 212.949 314.519 212.998L312.205 214.398C312.112 214.454 311.997 214.456 311.903 214.402L309.434 212.974C309.346 212.923 309.345 212.797 309.432 212.744L311.753 211.339C311.833 211.291 311.933 211.29 312.014 211.336Z",
    fill: "#3D415B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M307.991 208.983L310.494 210.431C310.576 210.478 310.577 210.596 310.496 210.645L308.181 212.045C308.089 212.101 307.973 212.103 307.879 212.049L305.41 210.62C305.322 210.57 305.321 210.443 305.409 210.39L307.729 208.986C307.809 208.938 307.909 208.936 307.991 208.983Z",
    fill: "#3D415B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M303.967 206.629L306.47 208.078C306.552 208.124 306.553 208.242 306.472 208.291L304.157 209.692C304.065 209.748 303.949 209.749 303.855 209.696L301.386 208.267C301.298 208.216 301.297 208.09 301.384 208.037L303.705 206.633C303.785 206.584 303.886 206.583 303.967 206.629Z",
    fill: "#3D415B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M299.943 204.276L302.446 205.724C302.528 205.771 302.529 205.889 302.448 205.938L300.133 207.338C300.041 207.394 299.925 207.396 299.831 207.342L297.362 205.913C297.274 205.863 297.273 205.737 297.361 205.683L299.681 204.279C299.761 204.231 299.862 204.229 299.943 204.276Z",
    fill: "#3D415B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M295.919 201.922L298.422 203.371C298.504 203.418 298.505 203.535 298.424 203.584L296.109 204.985C296.017 205.041 295.901 205.043 295.807 204.989L293.338 203.56C293.25 203.509 293.249 203.383 293.337 203.33L295.657 201.926C295.737 201.877 295.838 201.876 295.919 201.922Z",
    fill: "#3D415B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M291.784 202.636L289.315 201.207C289.227 201.156 289.225 201.03 289.313 200.977L291.633 199.573C291.714 199.524 291.814 199.523 291.895 199.569L294.398 201.018C294.48 201.064 294.481 201.182 294.4 201.231L292.086 202.632C291.993 202.688 291.877 202.689 291.784 202.636Z",
    fill: "#3D415B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M287.609 197.219C287.69 197.17 287.79 197.169 287.871 197.216L290.375 198.664C290.456 198.712 290.457 198.829 290.376 198.878L288.062 200.278C287.969 200.334 287.853 200.336 287.76 200.282L285.291 198.854C285.203 198.803 285.201 198.677 285.289 198.624L287.609 197.219Z",
    fill: "#3D415B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M283.847 194.862L286.351 196.311C286.433 196.358 286.434 196.475 286.352 196.524L284.038 197.925C283.945 197.981 283.829 197.982 283.736 197.929L282.871 197.428C282.859 197.424 282.845 197.425 282.833 197.419L277.243 194.147C277.155 194.096 277.153 193.969 277.241 193.917L279.561 192.512C279.642 192.464 279.742 192.462 279.823 192.509L283.842 194.861C283.842 194.861 283.846 194.861 283.847 194.862Z",
    fill: "#3D415B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M324.933 227.293L327.254 225.889C327.334 225.84 327.434 225.839 327.516 225.885L330.019 227.333C330.101 227.38 330.102 227.498 330.021 227.547L327.707 228.948C327.614 229.004 327.498 229.005 327.404 228.952L324.936 227.522C324.847 227.472 324.846 227.346 324.933 227.293Z",
    fill: "#3D415B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M325.997 225.193L323.683 226.594C323.59 226.65 323.474 226.652 323.38 226.598L320.912 225.169C320.823 225.119 320.822 224.992 320.91 224.94L323.23 223.535C323.311 223.487 323.411 223.485 323.492 223.532L325.995 224.98C326.077 225.027 326.078 225.144 325.997 225.193Z",
    fill: "#3D415B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M321.973 222.84L319.659 224.241C319.566 224.297 319.45 224.298 319.356 224.245L316.887 222.816C316.799 222.765 316.798 222.639 316.886 222.586L319.206 221.182C319.287 221.133 319.387 221.132 319.468 221.178L321.971 222.627C322.053 222.674 322.054 222.791 321.973 222.84Z",
    fill: "#3D415B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M315.332 221.891L312.863 220.463C312.775 220.412 312.774 220.285 312.862 220.233L315.182 218.828C315.263 218.78 315.363 218.778 315.444 218.825L317.947 220.274C318.029 220.32 318.03 220.438 317.949 220.487L315.634 221.887C315.542 221.943 315.426 221.945 315.332 221.891Z",
    fill: "#3D415B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M311.309 219.538L308.84 218.109C308.751 218.059 308.75 217.932 308.838 217.879L311.158 216.475C311.239 216.426 311.339 216.425 311.42 216.472L313.923 217.92C314.005 217.967 314.006 218.084 313.925 218.133L311.611 219.534C311.518 219.59 311.402 219.592 311.309 219.538Z",
    fill: "#3D415B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M307.285 217.185L304.816 215.756C304.728 215.705 304.727 215.578 304.814 215.526L307.135 214.121C307.215 214.073 307.315 214.071 307.396 214.118L309.9 215.567C309.982 215.613 309.983 215.731 309.901 215.78L307.587 217.18C307.494 217.236 307.378 217.238 307.285 217.185Z",
    fill: "#3D415B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M303.261 214.831L300.792 213.402C300.704 213.352 300.703 213.225 300.79 213.172L303.111 211.768C303.191 211.719 303.291 211.718 303.372 211.765L305.876 213.213C305.958 213.26 305.959 213.377 305.877 213.426L303.563 214.827C303.47 214.883 303.355 214.885 303.261 214.831Z",
    fill: "#3D415B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M299.237 212.478L296.768 211.049C296.68 210.998 296.679 210.872 296.766 210.819L299.087 209.415C299.167 209.366 299.267 209.365 299.348 209.411L301.852 210.86C301.934 210.907 301.935 211.024 301.853 211.073L299.539 212.474C299.446 212.53 299.331 212.531 299.237 212.478Z",
    fill: "#3D415B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M295.213 210.124L292.744 208.695C292.656 208.645 292.655 208.518 292.742 208.465L295.063 207.061C295.143 207.012 295.244 207.011 295.325 207.058L297.828 208.506C297.91 208.553 297.911 208.67 297.829 208.719L295.515 210.12C295.422 210.176 295.307 210.178 295.213 210.124Z",
    fill: "#3D415B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M291.189 207.771L288.72 206.342C288.632 206.291 288.631 206.165 288.719 206.112L291.039 204.708C291.12 204.659 291.22 204.658 291.301 204.704L293.804 206.153C293.886 206.2 293.887 206.317 293.806 206.366L291.491 207.767C291.399 207.823 291.283 207.824 291.189 207.771Z",
    fill: "#3D415B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M287.165 205.418L284.696 203.989C284.608 203.938 284.607 203.812 284.694 203.759L287.015 202.354C287.095 202.306 287.196 202.305 287.277 202.351L289.78 203.799C289.862 203.846 289.863 203.964 289.782 204.013L287.468 205.413C287.375 205.47 287.259 205.471 287.165 205.418Z",
    fill: "#3D415B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M283.253 199.998L285.756 201.446C285.838 201.493 285.839 201.61 285.758 201.66L283.443 203.06C283.351 203.116 283.235 203.118 283.141 203.064L280.672 201.635C280.584 201.585 280.583 201.458 280.67 201.405L282.991 200.001C283.071 199.953 283.172 199.951 283.253 199.998Z",
    fill: "#3D415B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M279.117 200.711L276.649 199.282C276.56 199.231 276.559 199.105 276.647 199.052L278.967 197.648C279.048 197.599 279.148 197.598 279.229 197.644L281.732 199.093C281.814 199.139 281.815 199.257 281.734 199.306L279.42 200.706C279.327 200.763 279.211 200.764 279.117 200.711Z",
    fill: "#3D415B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M277.71 196.953L275.396 198.353C275.303 198.409 275.188 198.411 275.094 198.357L272.625 196.928C272.537 196.878 272.536 196.751 272.623 196.699L274.944 195.294C275.024 195.246 275.125 195.244 275.205 195.291L277.709 196.739C277.79 196.786 277.791 196.904 277.71 196.953Z",
    fill: "#3D415B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M320.315 230.074L322.636 228.67C322.716 228.622 322.816 228.621 322.897 228.667L325.401 230.115C325.483 230.162 325.484 230.28 325.402 230.329L323.088 231.729C322.995 231.785 322.88 231.787 322.786 231.733L320.317 230.305C320.229 230.254 320.228 230.127 320.315 230.074Z",
    fill: "#3D415B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M319.064 229.376C318.972 229.432 318.856 229.433 318.762 229.38L316.293 227.951C316.205 227.901 316.204 227.774 316.291 227.721L318.612 226.317C318.692 226.268 318.792 226.267 318.874 226.314L321.377 227.762C321.459 227.809 321.46 227.926 321.379 227.975L319.064 229.376Z",
    fill: "#3D415B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M314.738 227.026L312.269 225.598C312.181 225.547 312.18 225.421 312.267 225.368L314.588 223.963C314.668 223.915 314.769 223.914 314.85 223.96L317.353 225.409C317.435 225.456 317.436 225.573 317.355 225.622L315.04 227.022C314.948 227.078 314.832 227.08 314.738 227.026Z",
    fill: "#3D415B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M310.714 224.673L308.245 223.244C308.157 223.194 308.156 223.067 308.243 223.014L310.564 221.61C310.644 221.562 310.745 221.56 310.826 221.607L313.329 223.055C313.411 223.102 313.412 223.22 313.331 223.269L311.016 224.669C310.924 224.725 310.808 224.727 310.714 224.673Z",
    fill: "#3D415B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M306.69 222.32L304.221 220.891C304.133 220.84 304.132 220.714 304.219 220.661L306.54 219.257C306.62 219.208 306.721 219.207 306.802 219.253L309.305 220.702C309.387 220.749 309.388 220.866 309.307 220.915L306.992 222.316C306.9 222.372 306.784 222.374 306.69 222.32Z",
    fill: "#3D415B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M302.667 219.967L300.198 218.537C300.109 218.487 300.108 218.36 300.196 218.308L302.516 216.904C302.596 216.855 302.697 216.853 302.778 216.9L305.281 218.348C305.363 218.395 305.364 218.513 305.283 218.562L302.969 219.962C302.876 220.019 302.76 220.02 302.667 219.967Z",
    fill: "#3D415B"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M298.643 217.613L296.174 216.184C296.085 216.133 296.084 216.007 296.172 215.954L298.492 214.55C298.573 214.501 298.673 214.5 298.754 214.547L301.257 215.995C301.339 216.042 301.34 216.16 301.259 216.209L298.945 217.609C298.852 217.665 298.736 217.667 298.643 217.613Z",
    fill: "#3D415B"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M294.619 215.26L292.15 213.83C292.062 213.78 292.06 213.654 292.148 213.601L294.469 212.197C294.549 212.148 294.649 212.146 294.73 212.193L297.234 213.642C297.316 213.688 297.316 213.806 297.235 213.855L294.921 215.256C294.828 215.312 294.712 215.313 294.619 215.26Z",
    fill: "#3D415B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M290.595 212.906L288.126 211.477C288.038 211.427 288.036 211.3 288.124 211.247L290.445 209.843C290.525 209.794 290.625 209.793 290.706 209.84L293.21 211.288C293.292 211.335 293.293 211.452 293.211 211.501L290.897 212.902C290.804 212.958 290.688 212.96 290.595 212.906Z",
    fill: "#3D415B"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M286.571 210.553L284.102 209.124C284.014 209.073 284.013 208.947 284.1 208.894L286.421 207.49C286.501 207.441 286.602 207.44 286.683 207.486L289.186 208.935C289.268 208.982 289.269 209.099 289.188 209.148L286.873 210.549C286.78 210.605 286.665 210.606 286.571 210.553Z",
    fill: "#3D415B"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M282.547 208.199L280.078 206.771C279.99 206.72 279.989 206.593 280.076 206.541L282.397 205.136C282.477 205.087 282.578 205.086 282.659 205.133L285.162 206.581C285.244 206.628 285.245 206.746 285.164 206.795L282.849 208.195C282.757 208.251 282.641 208.253 282.547 208.199Z",
    fill: "#3D415B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M278.523 205.846L276.054 204.417C275.966 204.367 275.965 204.24 276.053 204.187L278.373 202.783C278.453 202.734 278.554 202.733 278.635 202.779L281.138 204.228C281.22 204.275 281.221 204.392 281.14 204.441L278.826 205.842C278.733 205.898 278.617 205.899 278.523 205.846Z",
    fill: "#3D415B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M274.499 203.492L272.03 202.064C271.942 202.013 271.941 201.887 272.029 201.834L274.349 200.429C274.43 200.381 274.53 200.38 274.611 200.426L277.114 201.875C277.196 201.922 277.197 202.039 277.116 202.088L274.801 203.488C274.709 203.544 274.593 203.546 274.499 203.492Z",
    fill: "#3D415B"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M273.092 199.734L270.778 201.135C270.685 201.191 270.569 201.193 270.476 201.139L268.007 199.71C267.918 199.66 267.917 199.533 268.005 199.48L270.325 198.076C270.406 198.027 270.506 198.026 270.587 198.073L273.09 199.521C273.172 199.568 273.173 199.685 273.092 199.734Z",
    fill: "#3D415B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M318.017 231.452C318.098 231.403 318.198 231.402 318.279 231.449L320.782 232.897C320.864 232.944 320.865 233.062 320.784 233.111L318.47 234.511C318.377 234.567 318.261 234.569 318.168 234.515L315.699 233.087C315.61 233.036 315.609 232.91 315.697 232.857L318.017 231.452Z",
    fill: "#3D415B"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M313.993 229.099C314.074 229.05 314.174 229.049 314.255 229.096L316.759 230.544C316.841 230.591 316.841 230.708 316.76 230.757L314.446 232.158C314.353 232.214 314.237 232.215 314.144 232.162L311.675 230.733C311.587 230.682 311.586 230.556 311.673 230.503L313.993 229.099Z",
    fill: "#3D415B"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M309.97 226.745C310.05 226.697 310.15 226.696 310.231 226.742L312.735 228.191C312.817 228.238 312.817 228.355 312.736 228.404L310.422 229.804C310.329 229.86 310.213 229.862 310.12 229.808L307.651 228.38C307.563 228.329 307.561 228.203 307.649 228.15L309.97 226.745Z",
    fill: "#3D415B"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M305.946 224.392C306.026 224.344 306.126 224.342 306.207 224.389L308.711 225.837C308.793 225.884 308.794 226.001 308.712 226.05L306.398 227.451C306.305 227.507 306.19 227.509 306.096 227.455L303.627 226.026C303.539 225.975 303.538 225.849 303.625 225.796L305.946 224.392Z",
    fill: "#3D415B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M285.826 212.625C285.907 212.576 286.007 212.575 286.088 212.622L287.31 213.329C287.363 213.323 287.417 213.328 287.465 213.356L304.687 223.484C304.769 223.531 304.77 223.648 304.689 223.697L302.374 225.098C302.282 225.154 302.166 225.155 302.072 225.102L298.088 222.758C298.075 222.753 298.061 222.755 298.048 222.748L295.579 221.319C295.558 221.307 295.558 221.283 295.547 221.264L294.104 220.415C294.077 220.409 294.049 220.409 294.024 220.395L291.555 218.966C291.526 218.949 291.522 218.918 291.511 218.89L290.12 218.072C290.079 218.068 290.037 218.062 290 218.041L287.531 216.612C287.494 216.591 287.482 216.554 287.476 216.517L286.131 215.726C286.078 215.727 286.024 215.715 285.977 215.688L283.508 214.259C283.419 214.208 283.418 214.082 283.506 214.029L285.826 212.625Z",
    fill: "#3D415B"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M281.802 210.271C281.883 210.223 281.983 210.222 282.064 210.268L284.568 211.717C284.65 211.764 284.651 211.881 284.569 211.93L282.255 213.33C282.162 213.386 282.046 213.388 281.953 213.334L279.484 211.906C279.396 211.855 279.394 211.729 279.482 211.676L281.802 210.271Z",
    fill: "#3D415B"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M277.778 207.918C277.859 207.87 277.959 207.868 278.04 207.915L280.544 209.363C280.626 209.41 280.626 209.528 280.546 209.577L278.231 210.977C278.138 211.033 278.022 211.035 277.929 210.981L275.46 209.552C275.372 209.502 275.371 209.375 275.458 209.322L277.778 207.918Z",
    fill: "#3D415B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M273.754 205.565C273.835 205.516 273.935 205.515 274.016 205.561L276.52 207.01C276.602 207.057 276.602 207.174 276.521 207.223L274.207 208.624C274.114 208.68 273.998 208.682 273.905 208.628L271.436 207.199C271.348 207.148 271.347 207.022 271.434 206.969L273.754 205.565Z",
    fill: "#3D415B"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M269.731 203.212C269.811 203.163 269.911 203.161 269.993 203.208L272.496 204.656C272.578 204.703 272.579 204.821 272.498 204.87L270.183 206.271C270.09 206.327 269.975 206.328 269.881 206.274L267.412 204.845C267.324 204.795 267.323 204.668 267.41 204.616L269.731 203.212Z",
    fill: "#3D415B"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M263.386 202.262L265.707 200.858C265.787 200.809 265.888 200.808 265.969 200.854L268.472 202.303C268.554 202.35 268.555 202.467 268.474 202.516L266.159 203.917C266.067 203.973 265.951 203.975 265.857 203.921L263.388 202.492C263.3 202.441 263.299 202.315 263.386 202.262Z",
    fill: "#3D415B"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M338.79 218.695L341.259 220.124C341.353 220.177 341.468 220.176 341.561 220.12L343.875 218.719C343.957 218.67 343.956 218.553 343.874 218.506L341.37 217.057C341.289 217.011 341.189 217.012 341.108 217.061L338.788 218.465C338.701 218.518 338.702 218.644 338.79 218.695Z",
    fill: "url(#paint1_linear_7_1850)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M334.766 216.341L337.235 217.77C337.329 217.824 337.444 217.822 337.537 217.766L339.851 216.366C339.933 216.317 339.932 216.199 339.85 216.152L337.346 214.704C337.265 214.657 337.165 214.659 337.084 214.707L334.764 216.111C334.677 216.164 334.678 216.291 334.766 216.341Z",
    fill: "url(#paint2_linear_7_1850)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M330.742 213.988L333.211 215.417C333.305 215.47 333.42 215.469 333.513 215.413L335.827 214.012C335.909 213.963 335.908 213.846 335.826 213.799L333.322 212.35C333.241 212.304 333.141 212.305 333.06 212.354L330.74 213.758C330.653 213.811 330.654 213.937 330.742 213.988Z",
    fill: "url(#paint3_linear_7_1850)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M326.718 211.635L329.187 213.063C329.281 213.117 329.396 213.115 329.489 213.059L331.804 211.659C331.885 211.61 331.884 211.492 331.802 211.446L329.299 209.997C329.217 209.951 329.117 209.952 329.037 210L326.716 211.405C326.629 211.457 326.63 211.584 326.718 211.635Z",
    fill: "url(#paint4_linear_7_1850)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M322.694 209.281L325.163 210.71C325.257 210.764 325.373 210.762 325.465 210.706L327.78 209.305C327.861 209.256 327.86 209.139 327.778 209.092L325.275 207.644C325.193 207.597 325.093 207.598 325.013 207.647L322.692 209.051C322.605 209.104 322.606 209.23 322.694 209.281Z",
    fill: "url(#paint5_linear_7_1850)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M318.671 206.928L321.14 208.357C321.233 208.41 321.349 208.409 321.442 208.353L323.756 206.952C323.837 206.903 323.836 206.786 323.754 206.739L321.251 205.29C321.17 205.244 321.069 205.245 320.989 205.294L318.669 206.698C318.581 206.751 318.582 206.877 318.671 206.928Z",
    fill: "url(#paint6_linear_7_1850)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M314.647 204.574L317.116 206.003C317.209 206.057 317.325 206.055 317.418 205.999L319.732 204.598C319.813 204.549 319.812 204.432 319.73 204.385L317.227 202.937C317.146 202.89 317.045 202.891 316.965 202.94L314.645 204.344C314.557 204.397 314.558 204.524 314.647 204.574Z",
    fill: "url(#paint7_linear_7_1850)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M310.623 202.221L313.092 203.65C313.185 203.703 313.301 203.702 313.394 203.646L315.708 202.245C315.789 202.196 315.788 202.079 315.707 202.032L313.203 200.583C313.122 200.537 313.022 200.538 312.941 200.587L310.621 201.991C310.534 202.044 310.535 202.17 310.623 202.221Z",
    fill: "url(#paint8_linear_7_1850)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M306.599 199.867L309.068 201.296C309.161 201.35 309.277 201.348 309.37 201.292L311.684 199.892C311.765 199.842 311.764 199.725 311.683 199.678L309.179 198.23C309.098 198.183 308.998 198.185 308.917 198.233L306.597 199.637C306.51 199.69 306.511 199.817 306.599 199.867Z",
    fill: "url(#paint9_linear_7_1850)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M302.575 197.514L305.044 198.943C305.138 198.996 305.253 198.995 305.346 198.939L307.66 197.538C307.742 197.489 307.741 197.372 307.659 197.325L305.155 195.876C305.074 195.83 304.974 195.831 304.893 195.88L302.573 197.284C302.486 197.337 302.487 197.463 302.575 197.514Z",
    fill: "url(#paint10_linear_7_1850)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M298.551 195.161L301.02 196.589C301.114 196.643 301.229 196.642 301.322 196.585L303.636 195.185C303.718 195.136 303.717 195.018 303.635 194.972L301.131 193.523C301.05 193.477 300.95 193.478 300.869 193.526L298.549 194.931C298.462 194.983 298.463 195.11 298.551 195.161Z",
    fill: "url(#paint11_linear_7_1850)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M294.527 192.807L296.996 194.236C297.09 194.29 297.206 194.288 297.298 194.232L299.613 192.832C299.694 192.782 299.693 192.665 299.611 192.618L297.107 191.17C297.026 191.123 296.926 191.125 296.846 191.173L294.525 192.577C294.438 192.63 294.439 192.757 294.527 192.807Z",
    fill: "url(#paint12_linear_7_1850)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M290.503 190.454L292.973 191.883C293.066 191.936 293.182 191.935 293.275 191.879L295.589 190.478C295.67 190.429 295.669 190.312 295.587 190.265L293.084 188.816C293.003 188.77 292.902 188.771 292.822 188.82L290.501 190.224C290.414 190.277 290.415 190.403 290.503 190.454Z",
    fill: "url(#paint13_linear_7_1850)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M286.48 188.1L288.949 189.529C289.042 189.583 289.158 189.581 289.251 189.525L291.565 188.125C291.646 188.076 291.645 187.958 291.563 187.911L289.06 186.463C288.979 186.417 288.878 186.418 288.798 186.467L286.478 187.871C286.39 187.923 286.391 188.05 286.48 188.1Z",
    fill: "url(#paint14_linear_7_1850)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M334.172 221.477L336.641 222.905C336.734 222.959 336.85 222.957 336.943 222.901L339.257 221.501C339.338 221.452 339.337 221.335 339.255 221.288L336.752 219.839C336.671 219.793 336.57 219.794 336.49 219.842L334.17 221.247C334.082 221.3 334.083 221.426 334.172 221.477Z",
    fill: "url(#paint15_linear_7_1850)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M330.148 219.123L332.617 220.552C332.71 220.606 332.826 220.604 332.919 220.548L335.233 219.147C335.315 219.098 335.314 218.981 335.232 218.934L332.728 217.486C332.647 217.439 332.547 217.44 332.466 217.489L330.146 218.893C330.058 218.946 330.06 219.073 330.148 219.123Z",
    fill: "url(#paint16_linear_7_1850)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M326.124 216.77L328.593 218.199C328.686 218.252 328.802 218.251 328.895 218.195L331.209 216.794C331.29 216.745 331.289 216.628 331.207 216.581L328.704 215.132C328.623 215.086 328.522 215.087 328.442 215.136L326.122 216.54C326.035 216.593 326.036 216.719 326.124 216.77Z",
    fill: "url(#paint17_linear_7_1850)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M322.1 214.416L324.569 215.845C324.662 215.899 324.778 215.897 324.871 215.841L327.185 214.441C327.266 214.391 327.265 214.274 327.184 214.227L324.68 212.779C324.599 212.732 324.499 212.734 324.418 212.782L322.098 214.186C322.011 214.239 322.012 214.366 322.1 214.416Z",
    fill: "url(#paint18_linear_7_1850)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M318.076 212.063L320.545 213.492C320.639 213.546 320.755 213.544 320.847 213.488L323.162 212.087C323.243 212.038 323.242 211.921 323.16 211.874L320.656 210.425C320.575 210.379 320.475 210.38 320.394 210.429L318.074 211.833C317.987 211.886 317.988 212.012 318.076 212.063Z",
    fill: "url(#paint19_linear_7_1850)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M314.052 209.71L316.521 211.139C316.615 211.192 316.731 211.191 316.823 211.134L319.138 209.734C319.219 209.685 319.218 209.567 319.136 209.521L316.632 208.072C316.551 208.026 316.451 208.027 316.371 208.076L314.05 209.48C313.963 209.533 313.964 209.659 314.052 209.71Z",
    fill: "url(#paint20_linear_7_1850)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M310.029 207.356L312.498 208.785C312.591 208.839 312.707 208.837 312.8 208.781L315.114 207.38C315.195 207.331 315.194 207.214 315.112 207.167L312.609 205.719C312.528 205.672 312.427 205.673 312.347 205.722L310.027 207.126C309.939 207.179 309.94 207.306 310.029 207.356Z",
    fill: "url(#paint21_linear_7_1850)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M306.005 205.003L308.474 206.432C308.567 206.485 308.683 206.484 308.776 206.428L311.09 205.027C311.171 204.978 311.17 204.86 311.088 204.814L308.585 203.365C308.504 203.319 308.403 203.32 308.323 203.369L306.002 204.773C305.915 204.826 305.916 204.952 306.005 205.003Z",
    fill: "url(#paint22_linear_7_1850)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M301.981 202.649L304.45 204.078C304.543 204.132 304.659 204.13 304.752 204.074L307.066 202.674C307.147 202.624 307.146 202.507 307.064 202.46L304.561 201.012C304.48 200.965 304.379 200.967 304.299 201.015L301.978 202.419C301.891 202.472 301.893 202.599 301.981 202.649Z",
    fill: "url(#paint23_linear_7_1850)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M297.957 200.296L300.426 201.725C300.519 201.778 300.635 201.777 300.728 201.721L303.042 200.32C303.123 200.271 303.122 200.154 303.04 200.107L300.537 198.658C300.456 198.612 300.356 198.613 300.275 198.662L297.955 200.066C297.867 200.119 297.868 200.245 297.957 200.296Z",
    fill: "url(#paint24_linear_7_1850)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M293.933 197.943L296.402 199.371C296.496 199.425 296.611 199.423 296.704 199.367L299.018 197.967C299.1 197.918 299.099 197.8 299.017 197.754L296.513 196.305C296.432 196.259 296.332 196.26 296.251 196.308L293.931 197.713C293.844 197.765 293.845 197.892 293.933 197.943Z",
    fill: "url(#paint25_linear_7_1850)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M289.909 195.589L292.378 197.018C292.472 197.072 292.588 197.07 292.68 197.014L294.995 195.613C295.076 195.564 295.075 195.447 294.993 195.4L292.489 193.952C292.408 193.905 292.308 193.906 292.228 193.955L289.907 195.359C289.82 195.412 289.821 195.539 289.909 195.589Z",
    fill: "url(#paint26_linear_7_1850)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M285.885 193.236L288.354 194.665C288.448 194.718 288.564 194.717 288.656 194.661L290.971 193.26C291.052 193.211 291.051 193.094 290.969 193.047L288.466 191.598C288.384 191.552 288.284 191.553 288.204 191.602L285.883 193.006C285.796 193.059 285.797 193.185 285.885 193.236Z",
    fill: "url(#paint27_linear_7_1850)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M281.861 190.882L284.331 192.311C284.424 192.365 284.54 192.363 284.633 192.307L286.947 190.907C287.028 190.857 287.027 190.74 286.945 190.693L284.442 189.245C284.361 189.198 284.26 189.2 284.18 189.248L281.859 190.652C281.772 190.705 281.773 190.832 281.861 190.882Z",
    fill: "url(#paint28_linear_7_1850)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M326.492 222.457L332.022 225.687C332.116 225.741 332.232 225.739 332.324 225.683L334.639 224.283C334.72 224.234 334.719 224.116 334.637 224.069L329.072 220.819C328.991 220.773 328.891 220.774 328.811 220.823L326.49 222.227C326.403 222.28 326.404 222.406 326.492 222.457Z",
    fill: "url(#paint29_linear_7_1850)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M325.53 221.905L327.998 223.334C328.092 223.388 328.208 223.386 328.3 223.33L330.615 221.929C330.696 221.88 330.695 221.763 330.613 221.716L328.11 220.268C328.029 220.221 327.928 220.222 327.848 220.271L325.527 221.675C325.44 221.728 325.441 221.854 325.53 221.905Z",
    fill: "url(#paint30_linear_7_1850)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M321.506 219.552L323.975 220.981C324.068 221.034 324.184 221.033 324.277 220.977L326.591 219.576C326.672 219.527 326.671 219.41 326.589 219.363L324.086 217.914C324.005 217.868 323.904 217.869 323.824 217.918L321.504 219.322C321.416 219.375 321.417 219.501 321.506 219.552Z",
    fill: "url(#paint31_linear_7_1850)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M317.482 217.198L319.951 218.627C320.045 218.681 320.16 218.679 320.253 218.623L322.567 217.223C322.649 217.173 322.648 217.056 322.566 217.009L320.062 215.561C319.981 215.514 319.881 215.516 319.8 215.564L317.48 216.968C317.393 217.021 317.394 217.148 317.482 217.198Z",
    fill: "url(#paint32_linear_7_1850)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M313.458 214.845L315.927 216.274C316.021 216.327 316.136 216.326 316.229 216.27L318.543 214.869C318.625 214.82 318.624 214.703 318.542 214.656L316.038 213.207C315.957 213.161 315.857 213.162 315.776 213.211L313.456 214.615C313.369 214.668 313.37 214.794 313.458 214.845Z",
    fill: "url(#paint33_linear_7_1850)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M309.434 212.492L311.903 213.92C311.997 213.974 312.112 213.972 312.205 213.916L314.52 212.516C314.601 212.467 314.6 212.349 314.518 212.303L312.014 210.854C311.933 210.808 311.833 210.809 311.753 210.857L309.432 212.262C309.345 212.314 309.346 212.441 309.434 212.492Z",
    fill: "url(#paint34_linear_7_1850)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M305.41 210.138L307.879 211.567C307.973 211.62 308.089 211.619 308.181 211.563L310.496 210.162C310.577 210.113 310.576 209.996 310.494 209.949L307.99 208.5C307.909 208.454 307.809 208.455 307.729 208.504L305.408 209.908C305.321 209.961 305.322 210.088 305.41 210.138Z",
    fill: "url(#paint35_linear_7_1850)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M301.386 207.785L303.855 209.213C303.949 209.267 304.065 209.265 304.157 209.209L306.472 207.809C306.553 207.76 306.552 207.642 306.47 207.596L303.967 206.147C303.885 206.101 303.785 206.102 303.705 206.15L301.384 207.555C301.297 207.608 301.298 207.734 301.386 207.785Z",
    fill: "url(#paint36_linear_7_1850)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M297.362 205.431L299.831 206.86C299.925 206.914 300.041 206.912 300.133 206.856L302.448 205.455C302.529 205.406 302.528 205.289 302.446 205.242L299.943 203.794C299.862 203.747 299.761 203.748 299.681 203.797L297.36 205.201C297.273 205.254 297.274 205.381 297.362 205.431Z",
    fill: "url(#paint37_linear_7_1850)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M293.339 203.078L295.808 204.507C295.901 204.56 296.017 204.559 296.11 204.503L298.424 203.102C298.505 203.053 298.504 202.936 298.422 202.889L295.919 201.44C295.838 201.394 295.737 201.395 295.657 201.444L293.337 202.848C293.249 202.901 293.25 203.027 293.339 203.078Z",
    fill: "url(#paint38_linear_7_1850)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M289.315 200.724L291.784 202.153C291.877 202.207 291.993 202.205 292.086 202.149L294.4 200.749C294.481 200.699 294.48 200.582 294.398 200.535L291.895 199.087C291.814 199.04 291.714 199.042 291.633 199.09L289.313 200.494C289.225 200.547 289.226 200.674 289.315 200.724Z",
    fill: "url(#paint39_linear_7_1850)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M285.291 198.371L287.76 199.8C287.854 199.854 287.969 199.852 288.062 199.796L290.376 198.395C290.458 198.346 290.456 198.229 290.375 198.182L287.871 196.733C287.79 196.687 287.69 196.689 287.609 196.737L285.289 198.141C285.202 198.194 285.203 198.32 285.291 198.371Z",
    fill: "url(#paint40_linear_7_1850)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M281.267 196.018L283.736 197.447C283.829 197.5 283.945 197.499 284.038 197.443L286.352 196.042C286.433 195.993 286.432 195.875 286.351 195.829L283.847 194.38C283.766 194.334 283.666 194.335 283.585 194.384L281.265 195.788C281.178 195.84 281.179 195.967 281.267 196.018Z",
    fill: "url(#paint41_linear_7_1850)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M277.243 193.664L282.833 196.936C282.927 196.99 283.043 196.988 283.135 196.932L285.45 195.532C285.531 195.483 285.53 195.365 285.448 195.319L279.823 192.027C279.742 191.98 279.642 191.982 279.562 192.03L277.241 193.434C277.154 193.487 277.155 193.614 277.243 193.664Z",
    fill: "url(#paint42_linear_7_1850)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M324.935 227.04L327.404 228.469C327.498 228.523 327.614 228.521 327.706 228.465L330.021 227.065C330.102 227.015 330.101 226.898 330.019 226.851L327.515 225.403C327.434 225.356 327.334 225.358 327.254 225.406L324.933 226.81C324.846 226.863 324.847 226.99 324.935 227.04Z",
    fill: "url(#paint43_linear_7_1850)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M320.911 224.687L323.38 226.116C323.474 226.169 323.59 226.168 323.683 226.112L325.997 224.711C326.078 224.662 326.077 224.545 325.995 224.498L323.492 223.049C323.411 223.003 323.31 223.004 323.23 223.053L320.909 224.457C320.822 224.51 320.823 224.636 320.911 224.687Z",
    fill: "url(#paint44_linear_7_1850)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M316.888 222.334L319.356 223.762C319.45 223.816 319.566 223.814 319.658 223.758L321.973 222.358C322.054 222.309 322.053 222.191 321.971 222.145L319.468 220.696C319.387 220.65 319.286 220.651 319.206 220.699L316.885 222.104C316.798 222.156 316.799 222.283 316.888 222.334Z",
    fill: "url(#paint45_linear_7_1850)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M312.864 219.98L315.333 221.409C315.426 221.463 315.542 221.461 315.635 221.405L317.949 220.004C318.03 219.955 318.029 219.838 317.947 219.791L315.444 218.343C315.363 218.296 315.263 218.297 315.182 218.346L312.862 219.75C312.774 219.803 312.775 219.93 312.864 219.98Z",
    fill: "url(#paint46_linear_7_1850)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M308.84 217.627L311.309 219.056C311.402 219.109 311.518 219.108 311.611 219.052L313.925 217.651C314.006 217.602 314.005 217.485 313.923 217.438L311.42 215.989C311.339 215.943 311.238 215.944 311.158 215.993L308.838 217.397C308.751 217.45 308.752 217.576 308.84 217.627Z",
    fill: "url(#paint47_linear_7_1850)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M304.816 215.273L307.285 216.702C307.379 216.756 307.494 216.754 307.587 216.698L309.901 215.298C309.983 215.249 309.981 215.131 309.9 215.084L307.396 213.636C307.315 213.589 307.215 213.591 307.134 213.639L304.814 215.043C304.727 215.096 304.728 215.223 304.816 215.273Z",
    fill: "url(#paint48_linear_7_1850)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M300.792 212.92L303.261 214.349C303.354 214.402 303.47 214.401 303.563 214.345L305.877 212.944C305.958 212.895 305.957 212.778 305.876 212.731L303.372 211.282C303.291 211.236 303.191 211.237 303.11 211.286L300.79 212.69C300.703 212.743 300.704 212.869 300.792 212.92Z",
    fill: "url(#paint49_linear_7_1850)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M296.768 210.566L299.237 211.995C299.331 212.049 299.447 212.047 299.539 211.991L301.854 210.591C301.935 210.542 301.934 210.424 301.852 210.377L299.349 208.929C299.267 208.883 299.167 208.884 299.087 208.932L296.766 210.337C296.679 210.39 296.68 210.516 296.768 210.566Z",
    fill: "url(#paint50_linear_7_1850)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M292.744 208.213L295.213 209.642C295.307 209.696 295.423 209.694 295.515 209.638L297.83 208.237C297.911 208.188 297.91 208.071 297.828 208.024L295.325 206.576C295.244 206.529 295.143 206.53 295.063 206.579L292.742 207.983C292.655 208.036 292.656 208.162 292.744 208.213Z",
    fill: "url(#paint51_linear_7_1850)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M288.721 205.86L291.19 207.289C291.283 207.342 291.399 207.341 291.492 207.285L293.806 205.884C293.887 205.835 293.886 205.718 293.804 205.671L291.301 204.222C291.22 204.176 291.119 204.177 291.039 204.226L288.719 205.63C288.631 205.683 288.632 205.809 288.721 205.86Z",
    fill: "url(#paint52_linear_7_1850)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M284.697 203.506L287.166 204.935C287.259 204.989 287.375 204.987 287.468 204.931L289.782 203.531C289.863 203.481 289.862 203.364 289.78 203.317L287.277 201.869C287.196 201.822 287.095 201.824 287.015 201.872L284.695 203.276C284.607 203.329 284.608 203.456 284.697 203.506Z",
    fill: "url(#paint53_linear_7_1850)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M280.673 201.153L283.142 202.582C283.235 202.635 283.351 202.634 283.444 202.578L285.758 201.177C285.839 201.128 285.838 201.011 285.756 200.964L283.253 199.515C283.172 199.469 283.071 199.47 282.991 199.519L280.671 200.923C280.583 200.976 280.584 201.102 280.673 201.153Z",
    fill: "url(#paint54_linear_7_1850)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M276.649 198.8L279.118 200.228C279.211 200.282 279.327 200.28 279.42 200.224L281.734 198.824C281.815 198.775 281.814 198.657 281.732 198.611L279.229 197.162C279.148 197.116 279.048 197.117 278.967 197.165L276.647 198.57C276.559 198.622 276.561 198.749 276.649 198.8Z",
    fill: "url(#paint55_linear_7_1850)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M272.625 196.446L275.094 197.875C275.187 197.929 275.303 197.927 275.396 197.871L277.71 196.47C277.791 196.421 277.79 196.304 277.708 196.257L275.205 194.809C275.124 194.762 275.023 194.763 274.943 194.812L272.623 196.216C272.536 196.269 272.537 196.396 272.625 196.446Z",
    fill: "url(#paint56_linear_7_1850)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M320.317 229.822L322.786 231.251C322.879 231.305 322.995 231.303 323.088 231.247L325.402 229.846C325.483 229.797 325.482 229.68 325.4 229.633L322.897 228.185C322.816 228.138 322.716 228.14 322.635 228.188L320.315 229.592C320.228 229.645 320.229 229.772 320.317 229.822Z",
    fill: "url(#paint57_linear_7_1850)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M316.293 227.469L318.762 228.898C318.856 228.951 318.971 228.95 319.064 228.894L321.378 227.493C321.46 227.444 321.459 227.327 321.377 227.28L318.873 225.831C318.792 225.785 318.692 225.786 318.611 225.835L316.291 227.239C316.204 227.292 316.205 227.418 316.293 227.469Z",
    fill: "url(#paint58_linear_7_1850)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M312.269 225.115L314.738 226.544C314.832 226.598 314.948 226.596 315.04 226.54L317.355 225.14C317.436 225.091 317.435 224.973 317.353 224.927L314.85 223.478C314.769 223.432 314.668 223.433 314.588 223.481L312.267 224.886C312.18 224.938 312.181 225.065 312.269 225.115Z",
    fill: "url(#paint59_linear_7_1850)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M308.245 222.762L310.714 224.191C310.808 224.245 310.924 224.243 311.016 224.187L313.331 222.786C313.412 222.737 313.411 222.62 313.329 222.573L310.826 221.125C310.744 221.078 310.644 221.079 310.564 221.128L308.243 222.532C308.156 222.585 308.157 222.711 308.245 222.762Z",
    fill: "url(#paint60_linear_7_1850)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M304.222 220.409L306.691 221.838C306.784 221.891 306.9 221.89 306.993 221.834L309.307 220.433C309.388 220.384 309.387 220.266 309.305 220.22L306.802 218.771C306.721 218.725 306.62 218.726 306.54 218.775L304.22 220.179C304.132 220.232 304.133 220.358 304.222 220.409Z",
    fill: "url(#paint61_linear_7_1850)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M300.198 218.055L302.667 219.484C302.76 219.538 302.876 219.536 302.969 219.48L305.283 218.08C305.364 218.03 305.363 217.913 305.281 217.866L302.778 216.418C302.697 216.371 302.596 216.373 302.516 216.421L300.196 217.825C300.108 217.878 300.109 218.005 300.198 218.055Z",
    fill: "url(#paint62_linear_7_1850)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M296.174 215.702L298.643 217.131C298.736 217.184 298.852 217.183 298.945 217.127L301.259 215.726C301.34 215.677 301.339 215.56 301.257 215.513L298.754 214.064C298.673 214.018 298.572 214.019 298.492 214.068L296.172 215.472C296.084 215.525 296.085 215.651 296.174 215.702Z",
    fill: "url(#paint63_linear_7_1850)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M292.15 213.348L294.619 214.777C294.712 214.831 294.828 214.829 294.921 214.773L297.235 213.373C297.316 213.323 297.315 213.206 297.233 213.159L294.73 211.711C294.649 211.664 294.548 211.666 294.468 211.714L292.148 213.118C292.061 213.171 292.062 213.298 292.15 213.348Z",
    fill: "url(#paint64_linear_7_1850)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M288.126 210.995L290.595 212.424C290.689 212.477 290.805 212.476 290.897 212.42L293.212 211.019C293.293 210.97 293.292 210.853 293.21 210.806L290.706 209.357C290.625 209.311 290.525 209.312 290.445 209.361L288.124 210.765C288.037 210.818 288.038 210.944 288.126 210.995Z",
    fill: "url(#paint65_linear_7_1850)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M284.102 208.642L286.571 210.07C286.665 210.124 286.781 210.122 286.873 210.066L289.188 208.666C289.269 208.617 289.268 208.499 289.186 208.453L286.683 207.004C286.601 206.958 286.501 206.959 286.421 207.007L284.1 208.412C284.013 208.465 284.014 208.591 284.102 208.642Z",
    fill: "url(#paint66_linear_7_1850)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M280.078 206.288L282.547 207.717C282.641 207.771 282.757 207.769 282.849 207.713L285.164 206.312C285.245 206.263 285.244 206.146 285.162 206.099L282.658 204.651C282.577 204.604 282.477 204.605 282.397 204.654L280.076 206.058C279.989 206.111 279.99 206.238 280.078 206.288Z",
    fill: "url(#paint67_linear_7_1850)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M276.054 203.935L278.523 205.364C278.617 205.417 278.733 205.416 278.825 205.36L281.14 203.959C281.221 203.91 281.22 203.793 281.138 203.746L278.634 202.297C278.553 202.251 278.453 202.252 278.373 202.301L276.052 203.705C275.965 203.758 275.966 203.884 276.054 203.935Z",
    fill: "url(#paint68_linear_7_1850)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M272.031 201.581L274.5 203.01C274.593 203.064 274.709 203.062 274.802 203.006L277.116 201.606C277.197 201.556 277.196 201.439 277.114 201.392L274.611 199.944C274.53 199.897 274.429 199.899 274.349 199.947L272.029 201.351C271.941 201.404 271.942 201.531 272.031 201.581Z",
    fill: "url(#paint69_linear_7_1850)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M268.007 199.228L270.476 200.657C270.569 200.711 270.685 200.709 270.778 200.653L273.092 199.252C273.173 199.203 273.172 199.086 273.09 199.039L270.587 197.59C270.506 197.544 270.405 197.545 270.325 197.594L268.005 198.998C267.917 199.051 267.918 199.177 268.007 199.228Z",
    fill: "url(#paint70_linear_7_1850)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M315.699 232.604L318.168 234.033C318.262 234.087 318.377 234.085 318.47 234.029L320.784 232.628C320.866 232.579 320.865 232.462 320.783 232.415L318.279 230.967C318.198 230.92 318.098 230.921 318.017 230.97L315.697 232.374C315.61 232.427 315.611 232.554 315.699 232.604Z",
    fill: "url(#paint71_linear_7_1850)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M311.675 230.251L314.144 231.68C314.238 231.733 314.353 231.732 314.446 231.676L316.76 230.275C316.841 230.226 316.84 230.109 316.759 230.062L314.255 228.613C314.174 228.567 314.074 228.568 313.993 228.617L311.673 230.021C311.586 230.074 311.587 230.2 311.675 230.251Z",
    fill: "url(#paint72_linear_7_1850)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M307.651 227.897L310.12 229.326C310.214 229.38 310.329 229.378 310.422 229.322L312.736 227.922C312.818 227.872 312.817 227.755 312.735 227.708L310.231 226.26C310.15 226.213 310.05 226.215 309.969 226.263L307.649 227.667C307.562 227.72 307.563 227.847 307.651 227.897Z",
    fill: "url(#paint73_linear_7_1850)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M303.627 225.544L306.096 226.973C306.19 227.026 306.305 227.025 306.398 226.969L308.712 225.568C308.794 225.519 308.793 225.402 308.711 225.355L306.207 223.906C306.126 223.86 306.026 223.861 305.945 223.91L303.625 225.314C303.538 225.367 303.539 225.493 303.627 225.544Z",
    fill: "url(#paint74_linear_7_1850)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M284.884 214.511L302.072 224.619C302.166 224.673 302.282 224.671 302.374 224.615L304.689 223.215C304.77 223.166 304.769 223.048 304.687 223.002L287.464 212.873C287.383 212.827 287.283 212.828 287.203 212.877L284.882 214.281C284.795 214.334 284.796 214.46 284.884 214.511Z",
    fill: "url(#paint75_linear_7_1850)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M295.579 220.837L298.048 222.266C298.142 222.32 298.258 222.318 298.35 222.262L300.665 220.861C300.746 220.812 300.745 220.695 300.663 220.648L298.16 219.2C298.078 219.153 297.978 219.154 297.898 219.203L295.577 220.607C295.49 220.66 295.491 220.787 295.579 220.837Z",
    fill: "url(#paint76_linear_7_1850)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M291.556 218.484L294.025 219.913C294.118 219.966 294.234 219.965 294.327 219.908L296.641 218.508C296.722 218.459 296.721 218.341 296.639 218.295L294.136 216.846C294.055 216.8 293.954 216.801 293.874 216.849L291.554 218.254C291.466 218.307 291.467 218.433 291.556 218.484Z",
    fill: "url(#paint77_linear_7_1850)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M287.532 216.13L290.001 217.559C290.094 217.613 290.21 217.611 290.303 217.555L292.617 216.154C292.698 216.106 292.697 215.988 292.615 215.941L290.112 214.493C290.031 214.446 289.93 214.448 289.85 214.496L287.53 215.9C287.442 215.953 287.443 216.08 287.532 216.13Z",
    fill: "url(#paint78_linear_7_1850)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M283.508 213.777L285.977 215.206C286.07 215.259 286.186 215.258 286.279 215.202L288.593 213.801C288.674 213.752 288.673 213.635 288.591 213.588L286.088 212.139C286.007 212.093 285.907 212.094 285.826 212.143L283.506 213.547C283.419 213.6 283.42 213.726 283.508 213.777Z",
    fill: "url(#paint79_linear_7_1850)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M279.484 211.423L281.953 212.852C282.046 212.906 282.162 212.904 282.255 212.848L284.569 211.448C284.65 211.399 284.649 211.281 284.567 211.234L282.064 209.786C281.983 209.74 281.882 209.741 281.802 209.789L279.482 211.194C279.395 211.247 279.396 211.373 279.484 211.423Z",
    fill: "url(#paint80_linear_7_1850)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M275.46 209.07L277.929 210.499C278.023 210.553 278.139 210.551 278.231 210.495L280.546 209.094C280.627 209.045 280.626 208.928 280.544 208.881L278.04 207.433C277.959 207.386 277.859 207.387 277.779 207.436L275.458 208.84C275.371 208.893 275.372 209.019 275.46 209.07Z",
    fill: "url(#paint81_linear_7_1850)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M271.436 206.717L273.905 208.146C273.999 208.199 274.115 208.198 274.207 208.142L276.522 206.741C276.603 206.692 276.602 206.575 276.52 206.528L274.016 205.079C273.935 205.033 273.835 205.034 273.755 205.083L271.434 206.487C271.347 206.54 271.348 206.666 271.436 206.717Z",
    fill: "url(#paint82_linear_7_1850)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M267.412 204.363L269.881 205.792C269.975 205.846 270.091 205.844 270.183 205.788L272.498 204.388C272.579 204.338 272.578 204.221 272.496 204.174L269.993 202.726C269.911 202.679 269.811 202.681 269.731 202.729L267.41 204.133C267.323 204.186 267.324 204.313 267.412 204.363Z",
    fill: "url(#paint83_linear_7_1850)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M263.388 202.01L265.857 203.439C265.951 203.492 266.067 203.491 266.159 203.435L268.474 202.034C268.555 201.985 268.554 201.868 268.472 201.821L265.969 200.372C265.887 200.326 265.787 200.327 265.707 200.376L263.386 201.78C263.299 201.833 263.3 201.959 263.388 202.01Z",
    fill: "url(#paint84_linear_7_1850)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M235.072 129.432V196.551C235.072 198.509 236.114 200.314 237.807 201.297L325.952 252.382C326.247 252.548 325.671 254.416 325.974 254.469C327.749 254.847 330.441 251.755 330.441 249.798V183.367C330.441 182.15 330.169 180.971 329.655 179.921L325.952 182.195C325.272 180.888 324.222 179.777 322.892 179.006L236.643 129.017C236.175 128.745 235.676 128.594 235.185 128.563C235.109 128.835 235.072 129.13 235.072 129.432Z",
    fill: "url(#paint85_linear_7_1850)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M231.512 131.971V199.098C231.512 201.055 232.555 202.861 234.248 203.844L322.393 254.921C324.267 256.009 326.594 254.793 326.851 252.715C326.866 252.594 326.874 252.465 326.874 252.337V185.913C326.874 184.598 326.549 183.321 325.952 182.195C325.272 180.887 324.221 179.777 322.891 179.006L236.643 129.017C236.175 128.745 235.676 128.594 235.185 128.563C234.648 128.518 234.127 128.609 233.643 128.805L233.62 128.813C233.099 129.032 232.631 129.372 232.275 129.818L232.268 129.825C231.799 130.399 231.512 131.132 231.512 131.971Z",
    fill: "url(#paint86_linear_7_1850)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M233.643 128.805C234.127 128.609 234.648 128.518 235.185 128.563C235.676 128.594 236.175 128.744 236.643 129.017L322.892 179.006C324.222 179.777 325.272 180.888 325.952 182.195L329.655 179.921C328.975 178.493 327.872 177.276 326.458 176.46L321.161 173.391L240.203 126.47C238.85 125.684 237.286 125.949 236.25 126.855L236.228 126.87L233.643 128.805Z",
    fill: "url(#paint87_linear_7_1850)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6981 247.486V251.499C93.2471 251.627 91.766 251.31 90.4738 250.531L36.2675 217.832C34.6199 216.835 33.8914 211.395 35.1231 210.103C35.2968 210.284 36.0331 213.669 36.2675 213.812L90.4738 246.519C91.7662 247.297 93.2473 247.622 94.6981 247.486Z",
    fill: "url(#paint88_linear_7_1850)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M181.097 202.031L97.5546 250.592C96.6629 251.114 95.688 251.408 94.6981 251.499V247.486C93.2471 247.622 91.7659 247.297 90.4738 246.519L36.2674 213.812C36.0331 213.669 35.8291 213.502 35.6552 213.321C35.8442 213.124 36.0632 212.951 36.3128 212.807L83.2341 185.534L120.664 163.777C122.561 162.674 124.911 162.689 126.793 163.83L179.116 194.003C179.433 194.199 183.047 193.837 182.388 195.217C183.581 196.653 182.843 201.018 181.097 202.031Z",
    fill: "#525575"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M181.936 197.308C181.717 197.579 181.43 197.821 181.097 198.018L97.5546 246.572C96.6629 247.085 95.688 247.395 94.6981 247.486C93.2471 247.622 91.766 247.297 90.4738 246.519L36.2675 213.812C36.0331 213.668 35.8291 213.502 35.6552 213.321C34.4084 212.013 34.6273 209.769 36.3128 208.794L76.3272 185.534L120.664 159.764C122.561 158.661 124.911 158.676 126.793 159.809L181.143 192.599C182.858 193.635 183.123 195.894 181.936 197.308Z",
    fill: "url(#paint89_linear_7_1850)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M169.435 196.512L100.738 236.58C99.5889 237.247 98.1677 237.236 97.0301 236.549L68.6231 219.413C67.6273 218.812 67.6391 217.364 68.6445 216.779L137.764 176.466C138.76 175.888 139.991 175.898 140.977 176.493L169.458 193.674C170.531 194.321 170.519 195.882 169.435 196.512Z",
    fill: "#525575"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2335 213.573L82.9128 212.169C82.8325 212.12 82.7323 212.119 82.651 212.165L80.1476 213.614C80.0657 213.661 80.0647 213.778 80.146 213.827L82.4604 215.228C82.553 215.284 82.6688 215.286 82.7624 215.232L85.2315 213.803C85.3198 213.752 85.321 213.626 85.2335 213.573Z",
    fill: "#3D415B"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4845 212.874C86.577 212.93 86.6929 212.932 86.7865 212.878L89.2553 211.449C89.3437 211.399 89.3447 211.273 89.2573 211.219L86.9367 209.815C86.8563 209.767 86.7559 209.765 86.6748 209.812L84.1714 211.26C84.0895 211.307 84.0885 211.425 84.1698 211.474L86.4845 212.874Z",
    fill: "#3D415B"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5083 210.521C90.6009 210.577 90.7167 210.579 90.8103 210.525L93.2791 209.096C93.3675 209.045 93.3685 208.919 93.281 208.866L90.9605 207.462C90.8802 207.413 90.78 207.412 90.6987 207.458L88.1953 208.907C88.1133 208.954 88.1125 209.071 88.1937 209.12L90.5083 210.521Z",
    fill: "#3D415B"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5321 208.168C94.6247 208.224 94.7406 208.225 94.8341 208.172L97.303 206.743C97.3913 206.692 97.3924 206.566 97.3048 206.513L94.9843 205.109C94.9038 205.06 94.8038 205.059 94.7225 205.105L92.2191 206.554C92.1372 206.6 92.1362 206.718 92.2175 206.767L94.5321 208.168Z",
    fill: "#3D415B"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M98.556 205.814C98.6485 205.87 98.7644 205.872 98.858 205.818L101.327 204.39C101.415 204.339 101.416 204.213 101.329 204.159L99.0082 202.755C98.9277 202.706 98.8273 202.705 98.7463 202.752L96.2429 204.2C96.161 204.247 96.1602 204.365 96.2413 204.414L98.556 205.814Z",
    fill: "#3D415B"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M102.58 203.461C102.673 203.517 102.788 203.518 102.882 203.465L105.351 202.036C105.439 201.985 105.44 201.859 105.353 201.806L103.032 200.402C102.952 200.353 102.851 200.352 102.77 200.398L100.267 201.847C100.185 201.894 100.184 202.011 100.265 202.06L102.58 203.461Z",
    fill: "#3D415B"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M106.604 201.107C106.696 201.163 106.812 201.165 106.906 201.111L109.375 199.683C109.463 199.632 109.464 199.506 109.377 199.453L107.056 198.048C106.976 198 106.876 197.999 106.794 198.045L104.291 199.494C104.209 199.54 104.208 199.658 104.289 199.707L106.604 201.107Z",
    fill: "#3D415B"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M110.628 198.754C110.72 198.81 110.836 198.812 110.93 198.758L113.399 197.329C113.487 197.279 113.488 197.152 113.401 197.099L111.08 195.695C111 195.647 110.899 195.645 110.818 195.692L108.315 197.14C108.233 197.187 108.232 197.305 108.313 197.354L110.628 198.754Z",
    fill: "#3D415B"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M114.652 196.401C114.744 196.457 114.86 196.458 114.954 196.404L117.422 194.976C117.511 194.925 117.512 194.799 117.424 194.746L115.104 193.342C115.023 193.293 114.923 193.292 114.842 193.338L112.339 194.787C112.257 194.834 112.256 194.951 112.337 195L114.652 196.401Z",
    fill: "#3D415B"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M118.675 194.047C118.768 194.103 118.884 194.105 118.977 194.051L121.446 192.622C121.535 192.572 121.536 192.445 121.448 192.392L119.128 190.988C119.047 190.94 118.947 190.938 118.866 190.985L116.363 192.434C116.281 192.48 116.28 192.598 116.361 192.647L118.675 194.047Z",
    fill: "#3D415B"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M122.699 191.694C122.792 191.75 122.908 191.752 123.001 191.698L125.47 190.269C125.559 190.218 125.56 190.092 125.472 190.039L123.152 188.635C123.071 188.586 122.971 188.585 122.89 188.631L120.386 190.08C120.305 190.127 120.303 190.244 120.385 190.293L122.699 191.694Z",
    fill: "#3D415B"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M126.723 189.34C126.816 189.396 126.932 189.398 127.025 189.344L129.494 187.915C129.583 187.865 129.584 187.739 129.496 187.685L127.176 186.281C127.095 186.233 126.995 186.231 126.914 186.278L124.41 187.726C124.329 187.773 124.328 187.891 124.409 187.94L126.723 189.34Z",
    fill: "#3D415B"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M130.747 186.987C130.84 187.043 130.956 187.045 131.049 186.991L133.518 185.562C133.606 185.512 133.607 185.385 133.52 185.332L131.199 183.928C131.119 183.879 131.019 183.878 130.938 183.924L128.434 185.373C128.352 185.42 128.351 185.537 128.433 185.586L130.747 186.987Z",
    fill: "#3D415B"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M134.771 184.634C134.864 184.69 134.979 184.691 135.073 184.638L137.542 183.209C137.63 183.158 137.631 183.032 137.544 182.979L135.223 181.575C135.143 181.526 135.042 181.525 134.962 181.571L132.458 183.02C132.376 183.067 132.375 183.184 132.457 183.233L134.771 184.634Z",
    fill: "#3D415B"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8517 216.355L87.5312 214.951C87.4507 214.902 87.3505 214.901 87.2694 214.947L84.766 216.396C84.6841 216.443 84.6831 216.56 84.7642 216.609L87.0788 218.01C87.1714 218.066 87.2873 218.068 87.3808 218.014L89.8497 216.585C89.938 216.534 89.939 216.408 89.8517 216.355Z",
    fill: "#3D415B"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2934 212.594L88.7901 214.042C88.7081 214.089 88.7071 214.207 88.7882 214.256L91.1027 215.656C91.1954 215.712 91.3113 215.714 91.4049 215.66L93.8737 214.231C93.9619 214.181 93.9631 214.055 93.8755 214.001L91.5551 212.597C91.4747 212.549 91.3744 212.547 91.2934 212.594Z",
    fill: "#3D415B"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4287 213.307L97.8976 211.878C97.9857 211.828 97.9869 211.701 97.8994 211.648L95.5789 210.244C95.4984 210.195 95.3982 210.194 95.3169 210.24L92.8137 211.689C92.7318 211.736 92.7308 211.853 92.8119 211.902L95.1263 213.303C95.2193 213.359 95.3351 213.361 95.4287 213.307Z",
    fill: "#3D415B"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3409 207.887L96.8378 209.336C96.7558 209.383 96.7548 209.5 96.8359 209.549L99.1504 210.95C99.2431 211.006 99.3588 211.007 99.4526 210.954L101.921 209.525C102.01 209.474 102.011 209.348 101.923 209.295L99.6028 207.891C99.5224 207.842 99.4221 207.841 99.3409 207.887Z",
    fill: "#3D415B"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M103.365 205.534L100.862 206.982C100.78 207.029 100.779 207.147 100.86 207.196L103.174 208.596C103.267 208.652 103.383 208.654 103.476 208.6L105.945 207.172C106.033 207.121 106.035 206.994 105.947 206.942L103.627 205.537C103.546 205.488 103.446 205.487 103.365 205.534Z",
    fill: "#3D415B"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M107.389 203.18L104.885 204.629C104.804 204.676 104.803 204.793 104.884 204.842L107.198 206.243C107.291 206.299 107.407 206.3 107.5 206.247L109.969 204.818C110.057 204.768 110.058 204.641 109.971 204.588L107.65 203.184C107.57 203.135 107.47 203.134 107.389 203.18Z",
    fill: "#3D415B"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M111.413 200.827L108.909 202.275C108.828 202.322 108.827 202.44 108.908 202.489L111.222 203.889C111.315 203.945 111.431 203.947 111.524 203.893L113.993 202.464C114.081 202.414 114.083 202.287 113.995 202.234L111.675 200.83C111.594 200.782 111.494 200.78 111.413 200.827Z",
    fill: "#3D415B"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M115.436 198.473L112.933 199.922C112.851 199.969 112.851 200.086 112.932 200.135L115.246 201.536C115.339 201.592 115.454 201.593 115.548 201.54L118.017 200.111C118.105 200.06 118.107 199.934 118.019 199.881L115.699 198.477C115.618 198.428 115.518 198.427 115.436 198.473Z",
    fill: "#3D415B"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M119.46 196.12L116.957 197.569C116.875 197.615 116.874 197.733 116.955 197.782L119.27 199.183C119.363 199.239 119.478 199.24 119.572 199.187L122.041 197.758C122.129 197.707 122.13 197.581 122.043 197.528L119.722 196.124C119.642 196.075 119.541 196.073 119.46 196.12Z",
    fill: "#3D415B"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M123.484 193.767L120.981 195.215C120.899 195.262 120.898 195.379 120.979 195.428L123.294 196.829C123.386 196.885 123.502 196.887 123.596 196.833L126.065 195.404C126.153 195.354 126.154 195.227 126.067 195.174L123.746 193.77C123.666 193.721 123.565 193.72 123.484 193.767Z",
    fill: "#3D415B"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M127.508 191.413L125.005 192.862C124.923 192.908 124.922 193.026 125.003 193.075L127.317 194.476C127.41 194.532 127.526 194.533 127.619 194.48L130.088 193.051C130.177 193 130.178 192.874 130.09 192.821L127.77 191.417C127.69 191.368 127.589 191.367 127.508 191.413Z",
    fill: "#3D415B"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M131.532 189.06L129.029 190.508C128.947 190.555 128.946 190.673 129.027 190.722L131.341 192.122C131.434 192.178 131.55 192.18 131.643 192.126L134.112 190.698C134.201 190.647 134.202 190.521 134.114 190.467L131.794 189.063C131.714 189.015 131.613 189.013 131.532 189.06Z",
    fill: "#3D415B"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M138.138 188.114L135.818 186.71C135.737 186.661 135.637 186.66 135.556 186.707L133.053 188.155C132.971 188.202 132.969 188.319 133.051 188.369L135.365 189.769C135.458 189.825 135.574 189.827 135.667 189.773L138.136 188.344C138.225 188.294 138.226 188.167 138.138 188.114Z",
    fill: "#3D415B"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M137.075 186.015L139.389 187.416C139.482 187.472 139.597 187.473 139.691 187.42L142.16 185.991C142.248 185.94 142.249 185.814 142.162 185.761L139.841 184.357C139.761 184.308 139.661 184.307 139.58 184.353L137.076 185.802C136.994 185.849 136.993 185.966 137.075 186.015Z",
    fill: "#3D415B"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4919 217.014C98.5803 216.963 98.5813 216.836 98.4937 216.783L96.1733 215.379C96.093 215.33 95.9928 215.329 95.9114 215.376L94.9655 215.923C94.96 215.926 94.954 215.924 94.9488 215.927L93.9693 216.499L93.4081 216.824C93.4063 216.825 93.407 216.828 93.4052 216.829L89.3842 219.178C89.3023 219.224 89.3013 219.342 89.3824 219.391L91.6968 220.792C91.7894 220.848 91.9053 220.849 91.9988 220.796L96.5355 218.145L98.4919 217.014Z",
    fill: "#3D415B"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7447 216.085C99.8373 216.141 99.9532 216.142 100.047 216.089L102.516 214.66C102.604 214.61 102.605 214.483 102.518 214.43L100.197 213.026C100.117 212.977 100.016 212.976 99.9353 213.023L97.4321 214.471C97.3502 214.518 97.3492 214.635 97.4303 214.685L99.7447 216.085Z",
    fill: "#3D415B"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M103.959 210.669L101.456 212.118C101.374 212.164 101.373 212.281 101.454 212.331L103.769 213.731C103.861 213.787 103.977 213.789 104.071 213.735L106.539 212.307C106.628 212.256 106.629 212.129 106.541 212.077L104.221 210.672C104.141 210.624 104.04 210.623 103.959 210.669Z",
    fill: "#3D415B"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M107.983 208.316L105.48 209.764C105.398 209.811 105.397 209.929 105.478 209.978L107.793 211.378C107.885 211.434 108.001 211.436 108.095 211.382L110.563 209.953C110.652 209.903 110.653 209.776 110.565 209.723L108.245 208.319C108.165 208.271 108.064 208.269 107.983 208.316Z",
    fill: "#3D415B"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M112.007 205.962L109.504 207.411C109.422 207.458 109.421 207.575 109.502 207.624L111.816 209.025C111.909 209.081 112.025 209.083 112.118 209.029L114.587 207.6C114.676 207.549 114.677 207.423 114.589 207.37L112.269 205.966C112.189 205.917 112.088 205.916 112.007 205.962Z",
    fill: "#3D415B"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M116.031 203.609L113.528 205.057C113.446 205.104 113.445 205.222 113.526 205.271L115.84 206.671C115.933 206.727 116.049 206.729 116.142 206.675L118.611 205.246C118.7 205.196 118.701 205.069 118.613 205.016L116.293 203.612C116.212 203.564 116.112 203.562 116.031 203.609Z",
    fill: "#3D415B"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M120.055 201.255L117.552 202.704C117.47 202.751 117.469 202.868 117.55 202.917L119.864 204.318C119.957 204.374 120.073 204.376 120.166 204.322L122.635 202.893C122.724 202.842 122.725 202.716 122.637 202.663L120.317 201.259C120.236 201.21 120.136 201.209 120.055 201.255Z",
    fill: "#3D415B"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M124.079 198.902L121.575 200.35C121.493 200.397 121.492 200.515 121.574 200.564L123.888 201.965C123.981 202.021 124.096 202.022 124.19 201.969L126.659 200.539C126.747 200.489 126.748 200.363 126.661 200.31L124.34 198.906C124.26 198.857 124.16 198.855 124.079 198.902Z",
    fill: "#3D415B"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M128.103 196.548L125.599 197.997C125.518 198.044 125.517 198.161 125.598 198.21L127.912 199.611C128.005 199.667 128.12 199.668 128.214 199.615L130.683 198.186C130.771 198.135 130.772 198.009 130.685 197.956L128.364 196.552C128.284 196.503 128.184 196.502 128.103 196.548Z",
    fill: "#3D415B"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M132.238 197.262L134.707 195.832C134.795 195.782 134.796 195.656 134.709 195.603L132.388 194.199C132.308 194.15 132.207 194.149 132.126 194.195L129.623 195.644C129.541 195.691 129.54 195.808 129.621 195.857L131.936 197.258C132.028 197.314 132.144 197.315 132.238 197.262Z",
    fill: "#3D415B"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M136.412 191.845C136.332 191.796 136.231 191.795 136.15 191.842L133.647 193.29C133.565 193.337 133.564 193.454 133.645 193.503L135.96 194.904C136.052 194.96 136.168 194.962 136.262 194.908L138.731 193.479C138.819 193.429 138.82 193.302 138.732 193.25L136.412 191.845Z",
    fill: "#3D415B"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M140.174 189.488L137.671 190.937C137.589 190.984 137.588 191.101 137.669 191.15L139.984 192.551C140.076 192.607 140.192 192.608 140.286 192.555L141.15 192.054C141.163 192.05 141.177 192.051 141.188 192.045L146.779 188.773C146.867 188.722 146.868 188.595 146.78 188.543L144.46 187.138C144.38 187.09 144.279 187.088 144.198 187.135L140.179 189.487L140.174 189.488Z",
    fill: "#3D415B"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0881 221.919L96.7677 220.515C96.6874 220.466 96.5872 220.465 96.5058 220.511L94.0024 221.96C93.9205 222.006 93.9195 222.124 94.0008 222.173L96.3151 223.574C96.4078 223.63 96.5235 223.631 96.6173 223.578L99.0863 222.149C99.1745 222.098 99.1757 221.972 99.0881 221.919Z",
    fill: "#3D415B"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0247 219.819L100.339 221.22C100.432 221.276 100.548 221.278 100.641 221.224L103.11 219.795C103.198 219.745 103.2 219.618 103.112 219.566L100.792 218.161C100.711 218.113 100.611 218.111 100.53 218.158L98.0265 219.606C97.9445 219.653 97.9435 219.77 98.0247 219.819Z",
    fill: "#3D415B"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M102.049 217.466L104.363 218.867C104.456 218.923 104.571 218.924 104.665 218.871L107.134 217.442C107.222 217.391 107.223 217.265 107.136 217.212L104.815 215.808C104.735 215.759 104.635 215.758 104.554 215.805L102.05 217.253C101.968 217.3 101.967 217.417 102.049 217.466Z",
    fill: "#3D415B"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M108.689 216.517L111.158 215.088C111.246 215.038 111.247 214.911 111.16 214.859L108.839 213.454C108.759 213.406 108.658 213.404 108.577 213.451L106.074 214.9C105.992 214.946 105.991 215.064 106.072 215.113L108.387 216.513C108.48 216.569 108.595 216.571 108.689 216.517Z",
    fill: "#3D415B"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M112.713 214.164L115.182 212.735C115.27 212.685 115.271 212.558 115.184 212.505L112.863 211.101C112.783 211.052 112.682 211.051 112.601 211.098L110.098 212.546C110.016 212.593 110.015 212.71 110.096 212.759L112.411 214.16C112.503 214.216 112.619 214.218 112.713 214.164Z",
    fill: "#3D415B"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M116.737 211.811L119.206 210.382C119.294 210.331 119.295 210.205 119.208 210.152L116.887 208.747C116.807 208.699 116.706 208.698 116.625 208.744L114.122 210.193C114.04 210.24 114.039 210.357 114.12 210.406L116.434 211.806C116.527 211.862 116.643 211.864 116.737 211.811Z",
    fill: "#3D415B"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M120.761 209.457L123.23 208.028C123.318 207.978 123.319 207.851 123.231 207.798L120.911 206.394C120.83 206.346 120.73 206.344 120.649 206.391L118.146 207.839C118.064 207.886 118.063 208.003 118.144 208.052L120.459 209.453C120.551 209.509 120.667 209.511 120.761 209.457Z",
    fill: "#3D415B"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M124.785 207.104L127.253 205.675C127.342 205.624 127.343 205.498 127.255 205.445L124.935 204.041C124.854 203.992 124.754 203.991 124.673 204.037L122.17 205.486C122.088 205.533 122.087 205.65 122.168 205.699L124.482 207.1C124.575 207.156 124.691 207.157 124.785 207.104Z",
    fill: "#3D415B"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M128.808 204.75L131.277 203.321C131.365 203.271 131.367 203.145 131.279 203.091L128.958 201.687C128.878 201.639 128.778 201.638 128.697 201.684L126.193 203.132C126.111 203.179 126.111 203.297 126.192 203.346L128.506 204.746C128.599 204.802 128.715 204.804 128.808 204.75Z",
    fill: "#3D415B"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M132.832 202.397L135.301 200.968C135.389 200.917 135.391 200.791 135.303 200.738L132.982 199.334C132.902 199.285 132.802 199.284 132.721 199.331L130.217 200.779C130.136 200.826 130.134 200.943 130.216 200.992L132.53 202.393C132.623 202.449 132.738 202.45 132.832 202.397Z",
    fill: "#3D415B"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M136.856 200.043L139.325 198.615C139.413 198.564 139.415 198.438 139.327 198.384L137.006 196.98C136.926 196.932 136.826 196.931 136.745 196.977L134.241 198.425C134.159 198.472 134.158 198.59 134.24 198.639L136.554 200.039C136.647 200.095 136.763 200.097 136.856 200.043Z",
    fill: "#3D415B"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M140.769 194.624L138.265 196.072C138.183 196.119 138.182 196.236 138.264 196.285L140.578 197.686C140.671 197.742 140.786 197.744 140.88 197.69L143.349 196.261C143.437 196.211 143.439 196.084 143.351 196.031L141.03 194.627C140.95 194.579 140.85 194.577 140.769 194.624Z",
    fill: "#3D415B"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M144.904 195.337L147.373 193.908C147.461 193.857 147.462 193.731 147.375 193.678L145.054 192.274C144.974 192.225 144.873 192.224 144.792 192.27L142.289 193.719C142.207 193.766 142.206 193.883 142.287 193.932L144.602 195.333C144.694 195.389 144.81 195.391 144.904 195.337Z",
    fill: "#3D415B"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M146.311 191.579L148.625 192.979C148.718 193.035 148.834 193.037 148.928 192.983L151.397 191.554C151.485 191.504 151.486 191.377 151.399 191.325L149.078 189.92C148.998 189.872 148.897 189.87 148.816 189.917L146.313 191.365C146.231 191.412 146.23 191.53 146.311 191.579Z",
    fill: "#3D415B"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M103.707 224.7L101.386 223.296C101.306 223.248 101.205 223.247 101.124 223.293L98.6208 224.742C98.5389 224.788 98.5379 224.906 98.619 224.955L100.933 226.356C101.026 226.412 101.142 226.413 101.236 226.36L103.705 224.931C103.793 224.88 103.794 224.754 103.707 224.7Z",
    fill: "#3D415B"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M104.957 224.002C105.05 224.058 105.166 224.06 105.26 224.006L107.728 222.577C107.817 222.527 107.818 222.4 107.73 222.347L105.41 220.943C105.329 220.895 105.229 220.893 105.148 220.94L102.644 222.388C102.563 222.435 102.562 222.552 102.643 222.602L104.957 224.002Z",
    fill: "#3D415B"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M109.283 221.653L111.752 220.224C111.84 220.173 111.842 220.047 111.754 219.994L109.433 218.59C109.353 218.541 109.253 218.54 109.172 218.586L106.668 220.035C106.586 220.082 106.585 220.199 106.667 220.248L108.981 221.649C109.074 221.705 109.19 221.706 109.283 221.653Z",
    fill: "#3D415B"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M113.307 219.299L115.776 217.87C115.864 217.82 115.866 217.693 115.778 217.64L113.457 216.236C113.377 216.188 113.277 216.186 113.196 216.233L110.692 217.681C110.61 217.728 110.609 217.846 110.691 217.895L113.005 219.295C113.098 219.351 113.214 219.353 113.307 219.299Z",
    fill: "#3D415B"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M117.331 216.946L119.8 215.517C119.888 215.466 119.889 215.34 119.802 215.287L117.481 213.883C117.401 213.834 117.301 213.833 117.219 213.879L114.716 215.328C114.634 215.375 114.633 215.492 114.714 215.541L117.029 216.942C117.122 216.998 117.237 217 117.331 216.946Z",
    fill: "#3D415B"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M121.355 214.593L123.824 213.164C123.912 213.113 123.913 212.986 123.826 212.934L121.505 211.53C121.425 211.481 121.324 211.479 121.243 211.526L118.74 212.975C118.658 213.021 118.657 213.139 118.738 213.188L121.053 214.589C121.145 214.645 121.261 214.646 121.355 214.593Z",
    fill: "#3D415B"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M125.379 212.239L127.848 210.81C127.936 210.759 127.937 210.633 127.85 210.58L125.529 209.176C125.449 209.127 125.348 209.126 125.267 209.172L122.764 210.621C122.682 210.668 122.681 210.785 122.762 210.834L125.077 212.235C125.169 212.291 125.285 212.293 125.379 212.239Z",
    fill: "#3D415B"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M129.403 209.886L131.872 208.457C131.96 208.406 131.961 208.28 131.874 208.227L129.553 206.823C129.473 206.774 129.372 206.773 129.291 206.819L126.788 208.268C126.706 208.314 126.705 208.432 126.786 208.481L129.101 209.882C129.193 209.938 129.309 209.939 129.403 209.886Z",
    fill: "#3D415B"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M133.427 207.532L135.896 206.103C135.984 206.053 135.985 205.926 135.898 205.873L133.577 204.469C133.497 204.42 133.396 204.419 133.315 204.466L130.812 205.914C130.73 205.961 130.729 206.078 130.81 206.127L133.125 207.528C133.217 207.584 133.333 207.586 133.427 207.532Z",
    fill: "#3D415B"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M137.45 205.179L139.92 203.75C140.008 203.699 140.009 203.573 139.922 203.52L137.601 202.116C137.521 202.067 137.42 202.066 137.339 202.112L134.836 203.561C134.754 203.608 134.753 203.725 134.834 203.774L137.148 205.175C137.241 205.231 137.357 205.232 137.45 205.179Z",
    fill: "#3D415B"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M141.474 202.825L143.943 201.397C144.032 201.346 144.033 201.22 143.945 201.167L141.625 199.762C141.544 199.714 141.444 199.713 141.363 199.759L138.859 201.207C138.777 201.254 138.777 201.372 138.858 201.421L141.172 202.821C141.265 202.877 141.381 202.879 141.474 202.825Z",
    fill: "#3D415B"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M145.498 200.472L147.967 199.043C148.056 198.993 148.057 198.866 147.969 198.813L145.649 197.409C145.568 197.361 145.468 197.359 145.387 197.406L142.883 198.854C142.801 198.901 142.8 199.018 142.882 199.067L145.196 200.468C145.289 200.524 145.405 200.525 145.498 200.472Z",
    fill: "#3D415B"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M149.522 198.118L151.991 196.69C152.079 196.639 152.08 196.513 151.993 196.46L149.672 195.055C149.592 195.007 149.492 195.006 149.411 195.052L146.907 196.501C146.825 196.548 146.824 196.665 146.906 196.714L149.22 198.114C149.313 198.17 149.428 198.172 149.522 198.118Z",
    fill: "#3D415B"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M150.929 194.361L153.244 195.761C153.336 195.817 153.452 195.819 153.546 195.765L156.015 194.336C156.103 194.286 156.104 194.159 156.017 194.106L153.696 192.702C153.616 192.654 153.516 192.652 153.434 192.699L150.931 194.147C150.849 194.194 150.848 194.312 150.929 194.361Z",
    fill: "#3D415B"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M106.004 226.078C105.924 226.03 105.824 226.029 105.742 226.075L103.239 227.523C103.157 227.571 103.156 227.688 103.237 227.737L105.552 229.137C105.644 229.194 105.76 229.195 105.854 229.142L108.323 227.713C108.411 227.662 108.412 227.536 108.325 227.483L106.004 226.078Z",
    fill: "#3D415B"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M110.028 223.725C109.948 223.677 109.847 223.675 109.766 223.722L107.263 225.17C107.181 225.217 107.18 225.335 107.261 225.384L109.576 226.784C109.668 226.84 109.784 226.842 109.878 226.788L112.347 225.359C112.435 225.309 112.436 225.182 112.348 225.129L110.028 223.725Z",
    fill: "#3D415B"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M114.052 221.371C113.971 221.323 113.871 221.322 113.79 221.368L111.287 222.816C111.205 222.863 111.204 222.981 111.285 223.03L113.6 224.43C113.692 224.486 113.808 224.488 113.902 224.434L116.371 223.005C116.459 222.955 116.46 222.828 116.372 222.776L114.052 221.371Z",
    fill: "#3D415B"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M118.076 219.018C117.995 218.97 117.895 218.968 117.814 219.015L115.311 220.463C115.229 220.51 115.228 220.628 115.309 220.677L117.623 222.077C117.716 222.133 117.832 222.135 117.925 222.081L120.394 220.652C120.483 220.602 120.484 220.475 120.396 220.422L118.076 219.018Z",
    fill: "#3D415B"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M138.195 207.251C138.115 207.202 138.015 207.201 137.933 207.248L136.712 207.955C136.658 207.949 136.605 207.954 136.557 207.982L119.334 218.11C119.253 218.157 119.252 218.274 119.333 218.323L121.647 219.724C121.74 219.78 121.856 219.781 121.949 219.728L125.934 217.384C125.946 217.379 125.961 217.381 125.973 217.374L128.442 215.945C128.464 215.933 128.463 215.909 128.474 215.89L129.918 215.041C129.945 215.035 129.973 215.035 129.997 215.021L132.466 213.592C132.495 213.575 132.5 213.545 132.51 213.516L133.902 212.698C133.943 212.694 133.984 212.688 134.021 212.667L136.49 211.239C136.527 211.217 136.54 211.18 136.546 211.143L137.891 210.352C137.944 210.353 137.997 210.341 138.045 210.314L140.514 208.885C140.602 208.835 140.603 208.708 140.516 208.655L138.195 207.251Z",
    fill: "#3D415B"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M142.219 204.898C142.139 204.849 142.038 204.848 141.957 204.894L139.454 206.343C139.372 206.39 139.371 206.507 139.452 206.556L141.767 207.956C141.859 208.012 141.975 208.014 142.069 207.96L144.538 206.532C144.626 206.481 144.627 206.355 144.539 206.302L142.219 204.898Z",
    fill: "#3D415B"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M146.243 202.544C146.162 202.496 146.062 202.494 145.981 202.541L143.478 203.99C143.396 204.036 143.395 204.154 143.476 204.203L145.79 205.603C145.883 205.659 145.999 205.661 146.093 205.607L148.561 204.179C148.65 204.128 148.651 204.001 148.563 203.949L146.243 202.544Z",
    fill: "#3D415B"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M150.267 200.191C150.186 200.142 150.086 200.141 150.005 200.187L147.502 201.636C147.42 201.683 147.419 201.8 147.5 201.849L149.814 203.25C149.907 203.306 150.023 203.307 150.117 203.254L152.585 201.825C152.674 201.774 152.675 201.648 152.587 201.595L150.267 200.191Z",
    fill: "#3D415B"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M154.291 197.838C154.21 197.789 154.11 197.787 154.029 197.834L151.526 199.283C151.444 199.329 151.443 199.447 151.524 199.496L153.838 200.897C153.931 200.953 154.047 200.954 154.14 200.9L156.609 199.472C156.697 199.421 156.699 199.294 156.611 199.242L154.291 197.838Z",
    fill: "#3D415B"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M160.635 196.888L158.315 195.484C158.234 195.435 158.134 195.434 158.053 195.481L155.549 196.929C155.468 196.976 155.467 197.094 155.548 197.143L157.862 198.543C157.955 198.599 158.071 198.601 158.164 198.547L160.633 197.118C160.721 197.068 160.723 196.941 160.635 196.888Z",
    fill: "#3D415B"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2315 213.321L82.7626 214.75C82.6691 214.803 82.5532 214.802 82.4606 214.746L80.1462 213.345C80.0651 213.296 80.0661 213.179 80.148 213.132L82.6514 211.683C82.7325 211.637 82.8329 211.638 82.9132 211.687L85.2337 213.091C85.3208 213.144 85.3198 213.27 85.2315 213.321Z",
    fill: "url(#paint90_linear_7_1850)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2556 210.967L86.7865 212.396C86.6929 212.45 86.5771 212.448 86.4845 212.392L84.1701 210.992C84.089 210.943 84.09 210.825 84.1719 210.779L86.6753 209.33C86.7564 209.284 86.8568 209.285 86.9371 209.333L89.2576 210.738C89.3447 210.79 89.3437 210.917 89.2556 210.967Z",
    fill: "url(#paint91_linear_7_1850)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2794 208.614L90.8104 210.043C90.7168 210.096 90.6009 210.095 90.5083 210.039L88.1939 208.638C88.1128 208.589 88.1138 208.472 88.1957 208.425L90.6991 206.976C90.7802 206.93 90.8806 206.931 90.961 206.98L93.2814 208.384C93.3688 208.437 93.3676 208.563 93.2794 208.614Z",
    fill: "url(#paint92_linear_7_1850)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3032 206.26L94.8342 207.689C94.7406 207.743 94.6247 207.741 94.5322 207.685L92.2177 206.285C92.1366 206.236 92.1376 206.118 92.2196 206.072L94.7229 204.623C94.8041 204.577 94.9045 204.578 94.9848 204.626L97.3052 206.031C97.3926 206.084 97.3916 206.21 97.3032 206.26Z",
    fill: "url(#paint93_linear_7_1850)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M101.327 203.907L98.858 205.336C98.7645 205.39 98.6486 205.388 98.556 205.332L96.2416 203.931C96.1605 203.882 96.1615 203.765 96.2434 203.718L98.7468 202.27C98.8279 202.223 98.9283 202.224 99.0086 202.273L101.329 203.677C101.416 203.73 101.415 203.857 101.327 203.907Z",
    fill: "url(#paint94_linear_7_1850)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M105.351 201.554L102.882 202.983C102.789 203.036 102.673 203.035 102.58 202.979L100.266 201.578C100.185 201.529 100.186 201.412 100.267 201.365L102.771 199.916C102.852 199.87 102.952 199.871 103.033 199.92L105.353 201.324C105.44 201.377 105.439 201.503 105.351 201.554Z",
    fill: "url(#paint95_linear_7_1850)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M109.375 199.2L106.906 200.629C106.812 200.683 106.696 200.681 106.604 200.625L104.289 199.225C104.208 199.175 104.209 199.058 104.291 199.011L106.794 197.563C106.876 197.516 106.976 197.518 107.056 197.566L109.377 198.971C109.464 199.023 109.463 199.15 109.375 199.2Z",
    fill: "url(#paint96_linear_7_1850)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M113.399 196.847L110.93 198.276C110.836 198.329 110.72 198.328 110.628 198.272L108.313 196.871C108.232 196.822 108.233 196.705 108.315 196.658L110.819 195.209C110.9 195.163 111 195.164 111.08 195.213L113.401 196.617C113.488 196.67 113.487 196.796 113.399 196.847Z",
    fill: "url(#paint97_linear_7_1850)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M117.423 194.494L114.954 195.922C114.86 195.976 114.744 195.974 114.652 195.918L112.337 194.518C112.256 194.469 112.257 194.351 112.339 194.305L114.842 192.856C114.923 192.81 115.024 192.811 115.104 192.86L117.425 194.264C117.512 194.316 117.511 194.443 117.423 194.494Z",
    fill: "url(#paint98_linear_7_1850)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M121.447 192.14L118.977 193.569C118.884 193.623 118.768 193.621 118.675 193.565L116.361 192.164C116.28 192.115 116.281 191.998 116.363 191.951L118.866 190.503C118.947 190.456 119.048 190.457 119.128 190.506L121.449 191.91C121.536 191.963 121.535 192.09 121.447 192.14Z",
    fill: "url(#paint99_linear_7_1850)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M125.47 189.787L123.001 191.215C122.908 191.269 122.792 191.268 122.699 191.211L120.385 189.811C120.304 189.762 120.305 189.644 120.387 189.598L122.89 188.149C122.971 188.103 123.072 188.104 123.152 188.153L125.472 189.557C125.56 189.61 125.559 189.736 125.47 189.787Z",
    fill: "url(#paint100_linear_7_1850)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M129.494 187.433L127.025 188.862C126.932 188.916 126.816 188.914 126.723 188.858L124.409 187.457C124.328 187.408 124.329 187.291 124.411 187.244L126.914 185.796C126.995 185.749 127.096 185.751 127.176 185.799L129.496 187.203C129.584 187.256 129.583 187.383 129.494 187.433Z",
    fill: "url(#paint101_linear_7_1850)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M133.518 185.08L131.049 186.509C130.955 186.562 130.84 186.561 130.747 186.505L128.433 185.104C128.351 185.055 128.352 184.938 128.434 184.891L130.938 183.442C131.019 183.396 131.119 183.397 131.2 183.446L133.52 184.85C133.607 184.903 133.606 185.029 133.518 185.08Z",
    fill: "url(#paint102_linear_7_1850)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M137.542 182.726L135.073 184.155C134.979 184.209 134.863 184.207 134.771 184.151L132.456 182.751C132.375 182.702 132.376 182.584 132.458 182.537L134.962 181.089C135.043 181.043 135.143 181.044 135.223 181.093L137.544 182.497C137.631 182.55 137.63 182.676 137.542 182.726Z",
    fill: "url(#paint103_linear_7_1850)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8499 216.103L87.3808 217.532C87.2873 217.585 87.1714 217.584 87.0788 217.528L84.7644 216.127C84.6833 216.078 84.6843 215.961 84.7662 215.914L87.2696 214.465C87.3507 214.419 87.4511 214.42 87.5314 214.469L89.8519 215.873C89.939 215.926 89.938 216.052 89.8499 216.103Z",
    fill: "url(#paint104_linear_7_1850)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8737 213.749L91.4047 215.178C91.3111 215.232 91.1952 215.23 91.1027 215.174L88.7882 213.773C88.7071 213.724 88.7081 213.607 88.7901 213.56L91.2934 212.112C91.3746 212.065 91.475 212.066 91.5553 212.115L93.8757 213.519C93.9631 213.572 93.9619 213.699 93.8737 213.749Z",
    fill: "url(#paint105_linear_7_1850)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8975 211.396L95.4285 212.825C95.3349 212.878 95.2191 212.877 95.1265 212.821L92.8121 211.42C92.7309 211.371 92.732 211.254 92.8139 211.207L95.3173 209.758C95.3984 209.712 95.4988 209.713 95.5791 209.762L97.8996 211.166C97.9869 211.219 97.9859 211.345 97.8975 211.396Z",
    fill: "url(#paint106_linear_7_1850)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M101.921 209.042L99.4526 210.471C99.359 210.525 99.2431 210.523 99.1505 210.467L96.8361 209.067C96.755 209.017 96.756 208.9 96.8379 208.853L99.3413 207.405C99.4224 207.358 99.5228 207.36 99.6032 207.408L101.924 208.812C102.011 208.865 102.01 208.992 101.921 209.042Z",
    fill: "url(#paint107_linear_7_1850)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M105.945 206.689L103.476 208.118C103.383 208.172 103.267 208.17 103.174 208.114L100.86 206.713C100.779 206.664 100.78 206.547 100.862 206.5L103.365 205.051C103.446 205.005 103.546 205.006 103.627 205.055L105.947 206.459C106.035 206.512 106.034 206.638 105.945 206.689Z",
    fill: "url(#paint108_linear_7_1850)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M109.969 204.336L107.5 205.765C107.407 205.818 107.291 205.817 107.198 205.76L104.884 204.36C104.803 204.311 104.804 204.193 104.886 204.147L107.389 202.698C107.47 202.652 107.571 202.653 107.651 202.702L109.971 204.106C110.058 204.158 110.057 204.285 109.969 204.336Z",
    fill: "url(#paint109_linear_7_1850)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M113.993 201.982L111.524 203.411C111.431 203.465 111.315 203.463 111.222 203.407L108.908 202.007C108.827 201.957 108.828 201.84 108.909 201.793L111.413 200.345C111.494 200.298 111.594 200.3 111.675 200.348L113.995 201.753C114.082 201.805 114.081 201.932 113.993 201.982Z",
    fill: "url(#paint110_linear_7_1850)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M118.017 199.629L115.548 201.058C115.454 201.111 115.339 201.11 115.246 201.054L112.932 199.653C112.85 199.604 112.851 199.487 112.933 199.44L115.437 197.991C115.518 197.945 115.618 197.946 115.699 197.995L118.019 199.399C118.106 199.452 118.105 199.578 118.017 199.629Z",
    fill: "url(#paint111_linear_7_1850)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M122.041 197.275L119.572 198.704C119.478 198.758 119.362 198.756 119.27 198.7L116.955 197.3C116.874 197.251 116.875 197.133 116.957 197.086L119.461 195.638C119.542 195.592 119.642 195.593 119.722 195.642L122.043 197.046C122.13 197.098 122.129 197.225 122.041 197.275Z",
    fill: "url(#paint112_linear_7_1850)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M126.065 194.922L123.596 196.351C123.502 196.405 123.386 196.403 123.294 196.347L120.979 194.946C120.898 194.897 120.899 194.78 120.981 194.733L123.484 193.285C123.566 193.238 123.666 193.239 123.746 193.288L126.067 194.692C126.154 194.745 126.153 194.871 126.065 194.922Z",
    fill: "url(#paint113_linear_7_1850)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M130.089 192.568L127.619 193.997C127.526 194.051 127.41 194.049 127.317 193.993L125.003 192.593C124.922 192.544 124.923 192.426 125.005 192.38L127.508 190.931C127.589 190.885 127.69 190.886 127.77 190.935L130.091 192.339C130.178 192.392 130.177 192.518 130.089 192.568Z",
    fill: "url(#paint114_linear_7_1850)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M134.112 190.215L131.643 191.644C131.55 191.698 131.434 191.696 131.341 191.64L129.027 190.239C128.946 190.19 128.947 190.073 129.029 190.026L131.532 188.578C131.613 188.531 131.714 188.532 131.794 188.581L134.114 189.985C134.202 190.038 134.201 190.165 134.112 190.215Z",
    fill: "url(#paint115_linear_7_1850)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M138.136 187.862L135.667 189.291C135.574 189.344 135.458 189.343 135.365 189.287L133.051 187.886C132.97 187.837 132.971 187.72 133.053 187.673L135.556 186.224C135.637 186.178 135.737 186.179 135.818 186.228L138.138 187.632C138.226 187.685 138.225 187.811 138.136 187.862Z",
    fill: "url(#paint116_linear_7_1850)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M142.16 185.508L139.691 186.937C139.598 186.991 139.482 186.989 139.389 186.933L137.075 185.533C136.994 185.483 136.995 185.366 137.077 185.319L139.58 183.871C139.661 183.824 139.762 183.826 139.842 183.874L142.162 185.278C142.249 185.331 142.248 185.458 142.16 185.508Z",
    fill: "url(#paint117_linear_7_1850)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5293 217.083L91.999 220.314C91.9055 220.367 91.7896 220.366 91.697 220.31L89.3826 218.909C89.3015 218.86 89.3025 218.742 89.3844 218.696L94.949 215.445C95.0301 215.399 95.1305 215.4 95.2109 215.449L97.5313 216.853C97.6187 216.906 97.6177 217.032 97.5293 217.083Z",
    fill: "url(#paint118_linear_7_1850)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4919 216.531L96.0231 217.96C95.9295 218.014 95.8137 218.012 95.7211 217.956L93.4067 216.555C93.3255 216.506 93.3265 216.389 93.4085 216.342L95.9119 214.894C95.993 214.847 96.0934 214.848 96.1737 214.897L98.4941 216.301C98.5813 216.354 98.5803 216.481 98.4919 216.531Z",
    fill: "url(#paint119_linear_7_1850)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M102.516 214.178L100.047 215.607C99.9534 215.66 99.8375 215.659 99.7449 215.603L97.4305 214.202C97.3494 214.153 97.3504 214.036 97.4323 213.989L99.9357 212.54C100.017 212.494 100.117 212.495 100.198 212.544L102.518 213.948C102.605 214.001 102.604 214.127 102.516 214.178Z",
    fill: "url(#paint120_linear_7_1850)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M106.54 211.824L104.071 213.253C103.977 213.307 103.861 213.305 103.769 213.249L101.454 211.849C101.373 211.799 101.374 211.682 101.456 211.635L103.96 210.187C104.041 210.14 104.141 210.142 104.221 210.19L106.542 211.594C106.629 211.647 106.628 211.774 106.54 211.824Z",
    fill: "url(#paint121_linear_7_1850)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M110.563 209.471L108.094 210.9C108.001 210.953 107.885 210.952 107.792 210.896L105.478 209.495C105.397 209.446 105.398 209.329 105.48 209.282L107.983 207.833C108.064 207.787 108.165 207.788 108.245 207.837L110.565 209.241C110.653 209.294 110.652 209.42 110.563 209.471Z",
    fill: "url(#paint122_linear_7_1850)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M114.587 207.117L112.118 208.546C112.025 208.6 111.909 208.598 111.816 208.542L109.502 207.142C109.421 207.093 109.422 206.975 109.504 206.929L112.007 205.48C112.088 205.434 112.189 205.435 112.269 205.484L114.59 206.888C114.677 206.94 114.676 207.067 114.587 207.117Z",
    fill: "url(#paint123_linear_7_1850)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M118.611 204.764L116.143 206.193C116.049 206.247 115.933 206.245 115.841 206.189L113.526 204.788C113.445 204.739 113.446 204.622 113.528 204.575L116.031 203.127C116.112 203.08 116.213 203.081 116.293 203.13L118.614 204.534C118.701 204.587 118.7 204.714 118.611 204.764Z",
    fill: "url(#paint124_linear_7_1850)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M122.635 202.411L120.166 203.84C120.073 203.893 119.957 203.892 119.864 203.836L117.55 202.435C117.469 202.386 117.47 202.269 117.552 202.222L120.055 200.773C120.136 200.727 120.236 200.728 120.317 200.777L122.637 202.181C122.725 202.234 122.724 202.36 122.635 202.411Z",
    fill: "url(#paint125_linear_7_1850)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M126.659 200.057L124.19 201.486C124.096 201.54 123.981 201.538 123.888 201.482L121.574 200.082C121.492 200.032 121.493 199.915 121.575 199.868L124.079 198.42C124.16 198.373 124.26 198.375 124.341 198.423L126.661 199.828C126.748 199.88 126.747 200.007 126.659 200.057Z",
    fill: "url(#paint126_linear_7_1850)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M130.683 197.704L128.214 199.133C128.12 199.186 128.004 199.185 127.912 199.129L125.597 197.728C125.516 197.679 125.517 197.562 125.599 197.515L128.103 196.066C128.184 196.02 128.284 196.021 128.364 196.07L130.685 197.474C130.772 197.527 130.771 197.653 130.683 197.704Z",
    fill: "url(#paint127_linear_7_1850)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M134.707 195.35L132.238 196.779C132.144 196.833 132.028 196.831 131.936 196.775L129.621 195.375C129.54 195.325 129.541 195.208 129.623 195.161L132.126 193.713C132.208 193.666 132.308 193.668 132.388 193.716L134.709 195.12C134.796 195.173 134.795 195.3 134.707 195.35Z",
    fill: "url(#paint128_linear_7_1850)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M138.731 192.997L136.262 194.426C136.168 194.48 136.052 194.478 135.96 194.422L133.645 193.021C133.564 192.972 133.565 192.855 133.647 192.808L136.151 191.359C136.232 191.313 136.332 191.314 136.412 191.363L138.733 192.767C138.82 192.82 138.819 192.947 138.731 192.997Z",
    fill: "url(#paint129_linear_7_1850)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M142.755 190.644L140.286 192.073C140.192 192.126 140.076 192.125 139.984 192.069L137.669 190.668C137.588 190.619 137.589 190.501 137.671 190.455L140.174 189.006C140.255 188.96 140.356 188.961 140.436 189.01L142.757 190.414C142.844 190.467 142.843 190.593 142.755 190.644Z",
    fill: "url(#paint130_linear_7_1850)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M146.778 188.29L141.188 191.562C141.095 191.616 140.979 191.614 140.886 191.558L138.572 190.158C138.49 190.109 138.491 189.991 138.573 189.945L144.198 186.653C144.279 186.606 144.38 186.608 144.46 186.656L146.78 188.06C146.868 188.113 146.867 188.24 146.778 188.29Z",
    fill: "url(#paint131_linear_7_1850)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0864 221.667L96.6175 223.095C96.524 223.149 96.4081 223.147 96.3155 223.091L94.0011 221.691C93.92 221.642 93.921 221.524 94.0029 221.478L96.5063 220.029C96.5874 219.983 96.6878 219.984 96.7681 220.032L99.0886 221.437C99.1758 221.489 99.1748 221.616 99.0864 221.667Z",
    fill: "url(#paint132_linear_7_1850)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M103.11 219.313L100.641 220.742C100.548 220.795 100.432 220.794 100.339 220.738L98.025 219.337C97.9438 219.288 97.9448 219.171 98.0268 219.124L100.53 217.675C100.611 217.629 100.712 217.63 100.792 217.679L103.112 219.083C103.2 219.136 103.199 219.263 103.11 219.313Z",
    fill: "url(#paint133_linear_7_1850)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M107.134 216.96L104.665 218.388C104.571 218.442 104.456 218.44 104.363 218.384L102.049 216.984C101.967 216.935 101.968 216.817 102.05 216.771L104.554 215.322C104.635 215.276 104.735 215.277 104.816 215.325L107.136 216.73C107.223 216.783 107.222 216.909 107.134 216.96Z",
    fill: "url(#paint134_linear_7_1850)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M111.158 214.606L108.689 216.035C108.595 216.089 108.48 216.087 108.387 216.031L106.073 214.63C105.992 214.581 105.993 214.464 106.074 214.417L108.578 212.969C108.659 212.922 108.759 212.923 108.84 212.972L111.16 214.376C111.247 214.429 111.246 214.556 111.158 214.606Z",
    fill: "url(#paint135_linear_7_1850)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M115.182 212.253L112.713 213.682C112.619 213.735 112.503 213.734 112.411 213.678L110.096 212.277C110.015 212.228 110.016 212.111 110.098 212.064L112.602 210.615C112.683 210.569 112.783 210.57 112.864 210.619L115.184 212.023C115.271 212.076 115.27 212.202 115.182 212.253Z",
    fill: "url(#paint136_linear_7_1850)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M119.206 209.899L116.737 211.328C116.643 211.382 116.527 211.38 116.435 211.324L114.12 209.924C114.039 209.874 114.04 209.757 114.122 209.71L116.626 208.262C116.707 208.215 116.807 208.217 116.887 208.265L119.208 209.67C119.295 209.722 119.294 209.849 119.206 209.899Z",
    fill: "url(#paint137_linear_7_1850)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M123.23 207.546L120.761 208.975C120.667 209.029 120.551 209.027 120.459 208.971L118.144 207.57C118.063 207.521 118.064 207.404 118.146 207.357L120.649 205.908C120.73 205.862 120.831 205.863 120.911 205.912L123.232 207.316C123.319 207.369 123.318 207.495 123.23 207.546Z",
    fill: "url(#paint138_linear_7_1850)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M127.254 205.193L124.784 206.622C124.691 206.675 124.575 206.674 124.482 206.618L122.168 205.217C122.087 205.168 122.088 205.05 122.17 205.004L124.673 203.555C124.754 203.509 124.855 203.51 124.935 203.559L127.256 204.963C127.343 205.016 127.342 205.142 127.254 205.193Z",
    fill: "url(#paint139_linear_7_1850)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M131.277 202.839L128.808 204.268C128.715 204.322 128.599 204.32 128.506 204.264L126.192 202.864C126.111 202.815 126.112 202.697 126.194 202.65L128.697 201.202C128.778 201.155 128.879 201.157 128.959 201.205L131.279 202.609C131.367 202.662 131.366 202.789 131.277 202.839Z",
    fill: "url(#paint140_linear_7_1850)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M135.301 200.486L132.832 201.915C132.739 201.968 132.623 201.967 132.53 201.911L130.216 200.51C130.135 200.461 130.136 200.344 130.218 200.297L132.721 198.848C132.802 198.802 132.903 198.803 132.983 198.852L135.303 200.256C135.391 200.309 135.39 200.435 135.301 200.486Z",
    fill: "url(#paint141_linear_7_1850)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M139.325 198.132L136.856 199.561C136.762 199.615 136.647 199.613 136.554 199.557L134.24 198.157C134.158 198.107 134.159 197.99 134.241 197.943L136.745 196.495C136.826 196.448 136.926 196.45 137.007 196.498L139.327 197.902C139.414 197.955 139.413 198.082 139.325 198.132Z",
    fill: "url(#paint142_linear_7_1850)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M143.349 195.779L140.88 197.208C140.786 197.261 140.671 197.26 140.578 197.204L138.264 195.803C138.182 195.754 138.183 195.637 138.265 195.59L140.769 194.141C140.85 194.095 140.95 194.096 141.031 194.145L143.351 195.549C143.438 195.602 143.437 195.729 143.349 195.779Z",
    fill: "url(#paint143_linear_7_1850)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M147.373 193.426L144.904 194.854C144.81 194.908 144.694 194.906 144.602 194.85L142.287 193.45C142.206 193.401 142.207 193.284 142.289 193.237L144.793 191.788C144.874 191.742 144.974 191.743 145.054 191.791L147.375 193.196C147.462 193.249 147.461 193.375 147.373 193.426Z",
    fill: "url(#paint144_linear_7_1850)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M151.397 191.072L148.928 192.501C148.834 192.555 148.718 192.553 148.626 192.497L146.311 191.096C146.23 191.047 146.231 190.93 146.313 190.883L148.816 189.435C148.898 189.388 148.998 189.389 149.078 189.438L151.399 190.842C151.486 190.895 151.485 191.022 151.397 191.072Z",
    fill: "url(#paint145_linear_7_1850)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M103.705 224.448L101.236 225.877C101.142 225.931 101.026 225.929 100.934 225.873L98.6191 224.473C98.538 224.424 98.539 224.306 98.6209 224.259L101.124 222.811C101.205 222.765 101.306 222.766 101.386 222.814L103.707 224.219C103.794 224.271 103.793 224.398 103.705 224.448Z",
    fill: "url(#paint146_linear_7_1850)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M107.728 222.095L105.259 223.524C105.166 223.577 105.05 223.576 104.957 223.52L102.643 222.119C102.562 222.07 102.563 221.953 102.645 221.906L105.148 220.457C105.229 220.411 105.33 220.412 105.41 220.461L107.73 221.865C107.818 221.918 107.817 222.044 107.728 222.095Z",
    fill: "url(#paint147_linear_7_1850)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M111.752 219.741L109.283 221.17C109.19 221.224 109.074 221.222 108.981 221.166L106.667 219.766C106.586 219.717 106.587 219.599 106.669 219.552L109.172 218.104C109.253 218.058 109.354 218.059 109.434 218.107L111.754 219.512C111.842 219.565 111.841 219.691 111.752 219.741Z",
    fill: "url(#paint148_linear_7_1850)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M115.776 217.388L113.307 218.817C113.214 218.871 113.098 218.869 113.005 218.813L110.691 217.412C110.61 217.363 110.611 217.246 110.693 217.199L113.196 215.751C113.277 215.704 113.378 215.706 113.458 215.754L115.778 217.158C115.865 217.211 115.864 217.337 115.776 217.388Z",
    fill: "url(#paint149_linear_7_1850)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M119.8 215.035L117.331 216.464C117.238 216.517 117.122 216.516 117.029 216.46L114.715 215.059C114.634 215.01 114.635 214.892 114.717 214.846L117.22 213.397C117.301 213.351 117.401 213.352 117.482 213.401L119.802 214.805C119.89 214.858 119.888 214.984 119.8 215.035Z",
    fill: "url(#paint150_linear_7_1850)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M123.824 212.681L121.355 214.11C121.261 214.164 121.146 214.162 121.053 214.106L118.739 212.706C118.657 212.656 118.658 212.539 118.74 212.492L121.244 211.044C121.325 210.997 121.425 210.999 121.506 211.047L123.826 212.451C123.913 212.504 123.912 212.631 123.824 212.681Z",
    fill: "url(#paint151_linear_7_1850)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M127.848 210.328L125.379 211.757C125.285 211.81 125.17 211.809 125.077 211.753L122.763 210.352C122.681 210.303 122.682 210.186 122.764 210.139L125.268 208.69C125.349 208.644 125.449 208.645 125.53 208.694L127.85 210.098C127.937 210.151 127.936 210.277 127.848 210.328Z",
    fill: "url(#paint152_linear_7_1850)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M131.872 207.975L129.403 209.403C129.309 209.457 129.193 209.455 129.101 209.399L126.786 207.999C126.705 207.95 126.706 207.832 126.788 207.786L129.291 206.337C129.373 206.291 129.473 206.292 129.553 206.34L131.874 207.745C131.961 207.797 131.96 207.924 131.872 207.975Z",
    fill: "url(#paint153_linear_7_1850)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M135.896 205.621L133.427 207.05C133.333 207.104 133.217 207.102 133.125 207.046L130.81 205.645C130.729 205.596 130.73 205.479 130.812 205.432L133.315 203.984C133.396 203.937 133.497 203.938 133.577 203.987L135.898 205.391C135.985 205.444 135.984 205.571 135.896 205.621Z",
    fill: "url(#paint154_linear_7_1850)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M139.919 203.268L137.45 204.697C137.357 204.75 137.241 204.749 137.148 204.693L134.834 203.292C134.753 203.243 134.754 203.126 134.836 203.079L137.339 201.63C137.42 201.584 137.521 201.585 137.601 201.634L139.921 203.038C140.009 203.091 140.008 203.217 139.919 203.268Z",
    fill: "url(#paint155_linear_7_1850)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M143.943 200.914L141.474 202.343C141.381 202.397 141.265 202.395 141.172 202.339L138.858 200.938C138.777 200.889 138.778 200.772 138.86 200.725L141.363 199.277C141.444 199.23 141.545 199.231 141.625 199.28L143.945 200.684C144.033 200.737 144.032 200.864 143.943 200.914Z",
    fill: "url(#paint156_linear_7_1850)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M147.967 198.561L145.498 199.99C145.405 200.043 145.289 200.042 145.196 199.986L142.882 198.585C142.801 198.536 142.802 198.419 142.884 198.372L145.387 196.923C145.468 196.877 145.569 196.878 145.649 196.927L147.97 198.331C148.057 198.384 148.055 198.51 147.967 198.561Z",
    fill: "url(#paint157_linear_7_1850)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M151.991 196.207L149.522 197.636C149.429 197.69 149.313 197.688 149.22 197.632L146.906 196.232C146.825 196.183 146.826 196.065 146.908 196.018L149.411 194.57C149.492 194.523 149.593 194.525 149.673 194.573L151.993 195.977C152.081 196.031 152.08 196.157 151.991 196.207Z",
    fill: "url(#paint158_linear_7_1850)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M156.015 193.854L153.546 195.283C153.452 195.337 153.337 195.335 153.244 195.279L150.93 193.878C150.848 193.829 150.849 193.712 150.931 193.665L153.435 192.217C153.516 192.17 153.616 192.171 153.697 192.22L156.017 193.624C156.104 193.677 156.103 193.803 156.015 193.854Z",
    fill: "url(#paint159_linear_7_1850)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M108.323 227.23L105.854 228.659C105.76 228.713 105.644 228.711 105.552 228.655L103.237 227.255C103.156 227.205 103.157 227.088 103.239 227.041L105.743 225.593C105.824 225.546 105.924 225.548 106.004 225.596L108.325 227C108.412 227.053 108.411 227.18 108.323 227.23Z",
    fill: "url(#paint160_linear_7_1850)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M112.347 224.877L109.878 226.306C109.784 226.359 109.668 226.358 109.576 226.302L107.261 224.901C107.18 224.852 107.181 224.735 107.263 224.688L109.767 223.239C109.848 223.193 109.948 223.194 110.028 223.243L112.349 224.647C112.436 224.7 112.435 224.826 112.347 224.877Z",
    fill: "url(#paint161_linear_7_1850)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M116.371 222.523L113.902 223.952C113.808 224.006 113.692 224.004 113.6 223.948L111.285 222.548C111.204 222.498 111.205 222.381 111.287 222.334L113.79 220.886C113.872 220.839 113.972 220.841 114.052 220.889L116.373 222.293C116.46 222.346 116.459 222.473 116.371 222.523Z",
    fill: "url(#paint162_linear_7_1850)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M120.395 220.17L117.926 221.599C117.832 221.652 117.716 221.651 117.624 221.595L115.309 220.194C115.228 220.145 115.229 220.028 115.311 219.981L117.814 218.532C117.895 218.486 117.996 218.487 118.076 218.536L120.397 219.94C120.484 219.993 120.483 220.119 120.395 220.17Z",
    fill: "url(#paint163_linear_7_1850)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M139.137 209.137L121.95 219.245C121.856 219.299 121.74 219.297 121.648 219.241L119.333 217.841C119.252 217.792 119.253 217.674 119.335 217.628L136.557 207.499C136.638 207.453 136.739 207.454 136.819 207.503L139.14 208.907C139.227 208.96 139.225 209.086 139.137 209.137Z",
    fill: "url(#paint164_linear_7_1850)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M128.442 215.463L125.973 216.892C125.88 216.946 125.764 216.944 125.671 216.888L123.357 215.488C123.276 215.439 123.277 215.321 123.359 215.274L125.862 213.826C125.943 213.779 126.043 213.78 126.124 213.829L128.444 215.233C128.532 215.286 128.531 215.413 128.442 215.463Z",
    fill: "url(#paint165_linear_7_1850)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M132.466 213.11L129.997 214.539C129.903 214.592 129.788 214.591 129.695 214.535L127.381 213.134C127.3 213.085 127.301 212.968 127.382 212.921L129.886 211.472C129.967 211.426 130.067 211.427 130.148 211.476L132.468 212.88C132.555 212.933 132.554 213.059 132.466 213.11Z",
    fill: "url(#paint166_linear_7_1850)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M136.49 210.756L134.021 212.185C133.927 212.239 133.811 212.237 133.719 212.181L131.404 210.781C131.323 210.732 131.324 210.614 131.406 210.567L133.91 209.119C133.991 209.073 134.091 209.074 134.172 209.122L136.492 210.527C136.579 210.579 136.578 210.706 136.49 210.756Z",
    fill: "url(#paint167_linear_7_1850)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M140.514 208.403L138.045 209.832C137.951 209.886 137.835 209.884 137.743 209.828L135.428 208.427C135.347 208.378 135.348 208.261 135.43 208.214L137.933 206.766C138.015 206.719 138.115 206.72 138.195 206.769L140.516 208.173C140.603 208.226 140.602 208.352 140.514 208.403Z",
    fill: "url(#paint168_linear_7_1850)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M144.538 206.049L142.069 207.478C141.975 207.532 141.86 207.53 141.767 207.474L139.453 206.074C139.371 206.025 139.372 205.907 139.454 205.861L141.958 204.412C142.039 204.366 142.139 204.367 142.22 204.415L144.54 205.82C144.627 205.873 144.626 205.999 144.538 206.049Z",
    fill: "url(#paint169_linear_7_1850)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M148.562 203.696L146.093 205.125C145.999 205.179 145.883 205.177 145.791 205.121L143.476 203.72C143.395 203.671 143.396 203.554 143.478 203.507L145.981 202.059C146.063 202.012 146.163 202.013 146.243 202.062L148.564 203.466C148.651 203.519 148.65 203.646 148.562 203.696Z",
    fill: "url(#paint170_linear_7_1850)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M152.586 201.343L150.117 202.772C150.023 202.825 149.907 202.824 149.814 202.768L147.5 201.367C147.419 201.318 147.42 201.2 147.502 201.154L150.005 199.705C150.086 199.659 150.187 199.66 150.267 199.709L152.588 201.113C152.675 201.166 152.674 201.292 152.586 201.343Z",
    fill: "url(#paint171_linear_7_1850)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M156.609 198.989L154.14 200.418C154.047 200.472 153.931 200.47 153.838 200.414L151.524 199.014C151.443 198.964 151.444 198.847 151.526 198.8L154.029 197.352C154.11 197.305 154.211 197.307 154.291 197.355L156.611 198.759C156.699 198.812 156.698 198.939 156.609 198.989Z",
    fill: "url(#paint172_linear_7_1850)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M160.633 196.636L158.164 198.065C158.071 198.118 157.955 198.117 157.862 198.061L155.548 196.66C155.467 196.611 155.468 196.494 155.55 196.447L158.053 194.998C158.134 194.952 158.235 194.953 158.315 195.002L160.635 196.406C160.723 196.459 160.722 196.585 160.633 196.636Z",
    fill: "url(#paint173_linear_7_1850)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M188.95 124.058V191.177C188.95 193.135 187.907 194.94 186.215 195.923L98.0697 247.009C97.7751 247.175 98.3502 249.042 98.048 249.095C96.2721 249.473 93.5808 246.381 93.5808 244.424V177.993C93.5808 176.776 93.8527 175.597 94.3667 174.547L98.0695 176.821C98.7496 175.514 99.8 174.403 101.13 173.633L187.378 123.643C187.847 123.371 188.345 123.22 188.837 123.189C188.912 123.461 188.95 123.756 188.95 124.058Z",
    fill: "url(#paint174_linear_7_1850)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M192.51 126.597V193.724C192.51 195.681 191.467 197.487 189.774 198.47L101.629 249.548C99.7551 250.636 97.4274 249.419 97.1706 247.341C97.1555 247.22 97.1479 247.092 97.1479 246.963V180.54C97.1479 179.224 97.4728 177.947 98.0697 176.821C98.7498 175.514 99.8002 174.403 101.13 173.632L187.378 123.643C187.847 123.37 188.346 123.219 188.837 123.189C189.373 123.144 189.895 123.234 190.378 123.431L190.401 123.439C190.923 123.657 191.391 123.998 191.746 124.443L191.754 124.451C192.222 125.026 192.51 125.759 192.51 126.597Z",
    fill: "url(#paint175_linear_7_1850)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M190.378 123.431C189.895 123.235 189.373 123.144 188.837 123.189C188.345 123.22 187.847 123.37 187.378 123.643L101.13 173.632C99.8002 174.403 98.7498 175.514 98.0697 176.821L94.367 174.547C95.0471 173.119 96.1503 171.902 97.5635 171.086L102.861 168.017L183.819 121.096C185.172 120.31 186.736 120.575 187.771 121.481L187.794 121.496L190.378 123.431Z",
    fill: "url(#paint176_linear_7_1850)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0417,
    d: "M216.715 395.904C253.039 395.904 282.484 379.407 282.484 359.058C282.484 338.709 253.039 322.212 216.715 322.212C180.392 322.212 150.946 338.709 150.946 359.058C150.946 379.407 180.392 395.904 216.715 395.904Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0833,
    d: "M216.715 395.181C252.326 395.181 281.195 379.008 281.195 359.058C281.195 339.108 252.326 322.935 216.715 322.935C181.104 322.935 152.236 339.108 152.236 359.058C152.236 379.008 181.104 395.181 216.715 395.181Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M216.715 394.459C251.614 394.459 279.905 378.609 279.905 359.058C279.905 339.507 251.614 323.657 216.715 323.657C181.817 323.657 153.526 339.507 153.526 359.058C153.526 378.609 181.817 394.459 216.715 394.459Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1667,
    d: "M216.715 393.736C250.901 393.736 278.615 378.21 278.615 359.058C278.615 339.906 250.901 324.38 216.715 324.38C182.529 324.38 154.816 339.906 154.816 359.058C154.816 378.21 182.529 393.736 216.715 393.736Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2083,
    d: "M216.715 393.013C250.189 393.013 277.325 377.811 277.325 359.058C277.325 340.305 250.189 325.103 216.715 325.103C183.242 325.103 156.106 340.305 156.106 359.058C156.106 377.811 183.242 393.013 216.715 393.013Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M216.715 392.291C249.477 392.291 276.035 377.412 276.035 359.058C276.035 340.704 249.477 325.825 216.715 325.825C183.954 325.825 157.396 340.704 157.396 359.058C157.396 377.412 183.954 392.291 216.715 392.291Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2917,
    d: "M216.715 391.568C248.764 391.568 274.745 377.013 274.745 359.058C274.745 341.103 248.764 326.548 216.715 326.548C184.666 326.548 158.686 341.103 158.686 359.058C158.686 377.013 184.666 391.568 216.715 391.568Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M216.715 390.846C248.052 390.846 273.455 376.614 273.455 359.058C273.455 341.502 248.052 327.27 216.715 327.27C185.379 327.27 159.976 341.502 159.976 359.058C159.976 376.614 185.379 390.846 216.715 390.846Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M216.715 390.123C247.34 390.123 272.166 376.215 272.166 359.058C272.166 341.901 247.34 327.993 216.715 327.993C186.091 327.993 161.265 341.901 161.265 359.058C161.265 376.215 186.091 390.123 216.715 390.123Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4167,
    d: "M216.715 389.4C246.627 389.4 270.876 375.816 270.876 359.058C270.876 342.3 246.627 328.716 216.715 328.716C186.804 328.716 162.555 342.3 162.555 359.058C162.555 375.816 186.804 389.4 216.715 389.4Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4583,
    d: "M216.715 388.678C245.915 388.678 269.586 375.416 269.586 359.058C269.586 342.7 245.915 329.438 216.715 329.438C187.516 329.438 163.845 342.7 163.845 359.058C163.845 375.416 187.516 388.678 216.715 388.678Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M216.715 387.955C245.203 387.955 268.296 375.017 268.296 359.058C268.296 343.099 245.203 330.161 216.715 330.161C188.228 330.161 165.135 343.099 165.135 359.058C165.135 375.017 188.228 387.955 216.715 387.955Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5417,
    d: "M216.715 387.232C244.49 387.232 267.006 374.618 267.006 359.058C267.006 343.498 244.49 330.884 216.715 330.884C188.941 330.884 166.425 343.498 166.425 359.058C166.425 374.618 188.941 387.232 216.715 387.232Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5833,
    d: "M216.715 386.51C243.778 386.51 265.716 374.219 265.716 359.058C265.716 343.897 243.778 331.606 216.715 331.606C189.653 331.606 167.715 343.897 167.715 359.058C167.715 374.219 189.653 386.51 216.715 386.51Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M216.715 385.787C243.065 385.787 264.426 373.82 264.426 359.058C264.426 344.296 243.065 332.329 216.715 332.329C190.365 332.329 169.005 344.296 169.005 359.058C169.005 373.82 190.365 385.787 216.715 385.787Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M216.715 385.064C242.353 385.064 263.136 373.421 263.136 359.058C263.136 344.695 242.353 333.051 216.715 333.051C191.078 333.051 170.294 344.695 170.294 359.058C170.294 373.421 191.078 385.064 216.715 385.064Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7083,
    d: "M216.715 384.342C241.641 384.342 261.846 373.022 261.846 359.058C261.846 345.094 241.641 333.774 216.715 333.774C191.79 333.774 171.584 345.094 171.584 359.058C171.584 373.022 191.79 384.342 216.715 384.342Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M216.715 383.619C240.928 383.619 260.556 372.623 260.556 359.058C260.556 345.493 240.928 334.497 216.715 334.497C192.503 334.497 172.874 345.493 172.874 359.058C172.874 372.623 192.503 383.619 216.715 383.619Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7917,
    d: "M216.715 382.896C240.216 382.896 259.267 372.224 259.267 359.058C259.267 345.892 240.216 335.22 216.715 335.22C193.215 335.22 174.164 345.892 174.164 359.058C174.164 372.224 193.215 382.896 216.715 382.896Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8333,
    d: "M216.715 382.174C239.503 382.174 257.977 371.824 257.977 359.058C257.977 346.292 239.503 335.942 216.715 335.942C193.927 335.942 175.454 346.292 175.454 359.058C175.454 371.824 193.927 382.174 216.715 382.174Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M216.715 381.451C238.791 381.451 256.687 371.425 256.687 359.058C256.687 346.691 238.791 336.665 216.715 336.665C194.64 336.665 176.744 346.691 176.744 359.058C176.744 371.425 194.64 381.451 216.715 381.451Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9167,
    d: "M216.715 380.729C238.079 380.729 255.397 371.026 255.397 359.058C255.397 347.09 238.079 337.387 216.715 337.387C195.352 337.387 178.034 347.09 178.034 359.058C178.034 371.026 195.352 380.729 216.715 380.729Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9583,
    d: "M216.715 380.006C237.366 380.006 254.107 370.627 254.107 359.058C254.107 347.489 237.366 338.11 216.715 338.11C196.065 338.11 179.324 347.489 179.324 359.058C179.324 370.627 196.065 380.006 216.715 380.006Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.715 379.283C236.654 379.283 252.817 370.228 252.817 359.058C252.817 347.888 236.654 338.833 216.715 338.833C196.777 338.833 180.614 347.888 180.614 359.058C180.614 370.228 196.777 379.283 216.715 379.283Z",
    fill: "#190C00"
  }))), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M150.046 268.598V319.253L219.025 359.058V308.874L150.046 268.598Z",
    fill: "#525575"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M288.003 268.598V318.782L219.025 359.058V308.874L288.003 268.598Z",
    fill: "#525575"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M219.025 308.031L288.003 267.755L219.025 227.479L150.046 267.755L219.025 308.031Z",
    fill: "url(#paint177_linear_7_1850)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M150.046 267.755V318.41L219.025 358.215V308.031L150.046 267.755Z",
    fill: "url(#paint178_linear_7_1850)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M288.003 267.755V317.939L219.025 358.215V308.031L288.003 267.755Z",
    fill: "url(#paint179_linear_7_1850)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M221.439 290.727L253.701 271.889C256.866 270.041 256.866 265.468 253.701 263.62L221.439 244.783C219.947 243.912 218.102 243.912 216.611 244.783L184.349 263.62C181.184 265.468 181.184 270.041 184.349 271.889L216.611 290.727C218.102 291.598 219.947 291.598 221.439 290.727Z",
    fill: "url(#paint180_linear_7_1850)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M219.025 307.495L150.505 267.487L150.046 267.755L219.025 308.031L288.003 267.755L287.544 267.487L219.025 307.495Z",
    fill: "url(#paint181_linear_7_1850)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M150.046 209.319V259.974L219.025 299.779V249.595L150.046 209.319Z",
    fill: "#525575"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M288.003 209.319V259.503L219.025 299.779V249.595L288.003 209.319Z",
    fill: "#525575"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M219.025 248.752L288.003 208.476L219.025 168.2L150.046 208.476L219.025 248.752Z",
    fill: "url(#paint182_linear_7_1850)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M150.046 208.476V259.131L219.025 298.936V248.752L150.046 208.476Z",
    fill: "url(#paint183_linear_7_1850)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M288.003 208.476V258.66L219.025 298.936V248.752L288.003 208.476Z",
    fill: "url(#paint184_linear_7_1850)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M221.439 231.448L253.701 212.61C256.866 210.762 256.866 206.189 253.701 204.341L221.439 185.504C219.947 184.633 218.102 184.633 216.611 185.504L184.349 204.341C181.184 206.189 181.184 210.762 184.349 212.61L216.611 231.448C218.102 232.319 219.947 232.319 221.439 231.448Z",
    fill: "url(#paint185_linear_7_1850)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M219.025 248.216L150.505 208.208L150.046 208.476L219.025 248.752L288.003 208.476L287.544 208.208L219.025 248.216Z",
    fill: "url(#paint186_linear_7_1850)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M331.532 414.014V418.027C330.081 418.155 328.6 417.838 327.308 417.059L273.101 384.36C271.454 383.363 270.725 377.923 271.957 376.631C272.131 376.812 272.867 380.196 273.101 380.34L327.308 413.046C328.6 413.825 330.081 414.15 331.532 414.014Z",
    fill: "url(#paint187_linear_7_1850)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M417.931 368.559L334.388 417.12C333.497 417.641 332.521 417.936 331.532 418.027V414.014C330.081 414.15 328.599 413.825 327.307 413.047L273.101 380.34C272.867 380.196 272.663 380.03 272.489 379.849C272.678 379.652 272.897 379.478 273.146 379.335L320.068 352.062L357.497 330.305C359.394 329.202 361.744 329.217 363.626 330.358L415.949 360.531C416.267 360.727 419.88 360.365 419.221 361.745C420.415 363.181 419.677 367.546 417.931 368.559Z",
    fill: "url(#paint188_linear_7_1850)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M358.223 250.959V318.078C358.223 320.035 357.18 321.841 355.487 322.824L267.343 373.909C267.048 374.075 267.623 375.942 267.321 375.995C265.545 376.373 262.854 373.282 262.854 371.324V304.893C262.854 303.677 263.126 302.498 263.64 301.447L267.343 303.722C268.023 302.415 269.073 301.304 270.403 300.533L356.651 250.543C357.12 250.271 357.618 250.12 358.11 250.09C358.185 250.362 358.223 250.657 358.223 250.959Z",
    fill: "url(#paint189_linear_7_1850)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M361.782 253.498V320.624C361.782 322.582 360.74 324.388 359.047 325.37L270.902 376.448C269.028 377.536 266.7 376.32 266.443 374.241C266.428 374.12 266.421 373.992 266.421 373.863V307.44C266.421 306.125 266.746 304.848 267.343 303.722C268.023 302.414 269.073 301.303 270.403 300.533L356.651 250.543C357.12 250.271 357.618 250.12 358.11 250.09C358.646 250.044 359.168 250.135 359.651 250.331L359.674 250.339C360.195 250.558 360.664 250.898 361.019 251.344L361.027 251.352C361.495 251.926 361.782 252.659 361.782 253.498Z",
    fill: "#525575"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M269.634 307.44C269.634 306.667 269.824 305.902 270.181 305.226C270.6 304.422 271.23 303.767 272.015 303.312L358.263 253.324L358.299 253.321L358.378 253.292L358.499 253.341L358.552 253.404C358.562 253.421 358.569 253.447 358.569 253.498V320.625C358.569 321.432 358.134 322.185 357.434 322.591L269.632 373.47L269.634 307.44Z",
    fill: "url(#paint190_linear_7_1850)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M359.651 250.332C359.168 250.135 358.646 250.044 358.11 250.09C357.618 250.12 357.12 250.271 356.651 250.543L270.403 300.533C269.073 301.304 268.023 302.414 267.343 303.722L263.64 301.447C264.32 300.019 265.423 298.802 266.836 297.986L272.134 294.918L353.092 247.997C354.445 247.211 356.009 247.475 357.044 248.382L357.067 248.397L359.651 250.332Z",
    fill: "url(#paint191_linear_7_1850)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M418.77 363.835C418.551 364.107 418.263 364.349 417.931 364.546L334.388 413.1C333.497 413.613 332.521 413.923 331.532 414.014C330.081 414.15 328.599 413.825 327.307 413.046L273.101 380.34C272.867 380.196 272.663 380.03 272.489 379.849C271.242 378.541 271.461 376.297 273.146 375.322L313.161 352.061L357.497 326.292C359.394 325.189 361.744 325.204 363.626 326.337L417.976 359.127C419.692 360.163 419.956 362.422 418.77 363.835Z",
    fill: "url(#paint192_linear_7_1850)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M389.146 352.611L320.449 392.678C319.301 393.346 317.879 393.334 316.742 392.648L288.335 375.511C287.339 374.91 287.351 373.462 288.356 372.878L357.476 332.565C358.471 331.986 359.703 331.996 360.689 332.591L389.17 349.773C390.243 350.42 390.23 351.981 389.146 352.611Z",
    fill: "#525575"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M304.945 369.672L302.625 368.268C302.544 368.219 302.444 368.218 302.363 368.264L299.859 369.713C299.778 369.759 299.777 369.877 299.858 369.926L302.172 371.327C302.265 371.383 302.381 371.384 302.474 371.331L304.943 369.902C305.032 369.851 305.033 369.725 304.945 369.672Z",
    fill: "#3D415B"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M306.196 368.973C306.289 369.029 306.405 369.031 306.498 368.977L308.967 367.548C309.056 367.497 309.057 367.371 308.969 367.318L306.649 365.914C306.568 365.865 306.468 365.864 306.387 365.911L303.883 367.359C303.801 367.406 303.801 367.523 303.882 367.572L306.196 368.973Z",
    fill: "#3D415B"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M310.22 366.62C310.313 366.676 310.428 366.677 310.522 366.624L312.991 365.195C313.079 365.144 313.08 365.018 312.993 364.965L310.672 363.561C310.592 363.512 310.492 363.511 310.41 363.557L307.907 365.006C307.825 365.053 307.824 365.17 307.905 365.219L310.22 366.62Z",
    fill: "#3D415B"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M314.244 364.266C314.336 364.322 314.452 364.324 314.546 364.27L317.015 362.841C317.103 362.79 317.104 362.664 317.017 362.611L314.696 361.207C314.616 361.158 314.516 361.157 314.434 361.204L311.931 362.652C311.849 362.699 311.848 362.816 311.929 362.865L314.244 364.266Z",
    fill: "#3D415B"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M318.268 361.913C318.36 361.969 318.476 361.97 318.57 361.917L321.039 360.488C321.127 360.438 321.128 360.311 321.041 360.258L318.72 358.854C318.64 358.805 318.539 358.804 318.458 358.851L315.955 360.299C315.873 360.346 315.872 360.463 315.953 360.513L318.268 361.913Z",
    fill: "#3D415B"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M322.292 359.559C322.384 359.615 322.5 359.617 322.594 359.563L325.063 358.135C325.151 358.084 325.152 357.958 325.065 357.905L322.744 356.5C322.664 356.452 322.563 356.451 322.482 356.497L319.979 357.946C319.897 357.993 319.896 358.11 319.977 358.159L322.292 359.559Z",
    fill: "#3D415B"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M326.316 357.206C326.408 357.262 326.524 357.264 326.618 357.21L329.086 355.781C329.175 355.731 329.176 355.604 329.088 355.551L326.768 354.147C326.687 354.099 326.587 354.097 326.506 354.144L324.003 355.592C323.921 355.639 323.92 355.757 324.001 355.806L326.316 357.206Z",
    fill: "#3D415B"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M330.339 354.852C330.432 354.908 330.548 354.91 330.641 354.856L333.11 353.428C333.199 353.377 333.2 353.251 333.112 353.198L330.792 351.793C330.711 351.745 330.611 351.744 330.53 351.79L328.026 353.239C327.944 353.286 327.943 353.403 328.025 353.452L330.339 354.852Z",
    fill: "#3D415B"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M334.363 352.499C334.456 352.555 334.572 352.557 334.665 352.503L337.134 351.074C337.222 351.024 337.223 350.897 337.136 350.844L334.815 349.44C334.735 349.392 334.635 349.39 334.554 349.437L332.05 350.885C331.968 350.932 331.967 351.05 332.049 351.099L334.363 352.499Z",
    fill: "#3D415B"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M338.387 350.146C338.48 350.202 338.595 350.203 338.689 350.15L341.158 348.721C341.246 348.67 341.248 348.544 341.16 348.491L338.839 347.087C338.759 347.038 338.659 347.037 338.578 347.083L336.074 348.532C335.992 348.579 335.991 348.696 336.073 348.745L338.387 350.146Z",
    fill: "#3D415B"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M342.411 347.792C342.504 347.848 342.62 347.85 342.713 347.796L345.182 346.367C345.27 346.317 345.271 346.191 345.184 346.137L342.863 344.733C342.783 344.685 342.683 344.683 342.602 344.73L340.098 346.178C340.016 346.225 340.015 346.343 340.096 346.392L342.411 347.792Z",
    fill: "#3D415B"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M346.435 345.439C346.528 345.495 346.643 345.497 346.737 345.443L349.206 344.014C349.294 343.963 349.295 343.837 349.208 343.784L346.887 342.38C346.807 342.331 346.706 342.33 346.625 342.376L344.122 343.825C344.04 343.872 344.039 343.989 344.12 344.038L346.435 345.439Z",
    fill: "#3D415B"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M350.459 343.085C350.551 343.142 350.667 343.143 350.761 343.09L353.23 341.66C353.318 341.61 353.319 341.484 353.232 341.431L350.911 340.026C350.831 339.978 350.731 339.977 350.649 340.023L348.146 341.472C348.064 341.518 348.063 341.636 348.144 341.685L350.459 343.085Z",
    fill: "#3D415B"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M354.483 340.732C354.575 340.788 354.691 340.79 354.785 340.736L357.254 339.307C357.342 339.257 357.343 339.13 357.256 339.078L354.935 337.673C354.855 337.624 354.754 337.623 354.673 337.67L352.17 339.118C352.088 339.165 352.087 339.282 352.168 339.331L354.483 340.732Z",
    fill: "#3D415B"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M309.563 372.453L307.243 371.049C307.162 371.001 307.062 370.999 306.981 371.046L304.478 372.494C304.396 372.541 304.395 372.659 304.476 372.708L306.79 374.108C306.883 374.164 306.999 374.166 307.092 374.112L309.561 372.683C309.65 372.633 309.651 372.507 309.563 372.453Z",
    fill: "#3D415B"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M311.005 368.692L308.502 370.141C308.42 370.188 308.419 370.305 308.5 370.354L310.814 371.755C310.907 371.811 311.023 371.813 311.117 371.759L313.585 370.33C313.674 370.279 313.675 370.153 313.587 370.1L311.267 368.696C311.186 368.647 311.086 368.646 311.005 368.692Z",
    fill: "#3D415B"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M315.14 369.406L317.609 367.977C317.698 367.926 317.699 367.8 317.611 367.747L315.291 366.343C315.21 366.294 315.11 366.293 315.029 366.339L312.526 367.788C312.444 367.834 312.443 367.952 312.524 368.001L314.838 369.402C314.931 369.458 315.047 369.459 315.14 369.406Z",
    fill: "#3D415B"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M319.053 363.986L316.549 365.434C316.467 365.481 316.466 365.598 316.548 365.647L318.862 367.048C318.955 367.104 319.07 367.106 319.164 367.052L321.633 365.624C321.721 365.573 321.723 365.446 321.635 365.394L319.315 363.989C319.234 363.94 319.134 363.939 319.053 363.986Z",
    fill: "#3D415B"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M323.076 361.632L320.573 363.081C320.491 363.128 320.49 363.245 320.571 363.294L322.886 364.695C322.979 364.751 323.094 364.752 323.188 364.699L325.657 363.27C325.745 363.219 325.747 363.093 325.659 363.04L323.339 361.636C323.258 361.587 323.158 361.586 323.076 361.632Z",
    fill: "#3D415B"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M327.1 359.279L324.597 360.727C324.515 360.774 324.514 360.892 324.595 360.941L326.91 362.341C327.003 362.397 327.118 362.399 327.212 362.345L329.681 360.916C329.769 360.866 329.77 360.739 329.683 360.687L327.362 359.282C327.282 359.234 327.182 359.233 327.1 359.279Z",
    fill: "#3D415B"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M331.124 356.926L328.621 358.374C328.539 358.421 328.538 358.538 328.619 358.587L330.934 359.988C331.027 360.044 331.142 360.046 331.236 359.992L333.705 358.563C333.793 358.512 333.794 358.386 333.707 358.333L331.386 356.929C331.306 356.881 331.205 356.879 331.124 356.926Z",
    fill: "#3D415B"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M335.148 354.572L332.645 356.021C332.563 356.068 332.562 356.185 332.643 356.234L334.958 357.634C335.05 357.69 335.166 357.692 335.26 357.639L337.728 356.21C337.817 356.159 337.818 356.033 337.73 355.98L335.41 354.575C335.33 354.527 335.229 354.526 335.148 354.572Z",
    fill: "#3D415B"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M339.172 352.219L336.669 353.667C336.587 353.714 336.586 353.831 336.667 353.88L338.982 355.281C339.074 355.337 339.19 355.339 339.284 355.285L341.752 353.856C341.841 353.805 341.842 353.679 341.754 353.626L339.434 352.222C339.354 352.174 339.253 352.172 339.172 352.219Z",
    fill: "#3D415B"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M343.196 349.865L340.692 351.314C340.611 351.361 340.61 351.478 340.691 351.527L343.005 352.928C343.098 352.984 343.214 352.985 343.307 352.932L345.776 351.502C345.865 351.452 345.866 351.326 345.778 351.273L343.458 349.869C343.378 349.82 343.277 349.819 343.196 349.865Z",
    fill: "#3D415B"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M347.22 347.512L344.717 348.96C344.635 349.007 344.634 349.125 344.715 349.174L347.029 350.574C347.122 350.63 347.238 350.632 347.331 350.578L349.8 349.149C349.889 349.099 349.89 348.972 349.802 348.919L347.482 347.515C347.401 347.467 347.301 347.466 347.22 347.512Z",
    fill: "#3D415B"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M351.244 345.159L348.741 346.607C348.659 346.654 348.658 346.771 348.739 346.82L351.053 348.221C351.146 348.277 351.262 348.279 351.355 348.225L353.824 346.796C353.912 346.745 353.914 346.619 353.826 346.566L351.505 345.162C351.425 345.113 351.325 345.112 351.244 345.159Z",
    fill: "#3D415B"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M357.85 344.213L355.529 342.809C355.449 342.76 355.349 342.759 355.268 342.805L352.764 344.254C352.682 344.3 352.681 344.418 352.762 344.467L355.077 345.868C355.17 345.924 355.285 345.925 355.379 345.872L357.848 344.443C357.936 344.392 357.937 344.266 357.85 344.213Z",
    fill: "#3D415B"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M356.786 342.114L359.101 343.514C359.194 343.57 359.309 343.572 359.403 343.518L361.872 342.089C361.96 342.039 361.961 341.912 361.874 341.859L359.553 340.455C359.473 340.407 359.373 340.405 359.291 340.452L356.788 341.9C356.706 341.947 356.705 342.064 356.786 342.114Z",
    fill: "#3D415B"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M318.204 373.112C318.292 373.061 318.293 372.935 318.205 372.882L315.885 371.478C315.805 371.429 315.704 371.428 315.623 371.475L314.677 372.022C314.672 372.025 314.666 372.023 314.66 372.026L313.681 372.598L313.12 372.923C313.118 372.924 313.119 372.927 313.117 372.928L309.096 375.277C309.014 375.323 309.013 375.441 309.094 375.49L311.408 376.891C311.501 376.947 311.617 376.948 311.711 376.895L316.247 374.244L318.204 373.112Z",
    fill: "#3D415B"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M319.457 372.183C319.549 372.239 319.665 372.241 319.759 372.187L322.228 370.759C322.316 370.708 322.317 370.582 322.229 370.528L319.909 369.124C319.829 369.076 319.728 369.075 319.647 369.121L317.144 370.57C317.062 370.616 317.061 370.734 317.142 370.783L319.457 372.183Z",
    fill: "#3D415B"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M323.671 366.768L321.168 368.216C321.086 368.263 321.085 368.38 321.166 368.43L323.48 369.83C323.573 369.886 323.689 369.887 323.783 369.834L326.251 368.405C326.34 368.355 326.341 368.228 326.253 368.175L323.933 366.771C323.853 366.723 323.752 366.721 323.671 366.768Z",
    fill: "#3D415B"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M327.695 364.414L325.191 365.863C325.11 365.91 325.108 366.027 325.19 366.076L327.504 367.476C327.597 367.532 327.712 367.534 327.806 367.48L330.275 366.052C330.363 366.001 330.365 365.875 330.277 365.822L327.956 364.417C327.876 364.369 327.776 364.368 327.695 364.414Z",
    fill: "#3D415B"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M331.719 362.061L329.216 363.509C329.134 363.556 329.132 363.674 329.214 363.723L331.528 365.123C331.621 365.179 331.737 365.181 331.83 365.127L334.299 363.698C334.387 363.648 334.388 363.521 334.301 363.468L331.98 362.064C331.9 362.016 331.8 362.014 331.719 362.061Z",
    fill: "#3D415B"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M335.743 359.707L333.239 361.156C333.157 361.203 333.156 361.32 333.238 361.369L335.552 362.77C335.645 362.826 335.76 362.828 335.854 362.774L338.323 361.345C338.411 361.294 338.412 361.168 338.325 361.115L336.004 359.711C335.924 359.662 335.824 359.661 335.743 359.707Z",
    fill: "#3D415B"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M339.767 357.354L337.263 358.802C337.181 358.849 337.18 358.967 337.261 359.016L339.576 360.416C339.668 360.472 339.784 360.474 339.878 360.42L342.347 358.991C342.435 358.941 342.436 358.814 342.348 358.761L340.028 357.357C339.948 357.309 339.848 357.307 339.767 357.354Z",
    fill: "#3D415B"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M343.79 355L341.287 356.449C341.205 356.496 341.204 356.613 341.285 356.662L343.6 358.063C343.693 358.119 343.809 358.12 343.902 358.067L346.371 356.638C346.459 356.587 346.46 356.461 346.373 356.408L344.053 355.004C343.972 354.955 343.872 354.954 343.79 355Z",
    fill: "#3D415B"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M347.814 352.647L345.311 354.096C345.229 354.142 345.228 354.26 345.309 354.309L347.624 355.71C347.716 355.766 347.832 355.767 347.926 355.714L350.395 354.285C350.483 354.234 350.484 354.108 350.396 354.055L348.076 352.651C347.996 352.602 347.895 352.6 347.814 352.647Z",
    fill: "#3D415B"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M351.95 353.36L354.419 351.931C354.507 351.881 354.508 351.754 354.42 351.701L352.1 350.297C352.02 350.248 351.919 350.247 351.838 350.294L349.335 351.742C349.253 351.789 349.252 351.906 349.333 351.955L351.648 353.356C351.74 353.412 351.856 353.414 351.95 353.36Z",
    fill: "#3D415B"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M356.124 347.944C356.044 347.895 355.943 347.894 355.862 347.94L353.359 349.389C353.277 349.436 353.276 349.553 353.357 349.602L355.671 351.003C355.764 351.059 355.88 351.061 355.973 351.007L358.442 349.578C358.53 349.528 358.532 349.401 358.444 349.348L356.124 347.944Z",
    fill: "#3D415B"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M359.886 345.587L357.382 347.035C357.301 347.083 357.3 347.2 357.381 347.249L359.695 348.649C359.788 348.706 359.904 348.707 359.998 348.654L360.862 348.153C360.874 348.148 360.888 348.15 360.9 348.143L366.49 344.871C366.578 344.821 366.58 344.694 366.492 344.641L364.172 343.237C364.091 343.189 363.991 343.187 363.91 343.234L359.891 345.585C359.891 345.585 359.887 345.586 359.886 345.587Z",
    fill: "#3D415B"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M318.8 378.017L316.48 376.613C316.399 376.564 316.299 376.563 316.218 376.61L313.714 378.058C313.632 378.105 313.631 378.222 313.713 378.271L316.027 379.672C316.12 379.728 316.236 379.73 316.329 379.676L318.798 378.247C318.886 378.197 318.887 378.07 318.8 378.017Z",
    fill: "#3D415B"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M317.737 375.918L320.051 377.319C320.144 377.375 320.259 377.376 320.353 377.323L322.822 375.894C322.91 375.844 322.912 375.717 322.824 375.664L320.504 374.26C320.423 374.211 320.323 374.21 320.242 374.257L317.738 375.705C317.656 375.752 317.655 375.869 317.737 375.918Z",
    fill: "#3D415B"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M321.76 373.565L324.075 374.965C324.167 375.021 324.283 375.023 324.377 374.969L326.846 373.541C326.934 373.49 326.935 373.363 326.847 373.311L324.527 371.906C324.447 371.857 324.346 371.856 324.265 371.903L321.762 373.351C321.68 373.399 321.679 373.516 321.76 373.565Z",
    fill: "#3D415B"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M328.401 372.616L330.87 371.187C330.958 371.137 330.959 371.01 330.872 370.957L328.551 369.553C328.471 369.504 328.37 369.503 328.289 369.55L325.786 370.998C325.704 371.045 325.703 371.162 325.784 371.211L328.099 372.612C328.191 372.668 328.307 372.669 328.401 372.616Z",
    fill: "#3D415B"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M332.425 370.262L334.894 368.834C334.982 368.783 334.983 368.657 334.895 368.604L332.575 367.199C332.494 367.151 332.394 367.15 332.313 367.196L329.81 368.645C329.728 368.692 329.727 368.809 329.808 368.858L332.122 370.258C332.215 370.314 332.331 370.316 332.425 370.262Z",
    fill: "#3D415B"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M336.449 367.909L338.918 366.48C339.006 366.43 339.007 366.303 338.919 366.25L336.599 364.846C336.519 364.798 336.418 364.796 336.337 364.843L333.834 366.291C333.752 366.338 333.751 366.456 333.832 366.505L336.147 367.905C336.239 367.961 336.355 367.963 336.449 367.909Z",
    fill: "#3D415B"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M340.472 365.556L342.941 364.127C343.029 364.076 343.031 363.95 342.943 363.897L340.622 362.493C340.542 362.444 340.442 362.443 340.361 362.489L337.857 363.938C337.775 363.985 337.774 364.102 337.856 364.151L340.17 365.552C340.263 365.608 340.379 365.609 340.472 365.556Z",
    fill: "#3D415B"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M344.496 363.202L346.965 361.773C347.053 361.723 347.054 361.597 346.967 361.543L344.646 360.139C344.566 360.091 344.466 360.089 344.385 360.136L341.881 361.584C341.799 361.631 341.798 361.749 341.88 361.798L344.194 363.198C344.287 363.255 344.403 363.256 344.496 363.202Z",
    fill: "#3D415B"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M348.52 360.849L350.989 359.42C351.077 359.369 351.078 359.243 350.991 359.19L348.67 357.786C348.59 357.737 348.49 357.736 348.408 357.782L345.905 359.231C345.823 359.278 345.822 359.395 345.903 359.444L348.218 360.845C348.311 360.901 348.427 360.903 348.52 360.849Z",
    fill: "#3D415B"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M352.544 358.496L355.013 357.067C355.101 357.016 355.102 356.89 355.015 356.837L352.694 355.433C352.614 355.384 352.513 355.383 352.433 355.429L349.929 356.878C349.847 356.924 349.846 357.042 349.928 357.091L352.242 358.492C352.335 358.548 352.45 358.549 352.544 358.496Z",
    fill: "#3D415B"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M356.568 356.142L359.037 354.714C359.125 354.663 359.126 354.536 359.039 354.483L356.718 353.079C356.638 353.03 356.538 353.029 356.456 353.076L353.953 354.524C353.871 354.571 353.87 354.688 353.951 354.738L356.266 356.138C356.359 356.194 356.474 356.196 356.568 356.142Z",
    fill: "#3D415B"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M360.48 350.722L357.977 352.171C357.895 352.218 357.894 352.335 357.975 352.384L360.29 353.785C360.382 353.841 360.498 353.842 360.592 353.789L363.061 352.36C363.149 352.309 363.15 352.183 363.063 352.13L360.742 350.726C360.662 350.677 360.561 350.676 360.48 350.722Z",
    fill: "#3D415B"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M364.616 351.435L367.085 350.007C367.173 349.956 367.174 349.829 367.086 349.777L364.766 348.372C364.685 348.324 364.585 348.322 364.504 348.369L362.001 349.817C361.919 349.864 361.918 349.982 361.999 350.031L364.313 351.431C364.406 351.487 364.522 351.489 364.616 351.435Z",
    fill: "#3D415B"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M366.023 347.677L368.337 349.078C368.43 349.134 368.546 349.136 368.64 349.082L371.108 347.653C371.197 347.603 371.198 347.476 371.11 347.423L368.79 346.019C368.709 345.97 368.609 345.969 368.528 346.016L366.025 347.464C365.943 347.511 365.942 347.628 366.023 347.677Z",
    fill: "#3D415B"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M323.418 380.799L321.098 379.395C321.017 379.346 320.917 379.345 320.836 379.392L318.333 380.84C318.251 380.887 318.25 381.005 318.331 381.054L320.645 382.454C320.738 382.51 320.854 382.512 320.947 382.458L323.416 381.03C323.505 380.979 323.506 380.852 323.418 380.799Z",
    fill: "#3D415B"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M324.669 380.101C324.762 380.157 324.878 380.158 324.971 380.105L327.44 378.676C327.528 378.625 327.53 378.499 327.442 378.446L325.121 377.042C325.041 376.993 324.941 376.992 324.86 377.038L322.356 378.487C322.274 378.534 322.273 378.651 322.355 378.7L324.669 380.101Z",
    fill: "#3D415B"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M328.995 377.751L331.464 376.322C331.552 376.272 331.553 376.145 331.466 376.093L329.145 374.688C329.065 374.64 328.965 374.638 328.883 374.685L326.38 376.134C326.298 376.18 326.297 376.298 326.378 376.347L328.693 377.747C328.786 377.803 328.901 377.805 328.995 377.751Z",
    fill: "#3D415B"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M333.019 375.398L335.488 373.969C335.576 373.918 335.577 373.792 335.49 373.739L333.169 372.335C333.089 372.286 332.989 372.285 332.907 372.331L330.404 373.78C330.322 373.827 330.321 373.944 330.402 373.993L332.717 375.394C332.809 375.45 332.925 375.452 333.019 375.398Z",
    fill: "#3D415B"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M337.043 373.044L339.512 371.615C339.6 371.565 339.601 371.438 339.514 371.386L337.193 369.982C337.113 369.933 337.012 369.931 336.931 369.978L334.428 371.427C334.346 371.474 334.345 371.591 334.426 371.64L336.741 373.041C336.833 373.097 336.949 373.098 337.043 373.044Z",
    fill: "#3D415B"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M341.067 370.691L343.535 369.262C343.624 369.212 343.625 369.085 343.537 369.032L341.217 367.628C341.136 367.579 341.036 367.578 340.955 367.625L338.452 369.073C338.37 369.12 338.369 369.237 338.45 369.286L340.764 370.687C340.857 370.743 340.973 370.745 341.067 370.691Z",
    fill: "#3D415B"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M345.091 368.338L347.56 366.909C347.648 366.858 347.649 366.732 347.562 366.679L345.241 365.275C345.161 365.226 345.061 365.225 344.979 365.271L342.476 366.72C342.394 366.767 342.393 366.884 342.474 366.933L344.789 368.334C344.881 368.39 344.997 368.391 345.091 368.338Z",
    fill: "#3D415B"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M349.114 365.984L351.583 364.555C351.672 364.505 351.673 364.378 351.585 364.325L349.265 362.921C349.184 362.872 349.084 362.871 349.003 362.918L346.499 364.366C346.417 364.413 346.417 364.53 346.498 364.579L348.812 365.98C348.905 366.036 349.021 366.038 349.114 365.984Z",
    fill: "#3D415B"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M353.138 363.631L355.607 362.202C355.696 362.152 355.697 362.025 355.609 361.972L353.289 360.568C353.208 360.519 353.108 360.518 353.027 360.564L350.523 362.013C350.441 362.06 350.44 362.177 350.522 362.226L352.836 363.627C352.929 363.683 353.045 363.684 353.138 363.631Z",
    fill: "#3D415B"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M357.162 361.277L359.631 359.849C359.719 359.798 359.721 359.672 359.633 359.619L357.312 358.214C357.232 358.166 357.132 358.165 357.051 358.211L354.547 359.659C354.465 359.707 354.464 359.824 354.546 359.873L356.86 361.273C356.953 361.329 357.069 361.331 357.162 361.277Z",
    fill: "#3D415B"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M361.186 358.924L363.655 357.495C363.743 357.445 363.744 357.318 363.657 357.265L361.336 355.861C361.256 355.812 361.155 355.811 361.074 355.857L358.571 357.306C358.489 357.353 358.488 357.47 358.569 357.519L360.884 358.92C360.977 358.976 361.092 358.977 361.186 358.924Z",
    fill: "#3D415B"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M365.21 356.57L367.679 355.142C367.767 355.091 367.768 354.965 367.681 354.912L365.36 353.507C365.28 353.459 365.18 353.458 365.098 353.504L362.595 354.953C362.513 355 362.512 355.117 362.593 355.166L364.908 356.566C365.001 356.622 365.116 356.624 365.21 356.57Z",
    fill: "#3D415B"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M369.234 354.217L371.703 352.788C371.791 352.738 371.792 352.611 371.705 352.558L369.384 351.154C369.304 351.106 369.204 351.104 369.122 351.151L366.619 352.599C366.537 352.646 366.536 352.764 366.617 352.813L368.932 354.213C369.024 354.269 369.14 354.271 369.234 354.217Z",
    fill: "#3D415B"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M370.641 350.459L372.956 351.86C373.048 351.916 373.164 351.918 373.258 351.864L375.727 350.435C375.815 350.384 375.816 350.258 375.728 350.205L373.408 348.801C373.327 348.752 373.227 348.751 373.146 348.797L370.643 350.246C370.561 350.293 370.56 350.41 370.641 350.459Z",
    fill: "#3D415B"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M325.716 382.177C325.635 382.128 325.535 382.127 325.454 382.173L322.951 383.622C322.869 383.669 322.868 383.786 322.949 383.835L325.264 385.236C325.356 385.292 325.472 385.293 325.566 385.24L328.034 383.811C328.123 383.76 328.124 383.634 328.036 383.581L325.716 382.177Z",
    fill: "#3D415B"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M329.74 379.823C329.659 379.775 329.559 379.774 329.478 379.82L326.975 381.269C326.893 381.315 326.892 381.433 326.973 381.482L329.287 382.882C329.38 382.938 329.496 382.94 329.589 382.886L332.058 381.458C332.147 381.407 332.148 381.28 332.06 381.228L329.74 379.823Z",
    fill: "#3D415B"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M333.764 377.47C333.683 377.422 333.583 377.42 333.502 377.467L330.998 378.915C330.917 378.962 330.916 379.079 330.997 379.128L333.311 380.529C333.404 380.585 333.52 380.587 333.613 380.533L336.082 379.104C336.17 379.054 336.171 378.927 336.084 378.874L333.764 377.47Z",
    fill: "#3D415B"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M337.787 375.116C337.707 375.068 337.607 375.067 337.526 375.113L335.022 376.562C334.94 376.609 334.939 376.726 335.021 376.775L337.335 378.175C337.428 378.231 337.543 378.233 337.637 378.18L340.106 376.751C340.194 376.7 340.195 376.574 340.108 376.521L337.787 375.116Z",
    fill: "#3D415B"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M357.907 363.35C357.826 363.301 357.726 363.3 357.645 363.346L356.423 364.053C356.37 364.048 356.316 364.053 356.268 364.08L339.046 374.208C338.964 374.255 338.963 374.373 339.045 374.422L341.359 375.822C341.452 375.878 341.568 375.88 341.661 375.826L345.645 373.483C345.658 373.478 345.673 373.48 345.685 373.473L348.154 372.044C348.176 372.032 348.175 372.008 348.186 371.988L349.63 371.14C349.656 371.133 349.685 371.133 349.709 371.119L352.178 369.69C352.207 369.674 352.212 369.643 352.222 369.615L353.613 368.796C353.655 368.792 353.696 368.787 353.733 368.766L356.202 367.337C356.239 367.316 356.251 367.279 356.257 367.242L357.602 366.451C357.655 366.452 357.709 366.44 357.757 366.413L360.226 364.984C360.314 364.933 360.315 364.807 360.227 364.754L357.907 363.35Z",
    fill: "#3D415B"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M361.931 360.996C361.85 360.948 361.75 360.946 361.669 360.993L359.166 362.442C359.084 362.488 359.083 362.605 359.164 362.655L361.479 364.055C361.571 364.111 361.687 364.113 361.781 364.059L364.249 362.63C364.338 362.58 364.339 362.453 364.251 362.401L361.931 360.996Z",
    fill: "#3D415B"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M365.955 358.643C365.874 358.594 365.774 358.593 365.693 358.64L363.19 360.088C363.108 360.135 363.107 360.252 363.188 360.301L365.502 361.702C365.595 361.758 365.711 361.76 365.804 361.706L368.273 360.277C368.362 360.226 368.363 360.1 368.275 360.047L365.955 358.643Z",
    fill: "#3D415B"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M369.979 356.29C369.898 356.241 369.798 356.24 369.717 356.286L367.213 357.735C367.132 357.781 367.131 357.899 367.212 357.948L369.526 359.348C369.619 359.404 369.735 359.406 369.828 359.352L372.297 357.924C372.385 357.873 372.387 357.747 372.299 357.694L369.979 356.29Z",
    fill: "#3D415B"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M374.003 353.936C373.922 353.887 373.822 353.886 373.741 353.933L371.237 355.381C371.155 355.428 371.154 355.545 371.235 355.594L373.55 356.995C373.643 357.051 373.758 357.053 373.852 356.999L376.321 355.57C376.409 355.52 376.41 355.393 376.323 355.34L374.003 353.936Z",
    fill: "#3D415B"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M380.347 352.987L378.026 351.583C377.946 351.534 377.846 351.533 377.764 351.579L375.261 353.028C375.179 353.075 375.178 353.192 375.259 353.241L377.574 354.642C377.667 354.698 377.782 354.699 377.876 354.646L380.345 353.217C380.433 353.166 380.434 353.04 380.347 352.987Z",
    fill: "#3D415B"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M304.943 369.419L302.474 370.848C302.381 370.902 302.265 370.9 302.172 370.844L299.858 369.444C299.777 369.394 299.778 369.277 299.86 369.23L302.363 367.782C302.444 367.735 302.545 367.737 302.625 367.785L304.946 369.189C305.033 369.242 305.031 369.369 304.943 369.419Z",
    fill: "url(#paint193_linear_7_1850)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M308.967 367.066L306.498 368.495C306.405 368.548 306.289 368.547 306.196 368.491L303.882 367.09C303.801 367.041 303.802 366.924 303.883 366.877L306.387 365.428C306.468 365.382 306.568 365.383 306.649 365.432L308.969 366.836C309.057 366.889 309.056 367.015 308.967 367.066Z",
    fill: "url(#paint194_linear_7_1850)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M312.991 364.713L310.522 366.141C310.429 366.195 310.313 366.193 310.22 366.137L307.906 364.737C307.825 364.688 307.826 364.57 307.908 364.524L310.411 363.075C310.492 363.029 310.592 363.03 310.673 363.078L312.993 364.483C313.08 364.535 313.079 364.662 312.991 364.713Z",
    fill: "url(#paint195_linear_7_1850)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M317.015 362.359L314.546 363.788C314.452 363.842 314.336 363.84 314.244 363.784L311.929 362.383C311.848 362.334 311.849 362.217 311.931 362.17L314.435 360.722C314.516 360.675 314.616 360.676 314.696 360.725L317.017 362.129C317.104 362.182 317.103 362.309 317.015 362.359Z",
    fill: "url(#paint196_linear_7_1850)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M321.039 360.006L318.57 361.435C318.476 361.488 318.36 361.487 318.268 361.431L315.953 360.03C315.872 359.981 315.873 359.864 315.955 359.817L318.458 358.368C318.54 358.322 318.64 358.323 318.72 358.372L321.041 359.776C321.128 359.829 321.127 359.955 321.039 360.006Z",
    fill: "url(#paint197_linear_7_1850)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M325.063 357.652L322.594 359.081C322.5 359.135 322.384 359.133 322.292 359.077L319.977 357.677C319.896 357.628 319.897 357.51 319.979 357.463L322.482 356.015C322.564 355.969 322.664 355.97 322.744 356.018L325.065 357.423C325.152 357.475 325.151 357.602 325.063 357.652Z",
    fill: "url(#paint198_linear_7_1850)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M329.087 355.299L326.618 356.728C326.524 356.781 326.408 356.78 326.316 356.724L324.001 355.323C323.92 355.274 323.921 355.157 324.003 355.11L326.506 353.661C326.588 353.615 326.688 353.616 326.768 353.665L329.089 355.069C329.176 355.122 329.175 355.248 329.087 355.299Z",
    fill: "url(#paint199_linear_7_1850)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M333.11 352.945L330.642 354.374C330.548 354.428 330.432 354.426 330.34 354.37L328.025 352.97C327.944 352.921 327.945 352.803 328.027 352.756L330.53 351.308C330.611 351.261 330.712 351.263 330.792 351.312L333.113 352.716C333.2 352.768 333.199 352.895 333.11 352.945Z",
    fill: "url(#paint200_linear_7_1850)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M337.134 350.592L334.665 352.021C334.572 352.075 334.456 352.073 334.363 352.017L332.049 350.616C331.968 350.567 331.969 350.45 332.051 350.403L334.554 348.954C334.635 348.908 334.736 348.909 334.816 348.958L337.136 350.362C337.224 350.415 337.223 350.541 337.134 350.592Z",
    fill: "url(#paint201_linear_7_1850)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M341.158 348.239L338.689 349.668C338.596 349.721 338.48 349.72 338.387 349.664L336.073 348.263C335.992 348.214 335.993 348.096 336.075 348.05L338.578 346.601C338.659 346.555 338.76 346.556 338.84 346.605L341.16 348.009C341.248 348.062 341.247 348.188 341.158 348.239Z",
    fill: "url(#paint202_linear_7_1850)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M345.182 345.885L342.713 347.314C342.62 347.368 342.504 347.366 342.411 347.31L340.097 345.91C340.016 345.86 340.017 345.743 340.098 345.696L342.602 344.248C342.683 344.201 342.783 344.203 342.864 344.251L345.184 345.656C345.271 345.708 345.27 345.835 345.182 345.885Z",
    fill: "url(#paint203_linear_7_1850)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M349.206 343.532L346.737 344.961C346.643 345.014 346.528 345.013 346.435 344.957L344.12 343.556C344.039 343.507 344.04 343.39 344.122 343.343L346.626 341.894C346.707 341.848 346.807 341.849 346.887 341.898L349.208 343.302C349.295 343.355 349.294 343.481 349.206 343.532Z",
    fill: "url(#paint204_linear_7_1850)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M353.23 341.179L350.761 342.607C350.667 342.661 350.551 342.659 350.459 342.603L348.144 341.203C348.063 341.154 348.064 341.036 348.146 340.99L350.65 339.541C350.731 339.495 350.831 339.496 350.911 339.544L353.232 340.949C353.319 341.001 353.318 341.128 353.23 341.179Z",
    fill: "url(#paint205_linear_7_1850)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M357.254 338.825L354.785 340.254C354.691 340.308 354.575 340.306 354.483 340.25L352.168 338.849C352.087 338.8 352.088 338.683 352.17 338.636L354.673 337.188C354.755 337.141 354.855 337.142 354.935 337.191L357.256 338.595C357.343 338.648 357.342 338.775 357.254 338.825Z",
    fill: "url(#paint206_linear_7_1850)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M309.562 372.201L307.092 373.63C306.999 373.684 306.883 373.682 306.79 373.626L304.476 372.226C304.395 372.176 304.396 372.059 304.478 372.012L306.981 370.564C307.062 370.517 307.163 370.519 307.243 370.567L309.564 371.971C309.651 372.024 309.65 372.151 309.562 372.201Z",
    fill: "url(#paint207_linear_7_1850)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M313.585 369.848L311.116 371.277C311.023 371.33 310.907 371.329 310.814 371.273L308.5 369.872C308.419 369.823 308.42 369.706 308.502 369.659L311.005 368.21C311.086 368.164 311.187 368.165 311.267 368.214L313.587 369.618C313.675 369.671 313.674 369.797 313.585 369.848Z",
    fill: "url(#paint208_linear_7_1850)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M317.609 367.494L315.14 368.923C315.047 368.977 314.931 368.975 314.838 368.919L312.524 367.519C312.443 367.47 312.444 367.352 312.526 367.306L315.029 365.857C315.11 365.811 315.211 365.812 315.291 365.86L317.611 367.265C317.699 367.317 317.698 367.444 317.609 367.494Z",
    fill: "url(#paint209_linear_7_1850)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M321.633 365.141L319.164 366.57C319.07 366.624 318.955 366.622 318.862 366.566L316.548 365.165C316.466 365.116 316.467 364.999 316.549 364.952L319.053 363.504C319.134 363.457 319.234 363.458 319.315 363.507L321.635 364.911C321.722 364.964 321.721 365.09 321.633 365.141Z",
    fill: "url(#paint210_linear_7_1850)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M325.657 362.788L323.188 364.217C323.095 364.27 322.979 364.269 322.886 364.213L320.572 362.812C320.491 362.763 320.492 362.646 320.574 362.599L323.077 361.15C323.158 361.104 323.259 361.105 323.339 361.154L325.659 362.558C325.746 362.611 325.745 362.737 325.657 362.788Z",
    fill: "url(#paint211_linear_7_1850)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M329.681 360.434L327.212 361.863C327.119 361.917 327.003 361.915 326.91 361.859L324.596 360.459C324.515 360.409 324.516 360.292 324.597 360.245L327.101 358.797C327.182 358.75 327.282 358.752 327.363 358.8L329.683 360.204C329.77 360.257 329.769 360.384 329.681 360.434Z",
    fill: "url(#paint212_linear_7_1850)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M333.705 358.081L331.236 359.51C331.142 359.563 331.026 359.562 330.934 359.506L328.619 358.105C328.538 358.056 328.539 357.939 328.621 357.892L331.124 356.443C331.206 356.397 331.306 356.398 331.386 356.447L333.707 357.851C333.794 357.904 333.793 358.03 333.705 358.081Z",
    fill: "url(#paint213_linear_7_1850)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M337.729 355.727L335.26 357.156C335.166 357.21 335.05 357.208 334.958 357.152L332.643 355.752C332.562 355.702 332.563 355.585 332.645 355.538L335.149 354.09C335.23 354.043 335.33 354.045 335.41 354.093L337.731 355.498C337.818 355.55 337.817 355.677 337.729 355.727Z",
    fill: "url(#paint214_linear_7_1850)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M341.752 353.374L339.284 354.803C339.19 354.856 339.074 354.855 338.982 354.799L336.667 353.398C336.586 353.349 336.587 353.232 336.669 353.185L339.172 351.736C339.253 351.69 339.354 351.691 339.434 351.74L341.755 353.144C341.842 353.197 341.841 353.323 341.752 353.374Z",
    fill: "url(#paint215_linear_7_1850)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M345.776 351.021L343.307 352.449C343.214 352.503 343.098 352.501 343.005 352.445L340.691 351.045C340.61 350.996 340.611 350.878 340.693 350.832L343.196 349.383C343.277 349.337 343.378 349.338 343.458 349.387L345.778 350.791C345.866 350.844 345.865 350.97 345.776 351.021Z",
    fill: "url(#paint216_linear_7_1850)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M349.8 348.667L347.331 350.096C347.238 350.15 347.122 350.148 347.029 350.092L344.715 348.691C344.634 348.642 344.635 348.525 344.717 348.478L347.22 347.03C347.301 346.983 347.402 346.984 347.482 347.033L349.802 348.437C349.89 348.49 349.888 348.617 349.8 348.667Z",
    fill: "url(#paint217_linear_7_1850)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M353.824 346.314L351.355 347.743C351.262 347.796 351.146 347.795 351.053 347.739L348.739 346.338C348.658 346.289 348.659 346.172 348.741 346.125L351.244 344.676C351.325 344.63 351.425 344.631 351.506 344.68L353.826 346.084C353.914 346.137 353.912 346.263 353.824 346.314Z",
    fill: "url(#paint218_linear_7_1850)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M357.848 343.96L355.379 345.389C355.285 345.443 355.17 345.441 355.077 345.385L352.763 343.985C352.681 343.936 352.682 343.818 352.764 343.771L355.268 342.323C355.349 342.276 355.449 342.278 355.53 342.326L357.85 343.73C357.937 343.783 357.936 343.91 357.848 343.96Z",
    fill: "url(#paint219_linear_7_1850)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M361.872 341.607L359.403 343.036C359.309 343.09 359.194 343.088 359.101 343.032L356.787 341.631C356.706 341.582 356.707 341.465 356.788 341.418L359.292 339.969C359.373 339.923 359.473 339.924 359.554 339.973L361.874 341.377C361.961 341.43 361.96 341.556 361.872 341.607Z",
    fill: "url(#paint220_linear_7_1850)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M317.241 373.181L311.711 376.412C311.617 376.466 311.501 376.464 311.409 376.408L309.094 375.007C309.013 374.958 309.014 374.841 309.096 374.794L314.661 371.544C314.742 371.497 314.842 371.499 314.923 371.547L317.243 372.951C317.33 373.004 317.329 373.131 317.241 373.181Z",
    fill: "url(#paint221_linear_7_1850)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M318.204 372.63L315.735 374.059C315.641 374.112 315.525 374.111 315.433 374.055L313.118 372.654C313.037 372.605 313.038 372.488 313.12 372.441L315.624 370.992C315.705 370.946 315.805 370.947 315.885 370.996L318.206 372.4C318.293 372.453 318.292 372.579 318.204 372.63Z",
    fill: "url(#paint222_linear_7_1850)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M322.227 370.276L319.758 371.705C319.665 371.759 319.549 371.757 319.456 371.701L317.142 370.301C317.061 370.251 317.062 370.134 317.144 370.087L319.647 368.639C319.728 368.592 319.829 368.594 319.909 368.642L322.229 370.046C322.317 370.099 322.316 370.226 322.227 370.276Z",
    fill: "url(#paint223_linear_7_1850)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M326.251 367.923L323.782 369.352C323.689 369.405 323.573 369.404 323.48 369.348L321.166 367.947C321.085 367.898 321.086 367.781 321.168 367.734L323.671 366.285C323.752 366.239 323.853 366.24 323.933 366.289L326.254 367.693C326.341 367.746 326.34 367.872 326.251 367.923Z",
    fill: "url(#paint224_linear_7_1850)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M330.275 365.57L327.806 366.998C327.713 367.052 327.597 367.05 327.504 366.994L325.19 365.594C325.109 365.545 325.11 365.427 325.192 365.381L327.695 363.932C327.776 363.886 327.877 363.887 327.957 363.935L330.277 365.34C330.365 365.392 330.364 365.519 330.275 365.57Z",
    fill: "url(#paint225_linear_7_1850)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M334.299 363.216L331.83 364.645C331.737 364.699 331.621 364.697 331.528 364.641L329.214 363.24C329.133 363.191 329.134 363.074 329.216 363.027L331.719 361.579C331.8 361.532 331.901 361.534 331.981 361.582L334.301 362.986C334.389 363.039 334.388 363.166 334.299 363.216Z",
    fill: "url(#paint226_linear_7_1850)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M338.323 360.863L335.854 362.291C335.761 362.345 335.645 362.344 335.552 362.287L333.238 360.887C333.157 360.838 333.158 360.72 333.24 360.674L335.743 359.225C335.824 359.179 335.924 359.18 336.005 359.229L338.325 360.633C338.412 360.686 338.411 360.812 338.323 360.863Z",
    fill: "url(#paint227_linear_7_1850)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M342.347 358.509L339.878 359.938C339.784 359.992 339.669 359.99 339.576 359.934L337.261 358.533C337.18 358.484 337.181 358.367 337.263 358.32L339.767 356.872C339.848 356.825 339.948 356.826 340.028 356.875L342.349 358.279C342.436 358.332 342.435 358.459 342.347 358.509Z",
    fill: "url(#paint228_linear_7_1850)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M346.371 356.156L343.902 357.585C343.808 357.638 343.692 357.637 343.6 357.581L341.285 356.18C341.204 356.131 341.205 356.014 341.287 355.967L343.791 354.518C343.872 354.472 343.972 354.473 344.052 354.522L346.373 355.926C346.46 355.979 346.459 356.105 346.371 356.156Z",
    fill: "url(#paint229_linear_7_1850)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M350.395 353.802L347.926 355.231C347.832 355.285 347.716 355.283 347.624 355.227L345.309 353.827C345.228 353.778 345.229 353.66 345.311 353.614L347.815 352.165C347.896 352.119 347.996 352.12 348.076 352.168L350.397 353.573C350.484 353.626 350.483 353.752 350.395 353.802Z",
    fill: "url(#paint230_linear_7_1850)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M354.419 351.449L351.95 352.878C351.856 352.932 351.74 352.93 351.648 352.874L349.333 351.473C349.252 351.424 349.253 351.307 349.335 351.26L351.838 349.812C351.919 349.765 352.02 349.766 352.1 349.815L354.421 351.219C354.508 351.272 354.507 351.398 354.419 351.449Z",
    fill: "url(#paint231_linear_7_1850)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M358.442 349.096L355.974 350.525C355.88 350.578 355.764 350.577 355.672 350.521L353.357 349.12C353.276 349.071 353.277 348.954 353.359 348.907L355.862 347.458C355.944 347.412 356.044 347.413 356.124 347.462L358.445 348.866C358.532 348.919 358.531 349.045 358.442 349.096Z",
    fill: "url(#paint232_linear_7_1850)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M362.466 346.742L359.997 348.171C359.904 348.225 359.788 348.223 359.695 348.167L357.381 346.767C357.3 346.717 357.301 346.6 357.383 346.553L359.886 345.105C359.967 345.058 360.068 345.06 360.148 345.108L362.468 346.512C362.556 346.565 362.555 346.692 362.466 346.742Z",
    fill: "url(#paint233_linear_7_1850)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M366.49 344.389L360.9 347.661C360.806 347.715 360.69 347.713 360.598 347.657L358.283 346.257C358.202 346.207 358.203 346.09 358.285 346.043L363.91 342.751C363.991 342.705 364.091 342.706 364.172 342.755L366.492 344.159C366.579 344.212 366.578 344.338 366.49 344.389Z",
    fill: "url(#paint234_linear_7_1850)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M318.798 377.765L316.329 379.194C316.235 379.248 316.119 379.246 316.027 379.19L313.712 377.789C313.631 377.74 313.632 377.623 313.714 377.576L316.218 376.127C316.299 376.081 316.399 376.082 316.479 376.131L318.8 377.535C318.887 377.588 318.886 377.714 318.798 377.765Z",
    fill: "url(#paint235_linear_7_1850)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M322.822 375.412L320.353 376.841C320.259 376.894 320.144 376.893 320.051 376.836L317.736 375.436C317.655 375.387 317.656 375.269 317.738 375.223L320.242 373.774C320.323 373.728 320.423 373.729 320.503 373.777L322.824 375.182C322.911 375.235 322.91 375.361 322.822 375.412Z",
    fill: "url(#paint236_linear_7_1850)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M326.846 373.058L324.377 374.487C324.283 374.541 324.167 374.539 324.075 374.483L321.76 373.083C321.679 373.033 321.68 372.916 321.762 372.869L324.266 371.421C324.347 371.374 324.447 371.376 324.527 371.424L326.848 372.828C326.935 372.881 326.934 373.008 326.846 373.058Z",
    fill: "url(#paint237_linear_7_1850)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M330.87 370.705L328.401 372.134C328.307 372.187 328.191 372.186 328.099 372.13L325.784 370.729C325.703 370.68 325.704 370.563 325.786 370.516L328.289 369.067C328.37 369.021 328.471 369.022 328.551 369.071L330.872 370.475C330.959 370.528 330.958 370.654 330.87 370.705Z",
    fill: "url(#paint238_linear_7_1850)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M334.894 368.351L332.425 369.78C332.331 369.834 332.215 369.832 332.123 369.776L329.808 368.376C329.727 368.327 329.728 368.209 329.81 368.163L332.313 366.714C332.395 366.668 332.495 366.669 332.575 366.717L334.896 368.122C334.983 368.174 334.982 368.301 334.894 368.351Z",
    fill: "url(#paint239_linear_7_1850)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M338.917 365.998L336.448 367.427C336.355 367.48 336.239 367.479 336.146 367.423L333.832 366.022C333.751 365.973 333.752 365.856 333.834 365.809L336.337 364.36C336.418 364.314 336.519 364.315 336.599 364.364L338.92 365.768C339.007 365.821 339.006 365.947 338.917 365.998Z",
    fill: "url(#paint240_linear_7_1850)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M342.941 363.644L340.472 365.073C340.379 365.127 340.263 365.125 340.17 365.069L337.856 363.669C337.775 363.62 337.776 363.502 337.858 363.456L340.361 362.007C340.442 361.961 340.543 361.962 340.623 362.01L342.943 363.415C343.031 363.468 343.03 363.594 342.941 363.644Z",
    fill: "url(#paint241_linear_7_1850)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M346.965 361.291L344.496 362.72C344.403 362.774 344.287 362.772 344.194 362.716L341.88 361.315C341.799 361.266 341.8 361.149 341.882 361.102L344.385 359.654C344.466 359.607 344.566 359.608 344.647 359.657L346.967 361.061C347.054 361.114 347.053 361.241 346.965 361.291Z",
    fill: "url(#paint242_linear_7_1850)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M350.989 358.938L348.52 360.367C348.426 360.42 348.311 360.419 348.218 360.363L345.904 358.962C345.823 358.913 345.823 358.796 345.905 358.749L348.409 357.3C348.49 357.254 348.59 357.255 348.671 357.304L350.991 358.708C351.078 358.761 351.077 358.887 350.989 358.938Z",
    fill: "url(#paint243_linear_7_1850)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M355.013 356.584L352.544 358.013C352.451 358.067 352.335 358.065 352.242 358.009L349.928 356.609C349.847 356.56 349.848 356.442 349.93 356.395L352.433 354.947C352.514 354.9 352.614 354.902 352.695 354.95L355.015 356.354C355.102 356.407 355.101 356.534 355.013 356.584Z",
    fill: "url(#paint244_linear_7_1850)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M359.037 354.231L356.568 355.66C356.474 355.713 356.358 355.712 356.266 355.656L353.951 354.255C353.87 354.206 353.871 354.089 353.953 354.042L356.457 352.593C356.538 352.547 356.638 352.548 356.718 352.597L359.039 354.001C359.126 354.054 359.125 354.18 359.037 354.231Z",
    fill: "url(#paint245_linear_7_1850)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M363.061 351.878L360.592 353.306C360.498 353.36 360.382 353.358 360.29 353.302L357.975 351.902C357.894 351.853 357.895 351.735 357.977 351.689L360.48 350.24C360.562 350.194 360.662 350.195 360.742 350.243L363.063 351.648C363.15 351.7 363.149 351.827 363.061 351.878Z",
    fill: "url(#paint246_linear_7_1850)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M367.085 349.524L364.616 350.953C364.522 351.007 364.406 351.005 364.314 350.949L361.999 349.548C361.918 349.499 361.919 349.382 362.001 349.335L364.504 347.887C364.586 347.84 364.686 347.841 364.766 347.89L367.087 349.294C367.174 349.347 367.173 349.474 367.085 349.524Z",
    fill: "url(#paint247_linear_7_1850)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M371.108 347.171L368.639 348.6C368.546 348.653 368.43 348.652 368.337 348.596L366.023 347.195C365.942 347.146 365.943 347.029 366.025 346.982L368.528 345.533C368.609 345.487 368.71 345.488 368.79 345.537L371.111 346.941C371.198 346.994 371.197 347.12 371.108 347.171Z",
    fill: "url(#paint248_linear_7_1850)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M323.416 380.547L320.947 381.976C320.854 382.029 320.738 382.028 320.645 381.972L318.331 380.571C318.25 380.522 318.251 380.405 318.332 380.358L320.836 378.909C320.917 378.863 321.017 378.864 321.098 378.913L323.418 380.317C323.506 380.37 323.505 380.496 323.416 380.547Z",
    fill: "url(#paint249_linear_7_1850)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M327.44 378.194L324.971 379.622C324.878 379.676 324.762 379.674 324.669 379.618L322.355 378.218C322.274 378.169 322.275 378.051 322.357 378.005L324.86 376.556C324.941 376.51 325.041 376.511 325.122 376.559L327.442 377.964C327.529 378.016 327.528 378.143 327.44 378.194Z",
    fill: "url(#paint250_linear_7_1850)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M331.464 375.84L328.995 377.269C328.902 377.323 328.786 377.321 328.693 377.265L326.379 375.864C326.298 375.815 326.299 375.698 326.381 375.651L328.884 374.203C328.965 374.156 329.065 374.157 329.146 374.206L331.466 375.61C331.553 375.663 331.552 375.79 331.464 375.84Z",
    fill: "url(#paint251_linear_7_1850)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M335.488 373.487L333.019 374.916C332.925 374.969 332.809 374.968 332.717 374.912L330.402 373.511C330.321 373.462 330.322 373.345 330.404 373.298L332.908 371.849C332.989 371.803 333.089 371.804 333.169 371.853L335.49 373.257C335.577 373.31 335.576 373.436 335.488 373.487Z",
    fill: "url(#paint252_linear_7_1850)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M339.512 371.133L337.043 372.562C336.949 372.616 336.833 372.614 336.741 372.558L334.427 371.158C334.345 371.108 334.346 370.991 334.428 370.944L336.932 369.496C337.013 369.449 337.113 369.451 337.193 369.499L339.514 370.903C339.601 370.956 339.6 371.083 339.512 371.133Z",
    fill: "url(#paint253_linear_7_1850)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M343.536 368.78L341.067 370.209C340.973 370.262 340.857 370.261 340.765 370.205L338.45 368.804C338.369 368.755 338.37 368.638 338.452 368.591L340.955 367.142C341.037 367.096 341.137 367.097 341.217 367.146L343.538 368.55C343.625 368.603 343.624 368.729 343.536 368.78Z",
    fill: "url(#paint254_linear_7_1850)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M347.559 366.426L345.091 367.855C344.997 367.909 344.881 367.907 344.788 367.851L342.474 366.451C342.393 366.402 342.394 366.284 342.476 366.237L344.979 364.789C345.06 364.742 345.161 364.744 345.241 364.792L347.561 366.196C347.649 366.249 347.648 366.376 347.559 366.426Z",
    fill: "url(#paint255_linear_7_1850)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M351.583 364.073L349.115 365.502C349.021 365.556 348.905 365.554 348.813 365.498L346.498 364.097C346.417 364.048 346.418 363.931 346.5 363.884L349.003 362.435C349.084 362.389 349.185 362.39 349.265 362.439L351.586 363.843C351.673 363.896 351.672 364.023 351.583 364.073Z",
    fill: "url(#paint256_linear_7_1850)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M355.607 361.72L353.138 363.149C353.045 363.202 352.929 363.201 352.836 363.145L350.522 361.744C350.441 361.695 350.442 361.577 350.524 361.531L353.027 360.082C353.108 360.036 353.209 360.037 353.289 360.086L355.61 361.49C355.696 361.543 355.696 361.669 355.607 361.72Z",
    fill: "url(#paint257_linear_7_1850)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M359.631 359.366L357.162 360.795C357.069 360.849 356.953 360.847 356.86 360.791L354.546 359.391C354.465 359.341 354.466 359.224 354.547 359.177L357.051 357.729C357.132 357.682 357.232 357.684 357.313 357.732L359.633 359.136C359.72 359.189 359.72 359.316 359.631 359.366Z",
    fill: "url(#paint258_linear_7_1850)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M363.655 357.013L361.186 358.442C361.093 358.495 360.977 358.494 360.884 358.438L358.57 357.037C358.489 356.988 358.49 356.871 358.572 356.824L361.075 355.375C361.156 355.329 361.256 355.33 361.337 355.379L363.657 356.783C363.744 356.836 363.743 356.962 363.655 357.013Z",
    fill: "url(#paint259_linear_7_1850)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M367.679 354.659L365.21 356.088C365.116 356.142 365.001 356.14 364.908 356.084L362.594 354.684C362.512 354.635 362.513 354.517 362.595 354.471L365.099 353.022C365.18 352.976 365.28 352.977 365.361 353.026L367.681 354.43C367.768 354.482 367.767 354.609 367.679 354.659Z",
    fill: "url(#paint260_linear_7_1850)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M371.703 352.306L369.234 353.735C369.14 353.789 369.024 353.787 368.932 353.731L366.617 352.33C366.536 352.281 366.537 352.164 366.619 352.117L369.123 350.669C369.204 350.622 369.304 350.623 369.384 350.672L371.705 352.076C371.792 352.129 371.791 352.255 371.703 352.306Z",
    fill: "url(#paint261_linear_7_1850)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M375.726 349.953L373.258 351.382C373.164 351.435 373.048 351.434 372.956 351.378L370.641 349.977C370.56 349.928 370.561 349.811 370.643 349.764L373.146 348.315C373.228 348.269 373.328 348.27 373.408 348.319L375.729 349.723C375.816 349.776 375.815 349.902 375.726 349.953Z",
    fill: "url(#paint262_linear_7_1850)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M328.035 383.329L325.566 384.758C325.472 384.811 325.356 384.81 325.264 384.754L322.949 383.353C322.868 383.304 322.869 383.187 322.951 383.14L325.455 381.691C325.536 381.645 325.636 381.646 325.716 381.695L328.037 383.099C328.124 383.152 328.123 383.278 328.035 383.329Z",
    fill: "url(#paint263_linear_7_1850)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M332.058 380.975L329.589 382.404C329.496 382.458 329.38 382.456 329.287 382.4L326.973 381C326.892 380.951 326.893 380.833 326.975 380.786L329.478 379.338C329.559 379.292 329.66 379.293 329.74 379.341L332.06 380.746C332.148 380.798 332.147 380.925 332.058 380.975Z",
    fill: "url(#paint264_linear_7_1850)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M336.082 378.622L333.613 380.051C333.52 380.105 333.404 380.103 333.311 380.047L330.997 378.646C330.916 378.597 330.917 378.48 330.999 378.433L333.502 376.984C333.583 376.938 333.684 376.939 333.764 376.988L336.084 378.392C336.172 378.445 336.171 378.571 336.082 378.622Z",
    fill: "url(#paint265_linear_7_1850)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M340.106 376.269L337.637 377.698C337.544 377.751 337.428 377.75 337.335 377.694L335.021 376.293C334.94 376.244 334.941 376.126 335.023 376.08L337.526 374.631C337.607 374.585 337.708 374.586 337.788 374.635L340.108 376.039C340.196 376.092 340.195 376.218 340.106 376.269Z",
    fill: "url(#paint266_linear_7_1850)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M358.849 365.236L341.661 375.344C341.568 375.398 341.452 375.396 341.359 375.34L339.045 373.94C338.964 373.891 338.965 373.773 339.047 373.726L356.269 363.598C356.35 363.552 356.45 363.553 356.531 363.602L358.851 365.006C358.938 365.059 358.937 365.185 358.849 365.236Z",
    fill: "url(#paint267_linear_7_1850)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M348.154 371.562L345.685 372.991C345.591 373.044 345.476 373.043 345.383 372.987L343.069 371.586C342.987 371.537 342.988 371.42 343.07 371.373L345.574 369.924C345.655 369.878 345.755 369.879 345.836 369.928L348.156 371.332C348.243 371.385 348.242 371.511 348.154 371.562Z",
    fill: "url(#paint268_linear_7_1850)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M352.178 369.208L349.709 370.637C349.615 370.691 349.499 370.689 349.407 370.633L347.092 369.233C347.011 369.183 347.012 369.066 347.094 369.019L349.598 367.571C349.679 367.524 349.779 367.526 349.859 367.574L352.18 368.978C352.267 369.031 352.266 369.158 352.178 369.208Z",
    fill: "url(#paint269_linear_7_1850)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M356.202 366.855L353.733 368.284C353.639 368.337 353.523 368.336 353.431 368.28L351.116 366.879C351.035 366.83 351.036 366.713 351.118 366.666L353.621 365.217C353.703 365.171 353.803 365.172 353.883 365.221L356.204 366.625C356.291 366.678 356.29 366.804 356.202 366.855Z",
    fill: "url(#paint270_linear_7_1850)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M360.226 364.502L357.757 365.93C357.663 365.984 357.547 365.982 357.455 365.926L355.14 364.526C355.059 364.477 355.06 364.359 355.142 364.313L357.645 362.864C357.727 362.818 357.827 362.819 357.907 362.868L360.228 364.272C360.315 364.325 360.314 364.451 360.226 364.502Z",
    fill: "url(#paint271_linear_7_1850)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M364.249 362.148L361.781 363.577C361.687 363.631 361.571 363.629 361.479 363.573L359.164 362.172C359.083 362.123 359.084 362.006 359.166 361.959L361.669 360.511C361.75 360.464 361.851 360.465 361.931 360.514L364.252 361.918C364.339 361.971 364.338 362.098 364.249 362.148Z",
    fill: "url(#paint272_linear_7_1850)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M368.273 359.795L365.804 361.224C365.711 361.277 365.595 361.276 365.502 361.22L363.188 359.819C363.107 359.77 363.108 359.653 363.19 359.606L365.693 358.157C365.774 358.111 365.875 358.112 365.955 358.161L368.275 359.565C368.363 359.618 368.362 359.744 368.273 359.795Z",
    fill: "url(#paint273_linear_7_1850)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M372.297 357.441L369.828 358.87C369.735 358.924 369.619 358.922 369.526 358.866L367.212 357.466C367.131 357.417 367.132 357.299 367.214 357.252L369.717 355.804C369.798 355.757 369.899 355.759 369.979 355.807L372.299 357.212C372.386 357.264 372.385 357.391 372.297 357.441Z",
    fill: "url(#paint274_linear_7_1850)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M376.321 355.088L373.852 356.517C373.759 356.57 373.643 356.569 373.55 356.513L371.236 355.112C371.155 355.063 371.156 354.946 371.238 354.899L373.741 353.45C373.822 353.404 373.922 353.405 374.003 353.454L376.323 354.858C376.41 354.911 376.409 355.037 376.321 355.088Z",
    fill: "url(#paint275_linear_7_1850)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M380.345 352.735L377.876 354.164C377.783 354.217 377.667 354.216 377.574 354.159L375.26 352.759C375.179 352.71 375.18 352.592 375.262 352.546L377.765 351.097C377.846 351.051 377.946 351.052 378.027 351.1L380.347 352.505C380.434 352.558 380.433 352.684 380.345 352.735Z",
    fill: "url(#paint276_linear_7_1850)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M308.999 296.256L345.025 275.296C346.013 274.722 346.821 273.444 346.821 272.456C346.821 271.469 346.013 271.131 345.025 271.705L308.999 292.665C308.011 293.24 307.203 294.517 307.203 295.505C307.203 296.492 308.011 296.83 308.999 296.256Z",
    fill: "#CCD3DD"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M308.999 324.815L345.025 303.855C346.013 303.281 346.821 302.003 346.821 301.015C346.821 300.028 346.013 299.69 345.025 300.265L308.999 321.224C308.011 321.799 307.203 323.077 307.203 324.064C307.203 325.051 308.011 325.389 308.999 324.815Z",
    fill: "#CCD3DD"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M281.005 319.663V323.429C281.005 324.933 282.238 325.446 283.742 324.57L345.212 288.809C346.716 287.934 347.946 285.988 347.946 284.485V280.718C347.946 279.214 346.716 278.7 345.212 279.575L283.742 315.337C282.238 316.212 281.005 318.159 281.005 319.663Z",
    fill: "white"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M281.005 319.663V323.429C281.005 324.933 282.238 325.446 283.742 324.57L295.513 317.723V308.489L283.742 315.336C282.238 316.212 281.005 318.159 281.005 319.663Z",
    fill: "#FFD822"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M281.005 348.044V351.81C281.005 353.314 282.238 353.827 283.742 352.952L345.212 317.19C346.716 316.315 347.946 314.37 347.946 312.866V309.1C347.946 307.596 346.716 307.082 345.212 307.956L283.742 343.718C282.238 344.593 281.005 346.54 281.005 348.044Z",
    fill: "white"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M281.005 348.044V351.81C281.005 353.314 282.238 353.827 283.742 352.952L295.513 346.104V336.87L283.742 343.718C282.238 344.593 281.005 346.54 281.005 348.044Z",
    fill: "#FFD822"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M339.948 287.318C339.948 288.081 340.567 288.34 341.33 287.896C342.093 287.452 342.712 286.473 342.712 285.71C342.712 284.946 342.093 284.687 341.33 285.131C340.567 285.575 339.948 286.554 339.948 287.318Z",
    fill: "#525575"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M334.65 290.4C334.65 291.163 335.269 291.422 336.032 290.978C336.795 290.534 337.414 289.555 337.414 288.792C337.414 288.029 336.795 287.77 336.032 288.214C335.269 288.658 334.65 289.636 334.65 290.4Z",
    fill: "#525575"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M329.352 293.482C329.352 294.245 329.971 294.504 330.734 294.06C331.498 293.616 332.116 292.637 332.116 291.874C332.116 291.111 331.498 290.852 330.734 291.296C329.971 291.74 329.352 292.719 329.352 293.482Z",
    fill: "#525575"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M326.276 296.381C326.887 295.567 327.01 294.629 326.552 294.285C326.094 293.941 325.227 294.322 324.617 295.135C324.006 295.949 323.883 296.887 324.341 297.231C324.799 297.574 325.666 297.194 326.276 296.381Z",
    fill: "#525575"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M318.756 299.646C318.756 300.41 319.375 300.669 320.138 300.225C320.901 299.781 321.52 298.802 321.52 298.038C321.52 297.275 320.901 297.016 320.138 297.461C319.375 297.905 318.756 298.883 318.756 299.646Z",
    fill: "#525575"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M313.458 302.729C313.458 303.492 314.077 303.751 314.84 303.307C315.604 302.863 316.222 301.884 316.222 301.121C316.222 300.358 315.604 300.099 314.84 300.543C314.077 300.987 313.458 301.966 313.458 302.729Z",
    fill: "#525575"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M339.948 315.635C339.948 316.399 340.567 316.658 341.33 316.214C342.093 315.77 342.712 314.791 342.712 314.027C342.712 313.264 342.093 313.005 341.33 313.449C340.567 313.894 339.948 314.872 339.948 315.635Z",
    fill: "#525575"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M336.873 318.535C337.483 317.722 337.607 316.784 337.148 316.44C336.69 316.096 335.824 316.476 335.213 317.29C334.603 318.103 334.48 319.041 334.938 319.385C335.396 319.729 336.262 319.349 336.873 318.535Z",
    fill: "#525575"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M329.352 321.8C329.352 322.563 329.971 322.822 330.734 322.378C331.498 321.934 332.116 320.955 332.116 320.192C332.116 319.429 331.498 319.17 330.734 319.614C329.971 320.058 329.352 321.037 329.352 321.8Z",
    fill: "#525575"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M324.054 324.882C324.054 325.646 324.673 325.904 325.436 325.46C326.199 325.016 326.818 324.038 326.818 323.274C326.818 322.511 326.199 322.252 325.436 322.696C324.673 323.14 324.054 324.119 324.054 324.882Z",
    fill: "#525575"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M318.756 327.965C318.756 328.728 319.375 328.987 320.138 328.543C320.901 328.099 321.52 327.12 321.52 326.357C321.52 325.593 320.901 325.335 320.138 325.779C319.375 326.222 318.756 327.201 318.756 327.965Z",
    fill: "#525575"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M313.458 331.047C313.458 331.81 314.077 332.069 314.84 331.625C315.604 331.181 316.222 330.202 316.222 329.439C316.222 328.675 315.604 328.417 314.84 328.861C314.077 329.305 313.458 330.283 313.458 331.047Z",
    fill: "#525575"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M219.195 77.3506V231.448",
    stroke: "#A0A0A0",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M244.355 91.0936V166.236C244.355 173.095 248.018 179.433 253.962 182.856L297.551 207.964C303.642 211.473 307.396 217.968 307.396 224.998V275.627",
    stroke: "#A0A0A0",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M202.654 67.2303V147.691C202.654 154.016 195.755 157.924 190.33 154.672L136.371 122.328C130.97 119.091 124.103 122.981 124.103 129.277V156.4",
    stroke: "#A0A0A0",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M216.726 89.1964C216.73 89.2414 216.733 89.2866 216.742 89.3314C216.748 89.3681 216.759 89.4045 216.769 89.441C216.78 89.484 216.791 89.5268 216.806 89.5693C216.818 89.6043 216.835 89.639 216.85 89.6738C216.869 89.7185 216.889 89.7633 216.912 89.8075C216.945 89.8685 216.981 89.9292 217.022 89.9888C217.029 89.9985 217.036 90.0079 217.043 90.0175C217.085 90.077 217.133 90.1358 217.184 90.1934C217.193 90.2045 217.202 90.2157 217.212 90.2266C217.267 90.2868 217.328 90.3458 217.393 90.4039C217.434 90.4408 217.479 90.4764 217.524 90.5121C217.564 90.544 217.602 90.5764 217.645 90.6075C217.693 90.6424 217.746 90.676 217.798 90.7099C217.852 90.745 217.903 90.7812 217.961 90.8149C218.09 90.8896 218.226 90.9565 218.366 91.0195C218.406 91.0376 218.448 91.0545 218.489 91.0717C218.598 91.1177 218.711 91.1603 218.826 91.1996C218.867 91.2137 218.907 91.2288 218.949 91.2418C219.021 91.2645 219.096 91.2846 219.17 91.3049C219.226 91.3201 219.281 91.3364 219.338 91.3502C219.416 91.3691 219.496 91.385 219.576 91.401C219.63 91.4119 219.683 91.4241 219.737 91.4338C219.898 91.4621 220.06 91.4846 220.225 91.5016C220.275 91.5069 220.326 91.5101 220.377 91.5145C220.473 91.5225 220.57 91.5296 220.666 91.5338C220.728 91.5364 220.791 91.5378 220.853 91.539C220.931 91.5404 221.009 91.5412 221.087 91.5402C221.153 91.5394 221.218 91.5374 221.283 91.5348C221.356 91.532 221.428 91.5282 221.501 91.5231C221.567 91.5185 221.633 91.5129 221.698 91.5067C221.77 91.4998 221.841 91.4918 221.913 91.4828C221.977 91.4745 222.04 91.4655 222.104 91.4557C222.18 91.4438 222.256 91.4306 222.331 91.4161C222.391 91.4049 222.45 91.393 222.509 91.3802C222.599 91.3605 222.687 91.3382 222.775 91.3149C222.824 91.3019 222.874 91.2896 222.922 91.2755C223.079 91.2296 223.233 91.1782 223.382 91.1203C223.456 91.0916 223.527 91.0599 223.599 91.0282C223.635 91.0119 223.673 90.9972 223.709 90.9802C223.817 90.9288 223.923 90.8743 224.024 90.8161C224.869 90.328 225.292 89.6874 225.29 89.0477L225.315 97.9875C225.317 98.6271 224.895 99.2676 224.049 99.756C223.948 99.8144 223.843 99.8688 223.735 99.92C223.699 99.9371 223.661 99.9517 223.624 99.968C223.56 99.9965 223.497 100.026 223.431 100.052C223.423 100.055 223.415 100.057 223.407 100.06C223.259 100.118 223.105 100.169 222.948 100.215C222.935 100.219 222.923 100.224 222.911 100.228C222.875 100.238 222.837 100.245 222.801 100.255C222.713 100.278 222.625 100.3 222.535 100.32C222.511 100.325 222.488 100.332 222.464 100.337C222.429 100.345 222.392 100.349 222.357 100.356C222.282 100.37 222.206 100.384 222.13 100.396C222.099 100.4 222.07 100.407 222.039 100.411C222.006 100.416 221.972 100.418 221.938 100.423C221.867 100.432 221.796 100.44 221.724 100.447C221.69 100.45 221.656 100.455 221.622 100.458C221.59 100.461 221.558 100.461 221.526 100.463C221.454 100.468 221.382 100.472 221.309 100.475C221.273 100.476 221.237 100.48 221.2 100.481C221.171 100.481 221.142 100.48 221.113 100.48C221.034 100.481 220.956 100.481 220.878 100.479C220.839 100.478 220.8 100.48 220.761 100.479C220.738 100.478 220.715 100.475 220.692 100.474C220.595 100.47 220.499 100.463 220.403 100.455C220.364 100.452 220.325 100.451 220.286 100.447C220.274 100.446 220.262 100.443 220.25 100.442C220.086 100.425 219.923 100.402 219.763 100.374C219.755 100.373 219.747 100.372 219.739 100.371C219.693 100.362 219.648 100.351 219.601 100.341C219.522 100.325 219.442 100.309 219.364 100.29C219.307 100.277 219.251 100.26 219.195 100.245C219.121 100.225 219.047 100.205 218.974 100.182C218.959 100.177 218.943 100.174 218.927 100.169C218.901 100.16 218.877 100.149 218.851 100.14C218.736 100.101 218.624 100.058 218.514 100.012C218.473 99.9947 218.432 99.9779 218.392 99.9598C218.252 99.8967 218.115 99.8297 217.987 99.7552C217.969 99.7449 217.952 99.7347 217.935 99.7242C217.895 99.7005 217.861 99.6748 217.824 99.6503C217.772 99.6164 217.718 99.5829 217.67 99.5477C217.627 99.5168 217.589 99.4845 217.55 99.4526C217.505 99.4166 217.459 99.3811 217.418 99.3441C217.41 99.3367 217.4 99.3297 217.392 99.3222C217.337 99.2714 217.286 99.2194 217.238 99.1668C217.228 99.1558 217.219 99.1447 217.209 99.1337C217.181 99.1014 217.152 99.0692 217.126 99.0363C217.105 99.0104 217.087 98.9839 217.068 98.9576C217.062 98.9479 217.054 98.9385 217.048 98.9289C217.014 98.8797 216.982 98.8301 216.953 98.7799C216.947 98.7692 216.944 98.7582 216.938 98.7473C216.914 98.7032 216.895 98.6586 216.875 98.6138C216.864 98.5877 216.849 98.5622 216.839 98.5359C216.835 98.5271 216.834 98.518 216.831 98.5092C216.816 98.4668 216.806 98.4241 216.794 98.3813C216.787 98.3524 216.775 98.3236 216.769 98.2945C216.768 98.2867 216.768 98.2791 216.767 98.2712C216.759 98.2265 216.756 98.1817 216.751 98.1367C216.749 98.1072 216.742 98.0779 216.741 98.0486C216.741 98.0359 216.741 98.0234 216.741 98.0108L216.715 89.0709C216.716 89.1127 216.722 89.1547 216.726 89.1964Z",
    fill: "url(#paint277_linear_7_1850)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M217.98 87.3037C216.301 88.2732 216.293 89.8456 217.961 90.8151C219.631 91.7854 222.344 91.7854 224.024 90.8159C225.704 89.8456 225.713 88.274 224.043 87.3037C222.375 86.3342 219.66 86.3334 217.98 87.3037Z",
    fill: "url(#paint278_linear_7_1850)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M239.555 102.722C239.559 102.767 239.562 102.812 239.571 102.857C239.577 102.893 239.589 102.93 239.598 102.966C239.609 103.009 239.62 103.052 239.635 103.094C239.647 103.129 239.664 103.164 239.679 103.199C239.698 103.244 239.718 103.288 239.742 103.333C239.774 103.394 239.81 103.454 239.851 103.514C239.858 103.524 239.865 103.533 239.872 103.543C239.914 103.602 239.962 103.661 240.013 103.719C240.022 103.73 240.031 103.741 240.041 103.752C240.096 103.812 240.157 103.871 240.222 103.929C240.263 103.966 240.308 104.002 240.353 104.037C240.393 104.069 240.431 104.102 240.474 104.133C240.522 104.168 240.575 104.201 240.627 104.235C240.681 104.27 240.733 104.306 240.791 104.34C240.919 104.415 241.055 104.482 241.195 104.545C241.236 104.563 241.277 104.58 241.318 104.597C241.427 104.643 241.54 104.685 241.655 104.725C241.696 104.739 241.736 104.754 241.778 104.767C241.851 104.79 241.925 104.81 241.999 104.83C242.055 104.845 242.111 104.862 242.167 104.875C242.246 104.894 242.325 104.91 242.405 104.926C242.459 104.937 242.512 104.949 242.566 104.959C242.727 104.987 242.89 105.01 243.054 105.027C243.104 105.032 243.156 105.035 243.206 105.04C243.303 105.048 243.399 105.055 243.496 105.059C243.557 105.062 243.619 105.063 243.682 105.064C243.76 105.066 243.838 105.066 243.916 105.065C243.982 105.064 244.047 105.062 244.113 105.06C244.185 105.057 244.258 105.053 244.33 105.048C244.396 105.043 244.462 105.038 244.527 105.032C244.599 105.025 244.671 105.017 244.742 105.008C244.806 104.999 244.87 104.99 244.933 104.981C245.01 104.969 245.085 104.955 245.16 104.941C245.22 104.93 245.279 104.918 245.338 104.905C245.428 104.885 245.517 104.863 245.605 104.84C245.654 104.827 245.703 104.815 245.751 104.8C245.909 104.755 246.062 104.703 246.211 104.645C246.285 104.617 246.357 104.585 246.428 104.553C246.465 104.537 246.503 104.522 246.538 104.505C246.646 104.454 246.752 104.399 246.853 104.341C247.698 103.853 248.121 103.212 248.119 102.573L248.144 111.513C248.146 112.152 247.724 112.793 246.878 113.281C246.777 113.34 246.672 113.394 246.564 113.445C246.528 113.462 246.49 113.477 246.453 113.493C246.389 113.522 246.326 113.551 246.26 113.577C246.252 113.58 246.244 113.582 246.236 113.585C246.088 113.643 245.934 113.695 245.777 113.741C245.764 113.744 245.753 113.749 245.74 113.753C245.704 113.763 245.666 113.77 245.63 113.78C245.542 113.803 245.454 113.825 245.364 113.845C245.34 113.85 245.317 113.858 245.293 113.862C245.258 113.87 245.221 113.874 245.186 113.881C245.111 113.895 245.035 113.909 244.959 113.921C244.928 113.925 244.899 113.932 244.868 113.937C244.835 113.941 244.801 113.944 244.767 113.948C244.696 113.957 244.625 113.965 244.553 113.972C244.519 113.975 244.486 113.98 244.452 113.983C244.42 113.986 244.387 113.986 244.356 113.988C244.283 113.993 244.211 113.997 244.138 114C244.102 114.001 244.066 114.005 244.029 114.006C244 114.007 243.971 114.005 243.942 114.005C243.864 114.006 243.785 114.006 243.707 114.004C243.668 114.004 243.629 114.005 243.59 114.004C243.567 114.003 243.544 114 243.521 113.999C243.424 113.995 243.328 113.988 243.232 113.98C243.193 113.977 243.154 113.976 243.115 113.972C243.103 113.971 243.091 113.968 243.079 113.967C242.915 113.95 242.752 113.927 242.592 113.899C242.584 113.898 242.576 113.897 242.569 113.896C242.522 113.888 242.477 113.876 242.431 113.866C242.351 113.85 242.271 113.835 242.193 113.816C242.136 113.802 242.081 113.786 242.025 113.77C241.951 113.75 241.876 113.73 241.804 113.707C241.788 113.702 241.772 113.699 241.757 113.694C241.73 113.685 241.707 113.674 241.681 113.665C241.565 113.626 241.453 113.583 241.343 113.537C241.302 113.52 241.261 113.503 241.221 113.485C241.081 113.422 240.945 113.355 240.816 113.28C240.799 113.27 240.781 113.26 240.764 113.249C240.724 113.226 240.691 113.2 240.653 113.175C240.601 113.142 240.548 113.108 240.499 113.073C240.457 113.042 240.419 113.01 240.379 112.978C240.334 112.942 240.289 112.906 240.248 112.869C240.239 112.862 240.229 112.855 240.221 112.847C240.166 112.797 240.115 112.744 240.067 112.692C240.057 112.681 240.048 112.67 240.039 112.659C240.01 112.626 239.981 112.594 239.955 112.561C239.935 112.536 239.917 112.509 239.898 112.483C239.891 112.473 239.884 112.464 239.877 112.454C239.843 112.405 239.811 112.355 239.783 112.305C239.776 112.294 239.773 112.283 239.767 112.272C239.743 112.228 239.724 112.184 239.705 112.139C239.693 112.113 239.678 112.087 239.668 112.061C239.665 112.052 239.663 112.043 239.66 112.034C239.645 111.992 239.635 111.949 239.624 111.906C239.616 111.878 239.605 111.849 239.599 111.82C239.597 111.812 239.598 111.804 239.596 111.796C239.588 111.752 239.585 111.707 239.581 111.662C239.578 111.632 239.571 111.603 239.571 111.574C239.57 111.561 239.57 111.549 239.57 111.536L239.545 102.596C239.545 102.638 239.551 102.68 239.555 102.722Z",
    fill: "url(#paint279_linear_7_1850)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M240.809 100.829C239.13 101.798 239.122 103.371 240.79 104.34C242.46 105.31 245.174 105.31 246.853 104.341C248.533 103.371 248.542 101.799 246.872 100.829C245.204 99.8594 242.489 99.8586 240.809 100.829Z",
    fill: "url(#paint280_linear_7_1850)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M198.618 78.8426C198.622 78.8875 198.626 78.9327 198.634 78.9775C198.641 79.0143 198.652 79.0506 198.661 79.0871C198.673 79.1299 198.683 79.1729 198.698 79.2155C198.711 79.2506 198.727 79.2851 198.742 79.3199C198.762 79.3646 198.781 79.4094 198.805 79.4536C198.838 79.5146 198.873 79.5753 198.914 79.6349C198.921 79.6446 198.928 79.654 198.935 79.6636C198.978 79.7231 199.025 79.7819 199.076 79.8395C199.085 79.8506 199.094 79.8618 199.104 79.8727C199.16 79.9329 199.221 79.9919 199.285 80.05C199.326 80.0869 199.372 80.1225 199.416 80.1582C199.456 80.1901 199.494 80.2225 199.537 80.2536C199.585 80.2885 199.638 80.3221 199.69 80.356C199.744 80.3911 199.796 80.4273 199.854 80.461C199.982 80.5357 200.119 80.6026 200.259 80.6658C200.299 80.6839 200.34 80.7008 200.381 80.718C200.491 80.764 200.603 80.8066 200.718 80.846C200.759 80.86 200.8 80.8751 200.841 80.8881C200.914 80.911 200.988 80.9309 201.062 80.9512C201.118 80.9664 201.174 80.9827 201.231 80.9965C201.309 81.0154 201.388 81.0313 201.468 81.0474C201.522 81.0582 201.575 81.0704 201.629 81.0801C201.79 81.1084 201.953 81.1309 202.117 81.148C202.168 81.1532 202.219 81.1566 202.27 81.1608C202.366 81.1688 202.462 81.1759 202.559 81.1801C202.621 81.1827 202.683 81.1841 202.745 81.1853C202.823 81.1867 202.901 81.1873 202.979 81.1863C203.045 81.1855 203.11 81.1835 203.176 81.1809C203.248 81.1781 203.321 81.1743 203.393 81.1692C203.459 81.1646 203.525 81.1592 203.591 81.1528C203.662 81.1457 203.734 81.1379 203.805 81.1289C203.869 81.1206 203.933 81.1116 203.996 81.1018C204.073 81.0899 204.148 81.0767 204.224 81.0622C204.283 81.051 204.342 81.0391 204.401 81.0263C204.491 81.0066 204.58 80.9843 204.668 80.961C204.717 80.948 204.766 80.9357 204.814 80.9217C204.972 80.8757 205.125 80.8243 205.274 80.7664C205.348 80.7377 205.42 80.706 205.491 80.6743C205.528 80.658 205.565 80.6431 205.601 80.6263C205.709 80.5749 205.815 80.5205 205.916 80.4622C206.761 79.9741 207.184 79.3335 207.182 78.694L207.207 87.6338C207.209 88.2734 206.787 88.9139 205.941 89.4023C205.84 89.4607 205.735 89.5151 205.627 89.5663C205.591 89.5834 205.553 89.5981 205.516 89.6143C205.452 89.6428 205.389 89.6723 205.323 89.6984C205.315 89.7015 205.307 89.7035 205.299 89.7065C205.151 89.7645 204.997 89.8157 204.84 89.8617C204.827 89.8653 204.815 89.8705 204.803 89.8741C204.767 89.8844 204.729 89.8914 204.693 89.9011C204.605 89.9244 204.517 89.9466 204.427 89.9663C204.403 89.9715 204.38 89.9788 204.356 89.9836C204.321 89.9908 204.284 89.9954 204.249 90.0023C204.174 90.0165 204.098 90.03 204.022 90.0418C203.991 90.0466 203.962 90.0533 203.931 90.0577C203.898 90.0623 203.864 90.0647 203.83 90.0689C203.759 90.078 203.688 90.086 203.616 90.0928C203.582 90.096 203.549 90.1015 203.515 90.1043C203.483 90.1069 203.45 90.1073 203.419 90.1095C203.346 90.1145 203.274 90.1183 203.201 90.1211C203.165 90.1225 203.129 90.126 203.092 90.127C203.063 90.1278 203.034 90.1262 203.005 90.1266C202.927 90.1276 202.848 90.127 202.77 90.1256C202.731 90.1248 202.692 90.1264 202.653 90.125C202.63 90.1242 202.607 90.1213 202.584 90.1203C202.487 90.1161 202.391 90.1091 202.295 90.1011C202.256 90.0978 202.217 90.097 202.178 90.0932C202.166 90.092 202.155 90.0894 202.142 90.0882C201.978 90.0709 201.815 90.0487 201.655 90.0203C201.647 90.0189 201.639 90.0185 201.632 90.0171C201.585 90.0087 201.54 89.997 201.494 89.9876C201.414 89.9715 201.334 89.9557 201.256 89.9368C201.199 89.9229 201.144 89.9067 201.088 89.8914C201.014 89.8711 200.939 89.8513 200.867 89.8284C200.851 89.8236 200.835 89.8199 200.82 89.8149C200.793 89.8065 200.77 89.795 200.744 89.7862C200.628 89.747 200.516 89.7045 200.406 89.6583C200.365 89.641 200.324 89.6244 200.284 89.6061C200.144 89.5428 200.008 89.476 199.879 89.4015C199.862 89.3912 199.844 89.381 199.827 89.3705C199.787 89.3468 199.754 89.3211 199.716 89.2967C199.664 89.2627 199.611 89.2292 199.562 89.194C199.52 89.1631 199.482 89.1308 199.442 89.0989C199.397 89.0629 199.352 89.0274 199.311 88.9904C199.302 88.983 199.292 88.976 199.284 88.9685C199.229 88.9175 199.178 88.8657 199.13 88.8131C199.12 88.8021 199.111 88.791 199.102 88.78C199.073 88.7477 199.044 88.7155 199.018 88.6826C198.998 88.6567 198.98 88.6302 198.961 88.6039C198.954 88.5942 198.946 88.5848 198.94 88.5752C198.906 88.526 198.874 88.4764 198.845 88.4262C198.839 88.4155 198.836 88.4045 198.83 88.3936C198.806 88.3495 198.787 88.3049 198.768 88.2601C198.756 88.234 198.741 88.2085 198.731 88.1822C198.728 88.1734 198.726 88.1643 198.723 88.1555C198.708 88.1131 198.698 88.0704 198.687 88.0276C198.679 87.9987 198.668 87.97 198.662 87.9408C198.66 87.933 198.661 87.9254 198.659 87.9176C198.651 87.8728 198.648 87.828 198.644 87.783C198.641 87.7535 198.634 87.7242 198.634 87.6947C198.633 87.682 198.633 87.6696 198.633 87.6569L198.608 78.7171C198.608 78.7588 198.615 78.8008 198.618 78.8426Z",
    fill: "url(#paint281_linear_7_1850)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M199.872 76.9498C198.193 77.9193 198.186 79.4918 199.854 80.4612C201.523 81.4315 204.237 81.4315 205.916 80.462C207.596 79.4918 207.605 77.9201 205.936 76.9498C204.268 75.9804 201.553 75.9796 199.872 76.9498Z",
    fill: "url(#paint282_linear_7_1850)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M208.172 11.3944C207.653 11.1964 207.143 11.03 206.637 10.8802C206.554 10.8555 206.47 10.8288 206.388 10.8055C206.325 10.7878 206.261 10.7659 206.199 10.7488C205.781 10.6354 205.371 10.5444 204.964 10.4639C204.87 10.4454 204.779 10.4296 204.686 10.4129C204.54 10.3866 204.392 10.3547 204.248 10.3324C204.092 10.3085 203.944 10.3059 203.789 10.2866C203.499 10.2509 203.211 10.2193 202.928 10.2009C202.825 10.194 202.716 10.1739 202.614 10.1695C202.46 10.1627 202.315 10.1752 202.164 10.1733C201.935 10.1709 201.708 10.1701 201.485 10.1792C201.388 10.183 201.286 10.1758 201.191 10.1818C201.021 10.1926 200.86 10.2225 200.694 10.24C200.503 10.2599 200.312 10.278 200.126 10.3065C200.053 10.3177 199.977 10.3199 199.905 10.3324C199.699 10.3681 199.504 10.4245 199.304 10.4707C199.152 10.5059 198.996 10.5346 198.847 10.576C198.806 10.5872 198.763 10.5928 198.723 10.6047C198.427 10.6906 198.143 10.7986 197.86 10.9089C197.79 10.936 197.717 10.9553 197.648 10.9838C197.64 10.9872 197.631 10.9892 197.622 10.9926C197.267 11.1416 196.922 11.3101 196.589 11.4976C196.552 11.5185 196.515 11.5396 196.478 11.5611L192.958 13.6068C192.821 13.6759 192.677 13.7339 192.544 13.8092C192.507 13.8301 192.47 13.8512 192.433 13.8727L171.842 25.839C171.844 25.838 171.846 25.8368 171.848 25.8358L171.842 25.839C172.217 25.6213 172.608 25.4296 173.012 25.2615C173.08 25.2334 173.153 25.2145 173.221 25.1878C173.544 25.0623 173.872 24.9481 174.211 24.8541C174.36 24.8127 174.516 24.784 174.668 24.7487C174.938 24.6862 175.21 24.6274 175.49 24.5844C175.676 24.5559 175.867 24.5378 176.058 24.5179C176.318 24.4906 176.581 24.4679 176.849 24.4571C177.072 24.4481 177.299 24.4489 177.527 24.4511C177.779 24.4539 178.034 24.4615 178.293 24.4786C178.576 24.4971 178.864 24.5286 179.154 24.5643C179.451 24.6011 179.746 24.6356 180.05 24.6904C180.143 24.7071 180.235 24.723 180.328 24.7414C180.795 24.834 181.27 24.9469 181.752 25.083C181.835 25.1065 181.918 25.1332 182.001 25.1579C182.507 25.3077 183.017 25.4742 183.536 25.6721L187.539 23.3459C187.553 23.3511 187.567 23.3555 187.581 23.3607L208.172 11.3944Z",
    fill: "url(#paint283_linear_7_1850)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M240.918 12.8368C240.521 12.3811 240.117 11.9342 239.706 11.4958C239.569 11.3488 239.426 11.2089 239.287 11.0639C239.011 10.7765 238.736 10.488 238.455 10.2093C238.443 10.197 238.431 10.1838 238.418 10.1715C238.38 10.1334 238.339 10.099 238.3 10.0611C237.792 9.56231 237.274 9.08119 236.749 8.61191C236.604 8.4826 236.459 8.35389 236.314 8.22698C235.739 7.72679 235.158 7.23924 234.566 6.7782C234.538 6.75591 234.508 6.73583 234.48 6.71374C233.913 6.27459 233.337 5.86014 232.756 5.45995C232.601 5.35332 232.446 5.2479 232.29 5.14409C231.677 4.73526 231.059 4.34088 230.432 3.97924C229.918 3.68226 229.409 3.41358 228.903 3.15817C228.764 3.08809 228.626 3.02142 228.488 2.95455C228.075 2.75436 227.665 2.56741 227.259 2.39492C227.187 2.3646 227.113 2.32585 227.042 2.29633C227.013 2.28428 226.984 2.27545 226.955 2.2636C226.521 2.08589 226.091 1.92184 225.666 1.77545C225.612 1.75698 225.56 1.74312 225.507 1.72505C225.135 1.60035 224.767 1.4867 224.403 1.3857C224.364 1.37485 224.324 1.35999 224.285 1.34935C224.124 1.30578 223.967 1.27265 223.807 1.23369C223.653 1.19574 223.497 1.15478 223.343 1.12124C223.133 1.07506 222.925 1.03831 222.717 1.00016C222.573 0.973855 222.428 0.943334 222.285 0.920844C222.262 0.91723 222.238 0.911406 222.214 0.907993C221.911 0.861407 221.61 0.82446 221.313 0.795143C221.256 0.789521 221.199 0.787713 221.142 0.782693C220.922 0.763617 220.703 0.744942 220.487 0.735304C220.458 0.734099 220.431 0.737112 220.402 0.736108C219.949 0.718638 219.506 0.722854 219.072 0.746749C219.037 0.748557 219 0.745345 218.966 0.747554C218.899 0.75177 218.837 0.765023 218.771 0.770244C218.436 0.796348 218.108 0.8347 217.785 0.885503C217.721 0.895342 217.654 0.897149 217.592 0.907993C217.558 0.913816 217.526 0.924659 217.493 0.930683C217.11 1.00016 216.736 1.0847 216.371 1.18891C216.358 1.19293 216.343 1.19454 216.329 1.19855C216.279 1.21301 216.233 1.2349 216.184 1.24996C215.884 1.34132 215.592 1.44453 215.306 1.55919C215.256 1.57907 215.203 1.59232 215.154 1.6128C215.102 1.63469 215.054 1.66421 215.002 1.6869C214.73 1.80617 214.463 1.93629 214.203 2.07726C214.153 2.10456 214.099 2.12464 214.049 2.15256C214.01 2.17464 213.971 2.19713 213.932 2.21982L210.418 4.26197C210.332 4.30534 210.243 4.34289 210.159 4.38847C210.108 4.41578 210.054 4.43586 210.004 4.46377C209.965 4.48586 209.926 4.50835 209.887 4.53104L189.296 16.4974C189.384 16.4462 189.477 16.4036 189.567 16.355C189.827 16.2138 190.093 16.0835 190.366 15.964C190.467 15.9203 190.567 15.8775 190.669 15.8367C190.956 15.7219 191.248 15.6185 191.548 15.5271C191.611 15.5078 191.671 15.4845 191.735 15.4662C192.099 15.362 192.474 15.2777 192.857 15.208C192.953 15.1905 193.051 15.1779 193.148 15.1628C193.471 15.112 193.8 15.0737 194.135 15.0476C194.235 15.0397 194.334 15.0295 194.435 15.0241C194.869 15.0002 195.313 14.9958 195.765 15.0132C196.009 15.0227 196.256 15.0381 196.505 15.0598C196.562 15.0648 196.619 15.0667 196.677 15.0723C196.997 15.1036 197.321 15.1464 197.648 15.198C197.791 15.2205 197.937 15.251 198.081 15.2773C198.288 15.3152 198.496 15.3522 198.707 15.3982C198.86 15.4317 199.016 15.4727 199.171 15.5106C199.368 15.559 199.566 15.6072 199.766 15.6626C200.131 15.7636 200.499 15.8773 200.87 16.002C200.923 16.0199 200.976 16.0339 201.03 16.0524C201.455 16.1988 201.885 16.363 202.318 16.5405C202.419 16.5817 202.521 16.6291 202.622 16.6721C203.028 16.8445 203.438 17.0315 203.851 17.2317C203.99 17.2986 204.127 17.3654 204.266 17.4355C204.772 17.6909 205.281 17.9594 205.796 18.2566C206.422 18.6182 207.04 19.0128 207.654 19.4214C207.809 19.5252 207.965 19.6307 208.119 19.7373C208.7 20.1375 209.276 20.5519 209.843 20.9911C209.872 21.0132 209.901 21.0332 209.929 21.0555C210.521 21.5166 211.102 22.0043 211.677 22.5043C211.823 22.6312 211.968 22.7599 212.112 22.8892C212.637 23.3583 213.155 23.8396 213.664 24.3384C213.715 24.3886 213.767 24.436 213.818 24.4864C214.1 24.7653 214.375 25.0539 214.65 25.341C214.79 25.4858 214.932 25.626 215.07 25.7729C215.48 26.2113 215.885 26.6583 216.282 27.1139L220.303 24.7768C220.311 24.7854 220.319 24.7938 220.326 24.8025L240.918 12.8368Z",
    fill: "url(#paint284_linear_7_1850)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M301.084 85.7093C301.07 85.5009 301.041 85.2889 301.023 85.0794C300.989 84.6983 300.961 84.319 300.911 83.9343C300.906 83.8915 300.898 83.8481 300.892 83.8051C300.878 83.7017 300.86 83.5977 300.845 83.4939C300.775 83.0031 300.692 82.5102 300.598 82.0152C300.57 81.8682 300.543 81.7218 300.513 81.5747C300.491 81.468 300.474 81.3624 300.451 81.2556C300.406 81.0439 300.344 80.8305 300.295 80.6182C300.201 80.217 300.107 79.816 299.999 79.4132C299.97 79.3078 299.95 79.2034 299.921 79.098C299.858 78.8719 299.781 78.6452 299.714 78.4189C299.619 78.1016 299.526 77.7849 299.423 77.4675C299.388 77.3606 299.361 77.2538 299.325 77.147C299.238 76.8872 299.138 76.6279 299.045 76.3681C298.951 76.101 298.859 75.8344 298.758 75.5677C298.727 75.4854 298.701 75.4026 298.669 75.3203C298.54 74.9844 298.396 74.6504 298.258 74.3155C298.173 74.1085 298.093 73.9009 298.004 73.6944C297.986 73.6521 297.97 73.6093 297.952 73.5669C297.703 72.993 297.441 72.4212 297.167 71.8525C297.166 71.8495 297.164 71.8465 297.162 71.8432C297.145 71.8075 297.126 71.7724 297.108 71.7368C296.85 71.2049 296.583 70.675 296.304 70.1495C296.28 70.1037 296.253 70.0591 296.228 70.0133C296.112 69.7973 295.989 69.5846 295.869 69.3698C295.697 69.0587 295.529 68.7455 295.35 68.4373C295.303 68.3575 295.252 68.28 295.205 68.2005C295.05 67.9379 294.888 67.6792 294.727 67.419C294.578 67.1764 294.436 66.9305 294.282 66.6903C294.22 66.5931 294.152 66.4993 294.089 66.4028C293.895 66.1038 293.695 65.8096 293.494 65.5146C293.352 65.3052 293.217 65.0911 293.071 64.8841C293.006 64.7913 292.936 64.7032 292.87 64.611C292.618 64.257 292.358 63.9102 292.097 63.5632C291.953 63.3715 291.816 63.1731 291.669 62.9837C291.621 62.9209 291.567 62.8626 291.518 62.8C291.011 62.1522 290.493 61.5155 289.957 60.8984C289.948 60.888 289.94 60.8767 289.931 60.8663C289.931 60.8663 289.928 60.8635 289.927 60.8619C289.915 60.8482 289.902 60.8354 289.89 60.8217C289.465 60.3338 289.029 59.8587 288.586 59.3924C288.442 59.2406 288.295 59.094 288.15 58.9448C287.95 58.7402 287.754 58.5308 287.551 58.331C287.346 58.128 287.138 57.9276 286.93 57.7296L282.91 60.0655C282.901 60.0575 282.893 60.049 282.885 60.041L262.293 72.0073C262.708 72.4007 263.113 72.8113 263.516 73.2244C263.66 73.3728 263.807 73.5187 263.95 73.6695C264.394 74.138 264.832 74.6151 265.26 75.1055C265.27 75.1169 265.28 75.1277 265.29 75.1392C265.302 75.153 265.313 75.1677 265.325 75.1816C265.859 75.7968 266.376 76.4315 266.882 77.0771C267.08 77.3293 267.27 77.5876 267.463 77.8438C267.723 78.1894 267.982 78.5353 268.234 78.8881C268.446 79.1869 268.653 79.4901 268.859 79.7936C269.059 80.0879 269.26 80.3821 269.453 80.6805C269.672 81.017 269.883 81.358 270.093 81.6992C270.252 81.958 270.414 82.2158 270.568 82.4773C270.798 82.8658 271.018 83.259 271.236 83.6523C271.354 83.8652 271.477 84.076 271.592 84.2903C271.897 84.8594 272.19 85.4326 272.47 86.0093C272.488 86.0469 272.509 86.084 272.527 86.1218C272.823 86.7356 273.102 87.3537 273.369 87.9736C273.457 88.1778 273.536 88.3832 273.62 88.588C273.793 89.0073 273.964 89.4268 274.123 89.8476C274.223 90.1121 274.314 90.3772 274.408 90.642C274.539 91.0105 274.668 91.3788 274.788 91.7474C274.89 92.0633 274.984 92.3787 275.077 92.6944C275.176 93.0271 275.274 93.3596 275.363 93.692C275.471 94.094 275.566 94.495 275.659 94.8958C275.733 95.215 275.812 95.5349 275.877 95.853C275.907 96 275.934 96.1464 275.962 96.2929C276.056 96.7881 276.139 97.2813 276.209 97.772C276.224 97.8757 276.243 97.9799 276.256 98.0831C276.313 98.509 276.349 98.9299 276.386 99.3513C276.405 99.5632 276.434 99.7774 276.448 99.9881C276.49 100.611 276.512 101.228 276.51 101.838C276.493 107.856 274.327 112.088 270.801 114.138L275.516 111.397C275.298 111.549 275.075 111.693 274.846 111.826L295.437 99.8602C296.539 99.2198 297.508 98.3662 298.32 97.3116C300.107 94.9914 301.135 91.698 301.146 87.5603C301.148 86.9499 301.125 86.3322 301.084 85.7093Z",
    fill: "url(#paint285_linear_7_1850)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M287.146 52.0477C287.137 51.8897 287.127 51.7317 287.115 51.573C287.069 50.9325 287.01 50.2887 286.927 49.6391C286.926 49.6343 286.926 49.6297 286.925 49.6249C286.913 49.5243 286.894 49.4225 286.88 49.3217C286.825 48.9231 286.768 48.5239 286.7 48.1227C286.668 47.9377 286.63 47.7516 286.595 47.5661C286.536 47.2422 286.476 46.9183 286.408 46.5928C286.4 46.5534 286.394 46.5143 286.386 46.4749C286.372 46.4101 286.352 46.3446 286.338 46.2797C286.174 45.5287 285.99 44.7755 285.783 44.0205C285.771 43.9757 285.763 43.9314 285.75 43.8866C285.745 43.8689 285.739 43.851 285.734 43.8334C285.544 43.1521 285.333 42.4699 285.109 41.7878C285.085 41.7117 285.065 41.6358 285.04 41.5599C285.01 41.4708 284.974 41.3818 284.944 41.2926C284.746 40.7089 284.538 40.1258 284.316 39.5433C284.296 39.4899 284.279 39.436 284.258 39.3824C284.253 39.3682 284.246 39.3539 284.241 39.3397C284.002 38.7194 283.746 38.1011 283.482 37.4843C283.454 37.4208 283.431 37.357 283.404 37.2935C283.359 37.1893 283.307 37.0865 283.261 36.9825C283.053 36.509 282.837 36.0371 282.613 35.5666C282.564 35.4628 282.52 35.3578 282.47 35.254C282.444 35.201 282.416 35.1487 282.39 35.0957C282.097 34.4925 281.794 33.8923 281.478 33.2962C281.466 33.2731 281.455 33.2496 281.442 33.2263C281.402 33.1498 281.357 33.0753 281.316 32.999C281.037 32.4805 280.75 31.9659 280.455 31.454C280.404 31.3661 280.358 31.2759 280.306 31.1882C280.262 31.1118 280.213 31.038 280.168 30.9619C279.803 30.3428 279.431 29.7273 279.043 29.1205C279.041 29.1177 279.039 29.1145 279.037 29.1117C279.03 29.0998 279.021 29.0882 279.014 29.0763C278.608 28.4438 278.187 27.8211 277.759 27.2041C277.704 27.1247 277.653 27.0426 277.597 26.9637C277.556 26.9051 277.511 26.8495 277.47 26.791C276.999 26.125 276.515 25.4687 276.018 24.8244C275.985 24.7816 275.955 24.7366 275.922 24.6941C275.877 24.6362 275.828 24.5826 275.783 24.525C275.194 23.7714 274.589 23.0328 273.967 22.3142C273.939 22.2822 273.914 22.2479 273.887 22.216C273.802 22.1184 273.713 22.026 273.628 21.929C273.324 21.5849 273.018 21.2449 272.707 20.91C272.565 20.7562 272.422 20.6029 272.278 20.4511C271.951 20.1068 271.62 19.7688 271.287 19.4353C271.2 19.3487 271.116 19.2574 271.029 19.1716C270.994 19.1369 270.958 19.1038 270.922 19.069C270.785 18.9349 270.646 18.8046 270.508 18.6722C270.278 18.4524 270.049 18.2329 269.816 18.0184C269.664 17.8783 269.51 17.7415 269.357 17.6038C269.134 17.403 268.91 17.2036 268.685 17.008C268.525 16.8699 268.365 16.7339 268.204 16.5982C267.979 16.4088 267.754 16.2221 267.527 16.0379C267.364 15.9058 267.201 15.7747 267.037 15.6454C266.807 15.4643 266.576 15.2869 266.344 15.1114C266.181 14.988 266.019 14.8641 265.854 14.7434C265.613 14.5659 265.37 14.3938 265.126 14.2227C264.97 14.1127 264.814 14.0008 264.656 13.8936C264.386 13.7088 264.113 13.5315 263.84 13.3548C263.707 13.2693 263.576 13.1805 263.444 13.0968C263.036 12.8404 262.627 12.5916 262.215 12.3536C261.643 12.0233 261.077 11.7245 260.514 11.4406C260.359 11.3623 260.205 11.2878 260.051 11.2131C259.591 10.9904 259.135 10.7826 258.683 10.5906C258.604 10.5569 258.522 10.5139 258.443 10.4812C258.41 10.4677 258.379 10.4581 258.347 10.4448C257.864 10.247 257.385 10.0641 256.912 9.90127C256.849 9.87958 256.787 9.86311 256.724 9.84203C256.314 9.70448 255.907 9.57898 255.505 9.46754C255.461 9.45529 255.415 9.43842 255.371 9.42637C255.194 9.37838 255.02 9.34203 254.845 9.29906C254.672 9.25669 254.498 9.21111 254.327 9.17376C254.092 9.12236 253.861 9.0814 253.63 9.03903C253.47 9.00991 253.309 8.97618 253.151 8.95128C253.123 8.94686 253.095 8.94023 253.068 8.93602C252.731 8.88441 252.398 8.84345 252.068 8.81112C252.009 8.8053 251.952 8.80369 251.893 8.79847C251.642 8.77638 251.391 8.7555 251.144 8.74445C251.112 8.74305 251.083 8.74646 251.051 8.74526C250.549 8.72598 250.058 8.7312 249.576 8.75791C249.537 8.76012 249.496 8.7565 249.457 8.75891C249.383 8.76353 249.314 8.77859 249.24 8.78421C248.869 8.81333 248.503 8.8561 248.144 8.91252C248.074 8.92357 248 8.92558 247.93 8.93762C247.892 8.94405 247.858 8.9561 247.821 8.96292C247.396 9.04023 246.98 9.13401 246.575 9.25007C246.559 9.25449 246.543 9.2565 246.528 9.26091C246.472 9.27718 246.421 9.30107 246.366 9.31814C246.034 9.41954 245.709 9.5342 245.391 9.66151C245.336 9.6836 245.277 9.69826 245.222 9.72115C245.164 9.74544 245.111 9.77837 245.053 9.80368C244.751 9.9358 244.457 10.0798 244.169 10.2358C244.112 10.2663 244.051 10.289 243.995 10.3203C243.951 10.3454 243.907 10.3709 243.862 10.3966L240.362 12.431C240.283 12.4711 240.201 12.5052 240.124 12.5472C240.067 12.5777 240.006 12.6004 239.951 12.6318C239.906 12.6569 239.862 12.6824 239.817 12.7081L219.226 24.6744C219.326 24.6165 219.431 24.5684 219.533 24.5135C219.82 24.3577 220.115 24.2135 220.417 24.0814C220.529 24.0326 220.642 23.9848 220.755 23.9392C221.073 23.8119 221.398 23.6973 221.729 23.5959C221.8 23.5744 221.867 23.5483 221.938 23.528C222.343 23.4121 222.76 23.3184 223.184 23.2409C223.291 23.2214 223.4 23.2075 223.508 23.1905C223.867 23.1338 224.232 23.0913 224.604 23.0621C224.716 23.0533 224.827 23.0421 224.94 23.0358C225.422 23.0091 225.913 23.0039 226.415 23.0232C226.692 23.0338 226.973 23.0515 227.257 23.0762C227.316 23.0814 227.373 23.083 227.432 23.0889C227.788 23.1238 228.149 23.1714 228.514 23.2288C228.672 23.2537 228.834 23.2874 228.994 23.3166C229.225 23.3587 229.456 23.3999 229.69 23.4511C229.862 23.4884 230.036 23.5342 230.209 23.5766C230.428 23.6302 230.647 23.6836 230.869 23.7451C231.271 23.8565 231.677 23.982 232.088 24.1196C232.151 24.1406 232.212 24.1571 232.275 24.1788C232.749 24.3417 233.228 24.5246 233.71 24.7224C233.822 24.768 233.935 24.8208 234.047 24.8681C234.499 25.0601 234.955 25.2679 235.414 25.4906C235.569 25.5653 235.723 25.64 235.878 25.7181C236.44 26.0021 237.006 26.3009 237.579 26.6312C237.991 26.8691 238.4 27.1179 238.807 27.3743C238.94 27.4579 239.071 27.5468 239.203 27.6324C239.476 27.8091 239.749 27.9864 240.02 28.1711C240.177 28.2785 240.333 28.3902 240.49 28.5002C240.733 28.6715 240.976 28.8436 241.218 29.0209C241.382 29.1416 241.545 29.2655 241.708 29.389C241.94 29.5645 242.171 29.7418 242.401 29.9229C242.565 30.0522 242.728 30.1833 242.891 30.3155C243.117 30.4996 243.343 30.6863 243.567 30.8755C243.728 31.011 243.889 31.147 244.048 31.2853C244.274 31.4809 244.498 31.6803 244.721 31.8811C244.874 32.0189 245.027 32.1558 245.179 32.2958C245.412 32.5104 245.642 32.7297 245.872 32.9496C246.01 33.0819 246.149 33.2122 246.286 33.3462C246.409 33.4662 246.528 33.5907 246.65 33.7124C246.984 34.0459 247.315 34.3841 247.641 34.7283C247.785 34.8801 247.928 35.0333 248.071 35.1869C248.381 35.5218 248.688 35.862 248.991 36.206C249.104 36.3343 249.219 36.4614 249.331 36.5911C249.953 37.3096 250.558 38.0485 251.147 38.8017C251.225 38.9017 251.304 39.0005 251.382 39.1011C251.879 39.7457 252.363 40.4027 252.835 41.069C252.931 41.2051 253.026 41.3422 253.121 41.4792C253.55 42.0967 253.972 42.7201 254.377 43.3531C254.387 43.3679 254.397 43.3824 254.407 43.397C254.794 44.0039 255.167 44.6193 255.532 45.2384C255.628 45.402 255.724 45.5663 255.819 45.7305C256.114 46.2422 256.401 46.757 256.68 47.2753C256.733 47.3747 256.789 47.4729 256.842 47.5725C257.158 48.1685 257.461 48.7689 257.754 49.3721C257.83 49.5287 257.903 49.6859 257.977 49.8429C258.201 50.3132 258.417 50.7853 258.625 51.2588C258.699 51.4259 258.774 51.5929 258.846 51.7604C259.111 52.3773 259.366 52.9957 259.605 53.6158C259.631 53.6835 259.654 53.7515 259.68 53.8192C259.902 54.4015 260.11 54.985 260.308 55.5688C260.364 55.7338 260.42 55.8989 260.474 56.0639C260.697 56.7461 260.909 57.4282 261.098 58.1095C261.116 58.172 261.13 58.2342 261.147 58.2967C261.355 59.0517 261.538 59.8053 261.702 60.5559C261.725 60.6603 261.751 60.7649 261.772 60.8691C261.841 61.1944 261.9 61.5183 261.96 61.8424C261.994 62.0279 262.033 62.2141 262.064 62.399C262.132 62.8002 262.19 63.1994 262.244 63.598C262.259 63.7036 262.278 63.81 262.291 63.9155C262.375 64.5651 262.433 65.2088 262.48 65.8494C262.491 66.008 262.501 66.166 262.511 66.3241C262.548 66.9658 262.573 67.6042 262.571 68.2343C262.567 69.5632 262.468 70.8184 262.294 72.0059L266.343 69.6525C266.341 69.6662 266.341 69.6809 266.339 69.6945L286.93 57.7282C287.104 56.5404 287.204 55.2854 287.207 53.9565C287.209 53.328 287.183 52.6895 287.146 52.0477Z",
    fill: "url(#paint286_linear_7_1850)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M262.293 72.0073C262.467 70.8198 262.567 69.5646 262.571 68.2357C262.613 53.2501 251.424 34.626 237.578 26.6322C228.608 21.4537 220.733 22.0103 216.282 27.1143C213.153 23.523 209.585 20.4447 205.796 18.2572C194.657 11.8263 185.386 15.2327 183.536 25.6721C173.676 21.9119 166.173 26.9034 166.141 38.1164C166.105 50.7319 175.525 66.4082 187.181 73.1376L255.34 112.489C266.996 119.219 276.474 114.453 276.51 101.837C276.538 91.8187 270.588 79.8693 262.293 72.0073Z",
    fill: "url(#paint287_linear_7_1850)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M269.99 109.867C268.921 110.937 267.404 111.656 265.265 111.656C262.913 111.656 260.152 110.781 257.274 109.128L189.125 69.7746C178.742 63.7861 169.993 49.2813 170.031 38.1208C170.031 35.3015 170.712 28.8852 176.603 28.3601C174.328 30.5962 173.998 34.3682 173.998 36.3708C173.959 47.5313 182.708 62.0167 193.091 68.0053L261.24 107.359C264.118 109.031 266.879 109.906 269.232 109.906C269.504 109.906 269.757 109.887 269.99 109.867Z",
    fill: "#33626D"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M272.615 101.818C272.615 103.82 272.284 107.631 269.99 109.867C269.757 109.887 269.504 109.906 269.232 109.906C266.879 109.906 264.118 109.031 261.241 107.359L193.091 68.0054C182.708 62.0167 173.959 47.5313 173.998 36.3708C173.998 34.3682 174.328 30.5962 176.603 28.3601C176.856 28.3406 177.109 28.3211 177.381 28.3211C178.839 28.3211 180.434 28.6516 182.145 29.2934L186.539 30.9849L187.083 27.9129L190.505 29.2155L191.322 24.5878C191.672 22.6435 192.43 20.4658 194.025 18.9686C194.394 18.9104 194.783 18.8909 195.191 18.8909C197.758 18.8909 200.752 19.8242 203.843 21.613C207.129 23.5184 210.415 26.2988 213.351 29.6625L216.287 33.0263L219.029 29.8765L220.254 31.2763L223.17 27.9127C223.462 27.582 223.753 27.2904 224.084 27.0376C224.629 26.9404 225.192 26.9014 225.795 26.9014C228.712 26.9014 232.114 27.9709 235.633 29.993C248.174 37.2258 258.732 54.7445 258.693 68.2188C258.674 69.3077 258.596 70.3965 258.441 71.4463L258.149 73.4296L259.627 74.8296C267.307 82.102 272.654 93.204 272.615 101.818Z",
    fill: "url(#paint288_linear_7_1850)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M190.506 29.2157L186.539 30.9849L187.083 27.9129L187.356 26.3575C187.92 23.1882 189.553 19.5134 194.025 18.9688C192.43 20.466 191.672 22.6437 191.322 24.588L190.506 29.2157Z",
    fill: "#33626D"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M220.254 31.2767L216.287 33.0267L219.029 29.8769L219.204 29.6631C220.468 28.2243 222.101 27.3492 224.084 27.0382C223.754 27.291 223.462 27.5826 223.17 27.9133L220.254 31.2767Z",
    fill: "#33626D"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0417,
    d: "M352.734 394.414C381.172 394.414 404.227 381.498 404.227 365.566C404.227 349.634 381.172 336.718 352.734 336.718C324.295 336.718 301.241 349.634 301.241 365.566C301.241 381.498 324.295 394.414 352.734 394.414Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0833,
    d: "M352.734 393.848C380.615 393.848 403.217 381.186 403.217 365.566C403.217 349.946 380.615 337.284 352.734 337.284C324.853 337.284 302.251 349.946 302.251 365.566C302.251 381.186 324.853 393.848 352.734 393.848Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M352.734 393.282C380.057 393.282 402.207 380.873 402.207 365.566C402.207 350.259 380.057 337.85 352.734 337.85C325.411 337.85 303.261 350.259 303.261 365.566C303.261 380.873 325.411 393.282 352.734 393.282Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1667,
    d: "M352.734 392.716C379.499 392.716 401.197 380.561 401.197 365.566C401.197 350.571 379.499 338.415 352.734 338.415C325.968 338.415 304.271 350.571 304.271 365.566C304.271 380.561 325.968 392.716 352.734 392.716Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2083,
    d: "M352.734 392.151C378.941 392.151 400.187 380.248 400.187 365.566C400.187 350.884 378.941 338.981 352.734 338.981C326.526 338.981 305.281 350.884 305.281 365.566C305.281 380.248 326.526 392.151 352.734 392.151Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M352.734 391.585C378.384 391.585 399.177 379.936 399.177 365.566C399.177 351.196 378.384 339.547 352.734 339.547C327.084 339.547 306.291 351.196 306.291 365.566C306.291 379.936 327.084 391.585 352.734 391.585Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2917,
    d: "M352.734 391.019C377.826 391.019 398.167 379.623 398.167 365.566C398.167 351.509 377.826 340.113 352.734 340.113C327.642 340.113 307.3 351.509 307.3 365.566C307.3 379.623 327.642 391.019 352.734 391.019Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M352.734 390.453C377.268 390.453 397.157 379.311 397.157 365.566C397.157 351.821 377.268 340.678 352.734 340.678C328.199 340.678 308.31 351.821 308.31 365.566C308.31 379.311 328.199 390.453 352.734 390.453Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M352.734 389.888C376.711 389.888 396.148 378.998 396.148 365.566C396.148 352.133 376.711 341.244 352.734 341.244C328.757 341.244 309.32 352.133 309.32 365.566C309.32 378.998 328.757 389.888 352.734 389.888Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4167,
    d: "M352.734 389.322C376.153 389.322 395.138 378.686 395.138 365.566C395.138 352.446 376.153 341.81 352.734 341.81C329.315 341.81 310.33 352.446 310.33 365.566C310.33 378.686 329.315 389.322 352.734 389.322Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4583,
    d: "M352.734 388.756C375.595 388.756 394.128 378.373 394.128 365.566C394.128 352.758 375.595 342.376 352.734 342.376C329.873 342.376 311.34 352.758 311.34 365.566C311.34 378.373 329.873 388.756 352.734 388.756Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M352.734 388.19C375.037 388.19 393.118 378.061 393.118 365.566C393.118 353.071 375.037 342.942 352.734 342.942C330.43 342.942 312.35 353.071 312.35 365.566C312.35 378.061 330.43 388.19 352.734 388.19Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5417,
    d: "M352.734 387.625C374.479 387.625 392.108 377.749 392.108 365.566C392.108 353.383 374.479 343.507 352.734 343.507C330.988 343.507 313.36 353.383 313.36 365.566C313.36 377.749 330.988 387.625 352.734 387.625Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5833,
    d: "M352.734 387.059C373.922 387.059 391.098 377.436 391.098 365.566C391.098 353.696 373.922 344.073 352.734 344.073C331.546 344.073 314.37 353.696 314.37 365.566C314.37 377.436 331.546 387.059 352.734 387.059Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M352.734 386.493C373.364 386.493 390.088 377.124 390.088 365.566C390.088 354.008 373.364 344.639 352.734 344.639C332.104 344.639 315.38 354.008 315.38 365.566C315.38 377.124 332.104 386.493 352.734 386.493Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M352.734 385.927C372.806 385.927 389.078 376.811 389.078 365.566C389.078 354.321 372.806 345.205 352.734 345.205C332.662 345.205 316.39 354.321 316.39 365.566C316.39 376.811 332.662 385.927 352.734 385.927Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7083,
    d: "M352.734 385.361C372.249 385.361 388.068 376.499 388.068 365.566C388.068 354.633 372.249 345.77 352.734 345.77C333.219 345.77 317.399 354.633 317.399 365.566C317.399 376.499 333.219 385.361 352.734 385.361Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M352.734 384.796C371.691 384.796 387.058 376.186 387.058 365.566C387.058 354.946 371.691 346.336 352.734 346.336C333.777 346.336 318.41 354.946 318.41 365.566C318.41 376.186 333.777 384.796 352.734 384.796Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7917,
    d: "M352.734 384.23C371.133 384.23 386.048 375.874 386.048 365.566C386.048 355.258 371.133 346.902 352.734 346.902C334.335 346.902 319.419 355.258 319.419 365.566C319.419 375.874 334.335 384.23 352.734 384.23Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8333,
    d: "M352.734 383.664C370.575 383.664 385.039 375.561 385.039 365.566C385.039 355.571 370.575 347.468 352.734 347.468C334.892 347.468 320.429 355.571 320.429 365.566C320.429 375.561 334.892 383.664 352.734 383.664Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M352.734 383.098C370.017 383.098 384.029 375.249 384.029 365.566C384.029 355.883 370.017 348.034 352.734 348.034C335.45 348.034 321.439 355.883 321.439 365.566C321.439 375.249 335.45 383.098 352.734 383.098Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9167,
    d: "M352.734 382.533C369.46 382.533 383.019 374.936 383.019 365.566C383.019 356.195 369.46 348.599 352.734 348.599C336.008 348.599 322.449 356.195 322.449 365.566C322.449 374.936 336.008 382.533 352.734 382.533Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9583,
    d: "M352.734 381.967C368.902 381.967 382.009 374.624 382.009 365.566C382.009 356.508 368.902 349.165 352.734 349.165C336.566 349.165 323.459 356.508 323.459 365.566C323.459 374.624 336.566 381.967 352.734 381.967Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.734 381.401C368.344 381.401 380.999 374.311 380.999 365.566C380.999 356.82 368.344 349.731 352.734 349.731C337.124 349.731 324.469 356.82 324.469 365.566C324.469 374.311 337.124 381.401 352.734 381.401Z",
    fill: "#190C00"
  }))), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M316.699 378.178L322.253 374.978L318.921 379.401L316.699 378.178Z",
    fill: "#965930"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M349.812 287.705L340.641 279.567L314.012 295.86L314.99 315.92L314.923 379.215L382.539 339.885V268.286L349.812 287.705Z",
    fill: "url(#paint289_linear_7_1850)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M316.838 297.892L343.079 281.73L340.641 279.567L314.012 295.86L316.838 297.892Z",
    fill: "#FFDBC0"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M349.812 287.705L382.539 268.286L380.539 266.645L347.787 285.908L349.812 287.705Z",
    fill: "#FFDBC0"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M324.268 364.734V313.042L399.45 269.557L403.194 271.913L399.45 302.236L324.268 364.734Z",
    fill: "url(#paint290_linear_7_1850)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M324.268 313.042L328.358 315.629V367.011L324.268 379.401V313.042Z",
    fill: "#B7B0B0"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M328.358 315.629L403.194 271.913V300.684L328.358 367.011V315.629Z",
    fill: "url(#paint291_linear_7_1850)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M362.174 313.042L338.874 326.156C338.017 326.64 337.317 326.336 337.317 325.48C337.317 324.623 338.017 323.526 338.874 323.041L362.174 309.928C363.03 309.443 363.731 309.747 363.731 310.604C363.731 311.46 363.03 312.557 362.174 313.042Z",
    fill: "url(#paint292_linear_7_1850)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M393.89 300.674L338.874 331.815C338.017 332.3 337.316 331.996 337.316 331.139C337.316 330.283 338.017 329.186 338.874 328.701L393.89 297.559C394.746 297.075 395.447 297.379 395.447 298.235C395.447 299.091 394.746 300.189 393.89 300.674Z",
    fill: "url(#paint293_linear_7_1850)"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M393.89 306.333L338.874 337.475C338.017 337.96 337.316 337.656 337.316 336.799C337.316 335.943 338.017 334.845 338.874 334.361L393.89 303.219C394.746 302.734 395.447 303.038 395.447 303.895C395.447 304.751 394.746 305.849 393.89 306.333Z",
    fill: "url(#paint294_linear_7_1850)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M393.89 311.993L338.874 343.135C338.017 343.619 337.316 343.315 337.316 342.459C337.316 341.603 338.017 340.505 338.874 340.02L393.89 308.879C394.746 308.394 395.447 308.698 395.447 309.555C395.447 310.411 394.746 311.508 393.89 311.993Z",
    fill: "url(#paint295_linear_7_1850)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M393.89 318.032L338.874 349.174C338.017 349.659 337.316 349.355 337.316 348.498C337.316 347.642 338.017 346.544 338.874 346.06L393.89 314.918C394.746 314.433 395.447 314.737 395.447 315.594C395.447 316.45 394.746 317.548 393.89 318.032Z",
    fill: "url(#paint296_linear_7_1850)"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M387.308 341.869L422 290.764L354.451 330.844L319.759 381.95L387.308 341.869Z",
    fill: "url(#paint297_linear_7_1850)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M314.013 295.86L316.838 297.892V378.073L318.649 379.065L351.548 328.931L354.451 330.844L319.759 381.95L314.013 379.098V295.86Z",
    fill: "#B7774B"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M351.548 328.931L419.649 289.199L422 290.764L354.451 330.844L351.548 328.931Z",
    fill: "#FFDBC0"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0417,
    d: "M67.059 456.675C103.382 456.675 132.828 440.179 132.828 419.83C132.828 399.48 103.382 382.984 67.059 382.984C30.7358 382.984 1.28996 399.48 1.28996 419.83C1.28996 440.179 30.7358 456.675 67.059 456.675Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0833,
    d: "M67.059 455.953C102.67 455.953 131.538 439.78 131.538 419.83C131.538 399.879 102.67 383.706 67.059 383.706C31.448 383.706 2.57967 399.879 2.57967 419.83C2.57967 439.78 31.448 455.953 67.059 455.953Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M67.059 455.23C101.958 455.23 130.248 439.381 130.248 419.83C130.248 400.278 101.958 384.429 67.059 384.429C32.1605 384.429 3.86963 400.278 3.86963 419.83C3.86963 439.381 32.1605 455.23 67.059 455.23Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1667,
    d: "M67.059 454.508C101.245 454.508 128.958 438.982 128.958 419.83C128.958 400.677 101.245 385.151 67.059 385.151C32.8729 385.151 5.15959 400.677 5.15959 419.83C5.15959 438.982 32.8729 454.508 67.059 454.508Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2083,
    d: "M67.059 453.785C100.533 453.785 127.669 438.583 127.669 419.83C127.669 401.076 100.533 385.874 67.059 385.874C33.5852 385.874 6.44933 401.076 6.44933 419.83C6.44933 438.583 33.5852 453.785 67.059 453.785Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M67.059 453.062C99.8204 453.062 126.379 438.183 126.379 419.829C126.379 401.476 99.8204 386.597 67.059 386.597C34.2976 386.597 7.73927 401.476 7.73927 419.829C7.73927 438.183 34.2976 453.062 67.059 453.062Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2917,
    d: "M67.059 452.34C99.108 452.34 125.089 437.784 125.089 419.83C125.089 401.875 99.108 387.32 67.059 387.32C35.01 387.32 9.02921 401.875 9.02921 419.83C9.02921 437.784 35.01 452.34 67.059 452.34Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M67.059 451.617C98.3957 451.617 123.799 437.385 123.799 419.83C123.799 402.274 98.3957 388.042 67.059 388.042C35.7223 388.042 10.319 402.274 10.319 419.83C10.319 437.385 35.7223 451.617 67.059 451.617Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M67.059 450.894C97.6833 450.894 122.509 436.986 122.509 419.83C122.509 402.673 97.6833 388.765 67.059 388.765C36.4347 388.765 11.6089 402.673 11.6089 419.83C11.6089 436.986 36.4347 450.894 67.059 450.894Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4167,
    d: "M67.059 450.172C96.9708 450.172 121.219 436.587 121.219 419.83C121.219 403.072 96.9708 389.487 67.059 389.487C37.1472 389.487 12.8988 403.072 12.8988 419.83C12.8988 436.587 37.1472 450.172 67.059 450.172Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4583,
    d: "M67.059 449.449C96.2584 449.449 119.929 436.188 119.929 419.83C119.929 403.471 96.2584 390.21 67.059 390.21C37.8596 390.21 14.1888 403.471 14.1888 419.83C14.1888 436.188 37.8596 449.449 67.059 449.449Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M67.059 448.727C95.5461 448.727 118.639 435.789 118.639 419.83C118.639 403.87 95.5461 390.932 67.059 390.932C38.5719 390.932 15.4785 403.87 15.4785 419.83C15.4785 435.789 38.5719 448.727 67.059 448.727Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5417,
    d: "M67.059 448.004C94.8337 448.004 117.35 435.39 117.35 419.83C117.35 404.269 94.8337 391.655 67.059 391.655C39.2843 391.655 16.7685 404.269 16.7685 419.83C16.7685 435.39 39.2843 448.004 67.059 448.004Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5833,
    d: "M67.059 447.281C94.1213 447.281 116.06 434.991 116.06 419.83C116.06 404.668 94.1213 392.378 67.059 392.378C39.9967 392.378 18.0584 404.668 18.0584 419.83C18.0584 434.991 39.9967 447.281 67.059 447.281Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M67.059 446.559C93.409 446.559 114.77 434.592 114.77 419.83C114.77 405.067 93.409 393.101 67.059 393.101C40.709 393.101 19.3481 405.067 19.3481 419.83C19.3481 434.592 40.709 446.559 67.059 446.559Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M67.059 445.836C92.6966 445.836 113.48 434.193 113.48 419.83C113.48 405.467 92.6966 393.823 67.059 393.823C41.4214 393.823 20.6381 405.467 20.6381 419.83C20.6381 434.193 41.4214 445.836 67.059 445.836Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7083,
    d: "M67.059 445.113C91.9842 445.113 112.19 433.793 112.19 419.83C112.19 405.866 91.9842 394.546 67.059 394.546C42.1339 394.546 21.928 405.866 21.928 419.83C21.928 433.793 42.1339 445.113 67.059 445.113Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M67.059 444.391C91.2717 444.391 110.9 433.394 110.9 419.83C110.9 406.265 91.2717 395.268 67.059 395.268C42.8463 395.268 23.218 406.265 23.218 419.83C23.218 433.394 42.8463 444.391 67.059 444.391Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7917,
    d: "M67.059 443.668C90.5594 443.668 109.61 432.995 109.61 419.83C109.61 406.664 90.5594 395.991 67.059 395.991C43.5586 395.991 24.5077 406.664 24.5077 419.83C24.5077 432.995 43.5586 443.668 67.059 443.668Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8333,
    d: "M67.059 442.945C89.847 442.945 108.32 432.596 108.32 419.83C108.32 407.063 89.847 396.714 67.059 396.714C44.271 396.714 25.7977 407.063 25.7977 419.83C25.7977 432.596 44.271 442.945 67.059 442.945Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M67.059 442.223C89.1346 442.223 107.03 432.197 107.03 419.83C107.03 407.462 89.1346 397.436 67.059 397.436C44.9834 397.436 27.0876 407.462 27.0876 419.83C27.0876 432.197 44.9834 442.223 67.059 442.223Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9167,
    d: "M67.059 441.5C88.4223 441.5 105.741 431.798 105.741 419.83C105.741 407.861 88.4223 398.159 67.059 398.159C45.6957 398.159 28.3774 407.861 28.3774 419.83C28.3774 431.798 45.6957 441.5 67.059 441.5Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9583,
    d: "M67.059 440.777C87.7099 440.777 104.451 431.399 104.451 419.83C104.451 408.26 87.7099 398.882 67.059 398.882C46.4081 398.882 29.6673 408.26 29.6673 419.83C29.6673 431.399 46.4081 440.777 67.059 440.777Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.059 440.055C86.9975 440.055 103.161 431 103.161 419.83C103.161 408.659 86.9975 399.604 67.059 399.604C47.1206 399.604 30.9572 408.659 30.9572 419.83C30.9572 431 47.1206 440.055 67.059 440.055Z",
    fill: "#190C00"
  }))), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M132.683 389.798C132.491 390.867 131.847 391.854 130.777 392.472L72.3885 425.684C68.6584 427.81 64.0645 427.755 60.3758 425.561L3.42713 391.622C2.26148 390.936 1.5898 389.811 1.41109 388.632C1.17816 387.014 1.87775 385.273 3.4954 384.354L60.8284 351.732C64.9422 349.4 70.0022 349.441 74.061 351.869L130.846 385.711C132.354 386.617 132.971 388.276 132.683 389.798Z",
    fill: "url(#paint298_linear_7_1850)"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8946 427.145V437.067C63.3257 436.852 61.7739 436.323 60.3703 435.482L3.42628 401.536C2.27107 400.843 1.6269 399.753 1.44558 398.581L1.36245 398.548V388.627H1.41245C1.59377 389.816 2.254 390.938 3.42628 391.615L60.3703 425.56C61.7739 426.402 63.3257 426.931 64.8946 427.145Z",
    fill: "url(#paint299_linear_7_1850)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M132.751 389.799V398.548L132.702 398.581C132.867 400.034 132.223 401.553 130.77 402.378L72.3903 435.597C70.0782 436.917 67.4534 437.396 64.8946 437.066V427.145C67.4534 427.475 70.0782 426.996 72.3903 425.675L130.77 392.473C131.843 391.846 132.487 390.872 132.685 389.799L132.751 389.799Z",
    fill: "url(#paint300_linear_7_1850)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M106.83 389.337C106.714 389.985 106.324 390.584 105.676 390.958L70.2887 411.086C68.0281 412.374 65.2438 412.341 63.0083 411.011L28.4942 390.443C27.7878 390.027 27.3808 389.346 27.2724 388.631C27.1312 387.65 27.5551 386.595 28.5356 386.038L63.2826 366.267C65.7757 364.854 68.8423 364.879 71.3023 366.35L105.717 386.861C106.631 387.409 107.005 388.415 106.83 389.337Z",
    fill: "url(#paint301_linear_7_1850)"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M214.399 267.836C214.399 266.693 214.118 265.561 213.589 264.561C212.97 263.371 212.037 262.403 210.877 261.729L92.0324 193.059C87.9865 190.722 82.9267 193.638 82.9219 198.311L82.8291 287.341C82.8291 288.535 83.4723 289.65 84.5082 290.251L208.617 362.168C211.186 363.657 214.402 361.803 214.402 358.834L214.399 267.836Z",
    fill: "#449398"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M156.718 252.738L103.42 221.731C101.959 220.881 100.764 218.99 100.764 217.529C100.764 216.069 101.959 215.569 103.42 216.419L156.718 247.426C158.179 248.276 159.374 250.166 159.374 251.627C159.374 253.088 158.179 253.588 156.718 252.738Z",
    fill: "#CCD3DD"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M156.718 294.988L103.42 263.981C101.959 263.131 100.764 261.24 100.764 259.779C100.764 258.319 101.959 257.819 103.42 258.669L156.718 289.676C158.179 290.526 159.374 292.416 159.374 293.877C159.374 295.338 158.179 295.838 156.718 294.988Z",
    fill: "#CCD3DD"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M198.131 287.366V292.938C198.131 295.163 196.307 295.921 194.082 294.627L103.144 241.722C100.919 240.427 99.0997 237.549 99.0997 235.324V229.752C99.0997 227.527 100.919 226.766 103.144 228.061L194.082 280.967C196.307 282.261 198.131 285.141 198.131 287.366Z",
    fill: "white"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M198.131 287.366V292.938C198.131 295.163 196.307 295.921 194.082 294.627L176.668 284.496V270.836L194.082 280.966C196.307 282.261 198.131 285.141 198.131 287.366Z",
    fill: "#FFD822"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M198.131 329.353V334.925C198.131 337.15 196.307 337.908 194.082 336.614L103.144 283.709C100.919 282.414 99.0997 279.536 99.0997 277.311V271.739C99.0997 269.514 100.919 268.753 103.144 270.048L194.082 322.954C196.307 324.248 198.131 327.128 198.131 329.353Z",
    fill: "white"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M198.131 329.353V334.925C198.131 337.15 196.307 337.908 194.082 336.614L176.668 326.483V312.823L194.082 322.953C196.307 324.248 198.131 327.128 198.131 329.353Z",
    fill: "#FFD822"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M110.529 240.505C111.207 239.997 111.024 238.609 110.121 237.405C109.218 236.202 107.936 235.639 107.258 236.148C106.58 236.656 106.763 238.044 107.666 239.248C108.569 240.451 109.851 241.014 110.529 240.505Z",
    fill: "#525575"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M118.769 244.075C118.769 245.204 117.854 245.587 116.725 244.93C115.595 244.273 114.68 242.825 114.68 241.696C114.68 240.567 115.596 240.184 116.725 240.841C117.854 241.498 118.769 242.946 118.769 244.075Z",
    fill: "#525575"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M126.204 249.627C126.882 249.118 126.7 247.73 125.796 246.527C124.893 245.323 123.612 244.76 122.934 245.269C122.256 245.778 122.438 247.166 123.341 248.369C124.245 249.573 125.526 250.136 126.204 249.627Z",
    fill: "#525575"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M134.043 254.183C134.721 253.674 134.538 252.286 133.635 251.083C132.732 249.88 131.45 249.317 130.772 249.826C130.095 250.335 130.277 251.722 131.18 252.926C132.083 254.129 133.365 254.692 134.043 254.183Z",
    fill: "#525575"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M141.88 258.746C142.558 258.237 142.376 256.849 141.473 255.646C140.569 254.442 139.288 253.879 138.61 254.388C137.932 254.897 138.114 256.285 139.018 257.488C139.921 258.691 141.203 259.255 141.88 258.746Z",
    fill: "#525575"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M149.719 263.304C150.397 262.796 150.214 261.408 149.311 260.204C148.408 259.001 147.126 258.438 146.448 258.947C145.77 259.456 145.953 260.843 146.856 262.047C147.759 263.25 149.041 263.813 149.719 263.304Z",
    fill: "#525575"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M110.932 281.409C110.932 282.538 110.016 282.921 108.887 282.264C107.758 281.607 106.842 280.159 106.842 279.03C106.842 277.9 107.758 277.518 108.887 278.174C110.016 278.831 110.932 280.279 110.932 281.409Z",
    fill: "#525575"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M118.769 285.969C118.769 287.098 117.854 287.481 116.725 286.824C115.596 286.167 114.68 284.719 114.68 283.59C114.68 282.46 115.596 282.078 116.725 282.734C117.854 283.391 118.769 284.839 118.769 285.969Z",
    fill: "#525575"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M126.607 290.528C126.607 291.658 125.692 292.04 124.562 291.384C123.433 290.726 122.518 289.279 122.518 288.149C122.518 287.02 123.433 286.637 124.562 287.294C125.692 287.951 126.607 289.399 126.607 290.528Z",
    fill: "#525575"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M134.044 296.077C134.722 295.568 134.539 294.18 133.636 292.977C132.733 291.774 131.451 291.211 130.773 291.72C130.095 292.229 130.278 293.616 131.181 294.82C132.084 296.023 133.366 296.586 134.044 296.077Z",
    fill: "#525575"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M141.881 300.641C142.559 300.132 142.376 298.744 141.473 297.541C140.57 296.337 139.288 295.774 138.61 296.283C137.932 296.792 138.115 298.18 139.018 299.383C139.921 300.587 141.203 301.15 141.881 300.641Z",
    fill: "#525575"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M149.719 305.198C150.397 304.69 150.214 303.302 149.311 302.098C148.408 300.895 147.126 300.332 146.448 300.841C145.771 301.35 145.953 302.738 146.856 303.941C147.76 305.144 149.041 305.707 149.719 305.198Z",
    fill: "#525575"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M124.997 266.449C124.997 266.449 128.697 263.815 128.697 260.59C128.697 257.365 130.423 254.003 131.877 252.55C133.33 251.096 132.83 248.325 130.332 248.961C127.834 249.597 123.11 253.504 122.746 256.729C122.383 259.954 121.209 261.104 121.209 261.104C121.209 261.104 124.705 262.178 124.997 266.449Z",
    fill: "url(#paint302_linear_7_1850)"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4191 217.611C84.4191 217.611 85.2757 223.179 84.8474 223.964C84.4191 224.75 84.4191 224.964 84.4191 224.964C84.4191 224.964 85.2301 226.82 84.9672 227.819C84.7046 228.819 83.6337 233.459 82.7058 234.672C81.7777 235.886 77.69 235.672 76.8071 236.1C75.9242 236.528 74.883 241.893 74.883 241.893L62.4324 234.886C62.4324 234.886 65.145 227.248 65.4305 224.75C65.7161 222.251 68.5715 218.753 68.5715 218.753L84.4191 217.611Z",
    fill: "url(#paint303_linear_7_1850)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8462 210.33C89.2019 211.829 86.7034 218.254 83.491 218.682C80.2786 219.11 81.9205 223.251 80.5641 223.536C79.2077 223.822 79.7075 228.034 78.8509 227.891C77.9943 227.748 78.4226 224.321 75.8527 224.321C73.2829 224.321 76.4238 230.032 74.8533 230.461C73.2829 230.889 66.1444 231.389 64.0741 228.176C62.0039 224.964 61.7183 221.894 62.0039 219.539C62.2894 217.183 64.6452 216.326 64.6452 216.326C64.6452 216.326 63.2888 211.044 69.2138 210.33C75.1389 209.616 80.9924 210.83 83.4195 210.758C85.8466 210.687 86.8462 210.33 86.8462 210.33Z",
    fill: "url(#paint304_linear_7_1850)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0012 376.387C52.0012 376.387 50.8462 382.879 51.4193 383.534C51.9924 384.189 58.885 386.482 59.9417 385.253C60.9983 384.025 63.045 380.259 65.2557 377.721C67.4663 375.183 68.0394 369.698 64.6826 371.008C61.3258 372.317 59.1583 373.873 59.1583 373.873L52.0012 376.387Z",
    fill: "url(#paint305_linear_7_1850)"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5911 385.716C71.5911 385.716 70.2498 392.131 71.1504 392.949C72.051 393.768 77.6182 397.288 79.5013 396.224C81.3844 395.16 84.8229 391.558 88.8347 390.002C92.8465 388.446 96.285 381.406 91.3726 381.487C86.4602 381.569 80.6474 383.534 80.6474 383.534L71.5911 385.716Z",
    fill: "url(#paint306_linear_7_1850)"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3857 297.234C52.3857 297.234 48.1495 304.829 49.4844 309.279C50.8193 313.729 52.3857 315.657 52.3857 315.657L53.1928 339.094C53.1928 339.094 51.0042 347.846 51.2085 357.784C51.4127 367.723 51.2085 375.139 51.2085 375.139C51.2085 375.139 52.3028 378.403 57.0495 378.106C61.7963 377.809 62.983 375.139 62.983 375.139C62.983 375.139 61.4997 354.076 67.1364 342.802C72.773 331.529 69.9548 300.972 69.9548 300.972L52.3857 297.234Z",
    fill: "url(#paint307_linear_7_1850)"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9926 233.041C47.9926 233.041 35.4119 263.81 36.0635 266.155C36.7148 268.5 54.8255 289.086 54.8255 289.086L61.0796 278.663L48.5579 261.986L53.6528 243.354L47.9926 233.041Z",
    fill: "url(#paint308_linear_7_1850)"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9326 232.355C64.1035 233.249 68.9253 236.274 74.2887 238.445C79.6521 240.616 76.715 243.681 79.1412 245.341C81.5675 247.001 83.7693 247.552 84.5355 253.043C85.3018 258.534 87.8558 300.292 87.8558 300.292C87.8558 300.292 78.4059 307.443 64.9974 305.017C51.5888 302.59 51.9719 295.184 51.9719 295.184C51.9719 295.184 50.8225 264.919 47.63 255.341C44.4374 245.763 44.332 231.961 50.2062 232.344C56.0805 232.727 55.1642 233.504 57.9736 233.377C60.7834 233.249 61.9326 232.355 61.9326 232.355Z",
    fill: "url(#paint309_linear_7_1850)"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4733 249.753C79.831 249.825 73.9453 254.106 76.818 262.275C79.6904 270.444 95.3675 287.601 96.9834 287.69C98.5992 287.78 101.651 283.382 102.459 278.444C103.267 273.507 100.933 271.622 100.933 271.622C100.933 271.622 86.301 249.698 83.4733 249.753Z",
    fill: "url(#paint310_linear_7_1850)"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M102.629 274.495L121.131 260.67C121.131 260.67 123.644 260.76 124.991 264.261C126.337 267.762 125.26 268.359 125.26 268.359C125.26 268.359 104.254 289.758 97.4322 287.692C97.4322 287.692 102.62 282.574 102.629 274.495Z",
    fill: "url(#paint311_linear_7_1850)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0796 304.06C61.0796 304.06 58.9266 312.01 61.0796 316.943C63.2326 321.876 66.4255 323.109 66.4255 323.109L70.6592 343.766C70.6592 343.766 68.9361 352.553 69.8612 365.039C70.7861 377.526 70.6592 384.463 70.6592 384.463C70.6592 384.463 71.8652 387.084 75.2568 387.392C78.6483 387.7 81.7314 385.234 81.7314 385.234C81.7314 385.234 81.7314 357.887 84.9687 345.739C88.206 333.592 86.7642 301.017 86.7642 301.017C86.7642 301.017 76.1921 308.751 61.0796 304.06Z",
    fill: "url(#paint312_linear_7_1850)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_1850",
    x1: 241.358,
    y1: 208.606,
    x2: 389.162,
    y2: 208.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_1850",
    x1: 338.723,
    y1: 218.593,
    x2: 343.936,
    y2: 218.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7_1850",
    x1: 334.699,
    y1: 216.239,
    x2: 339.912,
    y2: 216.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7_1850",
    x1: 330.675,
    y1: 213.886,
    x2: 335.888,
    y2: 213.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7_1850",
    x1: 326.651,
    y1: 211.533,
    x2: 331.864,
    y2: 211.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7_1850",
    x1: 322.628,
    y1: 209.179,
    x2: 327.84,
    y2: 209.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7_1850",
    x1: 318.604,
    y1: 206.826,
    x2: 323.816,
    y2: 206.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7_1850",
    x1: 314.58,
    y1: 204.472,
    x2: 319.792,
    y2: 204.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7_1850",
    x1: 310.556,
    y1: 202.119,
    x2: 315.769,
    y2: 202.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7_1850",
    x1: 306.532,
    y1: 199.766,
    x2: 311.745,
    y2: 199.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7_1850",
    x1: 302.508,
    y1: 197.412,
    x2: 307.721,
    y2: 197.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7_1850",
    x1: 298.484,
    y1: 195.059,
    x2: 303.697,
    y2: 195.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7_1850",
    x1: 294.46,
    y1: 192.705,
    x2: 299.673,
    y2: 192.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7_1850",
    x1: 290.437,
    y1: 190.352,
    x2: 295.649,
    y2: 190.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7_1850",
    x1: 286.413,
    y1: 187.999,
    x2: 291.625,
    y2: 187.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7_1850",
    x1: 334.105,
    y1: 221.375,
    x2: 339.317,
    y2: 221.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7_1850",
    x1: 330.081,
    y1: 219.021,
    x2: 335.294,
    y2: 219.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_7_1850",
    x1: 326.057,
    y1: 216.668,
    x2: 331.27,
    y2: 216.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_7_1850",
    x1: 322.033,
    y1: 214.315,
    x2: 327.246,
    y2: 214.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_7_1850",
    x1: 318.009,
    y1: 211.961,
    x2: 323.222,
    y2: 211.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_7_1850",
    x1: 313.986,
    y1: 209.608,
    x2: 319.198,
    y2: 209.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_7_1850",
    x1: 309.962,
    y1: 207.254,
    x2: 315.174,
    y2: 207.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_7_1850",
    x1: 305.938,
    y1: 204.901,
    x2: 311.15,
    y2: 204.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_7_1850",
    x1: 301.914,
    y1: 202.548,
    x2: 307.127,
    y2: 202.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_7_1850",
    x1: 297.89,
    y1: 200.194,
    x2: 303.103,
    y2: 200.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_7_1850",
    x1: 293.866,
    y1: 197.841,
    x2: 299.079,
    y2: 197.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_7_1850",
    x1: 289.842,
    y1: 195.487,
    x2: 295.055,
    y2: 195.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_7_1850",
    x1: 285.818,
    y1: 193.134,
    x2: 291.031,
    y2: 193.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_7_1850",
    x1: 281.795,
    y1: 190.781,
    x2: 287.007,
    y2: 190.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_7_1850",
    x1: 326.425,
    y1: 223.256,
    x2: 334.699,
    y2: 223.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_7_1850",
    x1: 325.463,
    y1: 221.803,
    x2: 330.675,
    y2: 221.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_7_1850",
    x1: 321.439,
    y1: 219.45,
    x2: 326.652,
    y2: 219.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_7_1850",
    x1: 317.415,
    y1: 217.096,
    x2: 322.628,
    y2: 217.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_7_1850",
    x1: 313.391,
    y1: 214.743,
    x2: 318.604,
    y2: 214.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_7_1850",
    x1: 309.367,
    y1: 212.39,
    x2: 314.58,
    y2: 212.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_7_1850",
    x1: 305.343,
    y1: 210.036,
    x2: 310.556,
    y2: 210.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_7_1850",
    x1: 301.319,
    y1: 207.683,
    x2: 306.532,
    y2: 207.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_7_1850",
    x1: 297.296,
    y1: 205.329,
    x2: 302.508,
    y2: 205.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_7_1850",
    x1: 293.272,
    y1: 202.976,
    x2: 298.484,
    y2: 202.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_7_1850",
    x1: 289.248,
    y1: 200.623,
    x2: 294.461,
    y2: 200.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_7_1850",
    x1: 285.224,
    y1: 198.269,
    x2: 290.437,
    y2: 198.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_7_1850",
    x1: 281.2,
    y1: 195.916,
    x2: 286.413,
    y2: 195.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_7_1850",
    x1: 277.176,
    y1: 194.484,
    x2: 285.51,
    y2: 194.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_7_1850",
    x1: 324.869,
    y1: 226.939,
    x2: 330.081,
    y2: 226.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_7_1850",
    x1: 320.845,
    y1: 224.585,
    x2: 326.057,
    y2: 224.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_7_1850",
    x1: 316.821,
    y1: 222.232,
    x2: 322.033,
    y2: 222.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_7_1850",
    x1: 312.797,
    y1: 219.878,
    x2: 318.01,
    y2: 219.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_7_1850",
    x1: 308.773,
    y1: 217.525,
    x2: 313.986,
    y2: 217.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_7_1850",
    x1: 304.749,
    y1: 215.172,
    x2: 309.962,
    y2: 215.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_7_1850",
    x1: 300.725,
    y1: 212.818,
    x2: 305.938,
    y2: 212.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_7_1850",
    x1: 296.701,
    y1: 210.465,
    x2: 301.914,
    y2: 210.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_7_1850",
    x1: 292.677,
    y1: 208.111,
    x2: 297.89,
    y2: 208.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_7_1850",
    x1: 288.654,
    y1: 205.758,
    x2: 293.866,
    y2: 205.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_7_1850",
    x1: 284.63,
    y1: 203.405,
    x2: 289.842,
    y2: 203.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_7_1850",
    x1: 280.606,
    y1: 201.051,
    x2: 285.818,
    y2: 201.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_7_1850",
    x1: 276.582,
    y1: 198.698,
    x2: 281.795,
    y2: 198.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_7_1850",
    x1: 272.558,
    y1: 196.344,
    x2: 277.771,
    y2: 196.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_7_1850",
    x1: 320.25,
    y1: 229.72,
    x2: 325.463,
    y2: 229.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_7_1850",
    x1: 316.226,
    y1: 227.367,
    x2: 321.439,
    y2: 227.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_7_1850",
    x1: 312.202,
    y1: 225.014,
    x2: 317.415,
    y2: 225.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_7_1850",
    x1: 308.179,
    y1: 222.66,
    x2: 313.391,
    y2: 222.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_7_1850",
    x1: 304.155,
    y1: 220.307,
    x2: 309.367,
    y2: 220.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_7_1850",
    x1: 300.131,
    y1: 217.953,
    x2: 305.343,
    y2: 217.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_7_1850",
    x1: 296.107,
    y1: 215.6,
    x2: 301.32,
    y2: 215.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_7_1850",
    x1: 292.083,
    y1: 213.247,
    x2: 297.296,
    y2: 213.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_7_1850",
    x1: 288.059,
    y1: 210.893,
    x2: 293.272,
    y2: 210.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_7_1850",
    x1: 284.035,
    y1: 208.54,
    x2: 289.248,
    y2: 208.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_7_1850",
    x1: 280.011,
    y1: 206.186,
    x2: 285.224,
    y2: 206.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_7_1850",
    x1: 275.987,
    y1: 203.833,
    x2: 281.2,
    y2: 203.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_7_1850",
    x1: 271.964,
    y1: 201.48,
    x2: 277.176,
    y2: 201.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_7_1850",
    x1: 267.94,
    y1: 199.126,
    x2: 273.152,
    y2: 199.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_7_1850",
    x1: 315.632,
    y1: 232.502,
    x2: 320.845,
    y2: 232.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_7_1850",
    x1: 311.608,
    y1: 230.149,
    x2: 316.821,
    y2: 230.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_7_1850",
    x1: 307.584,
    y1: 227.796,
    x2: 312.797,
    y2: 227.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_7_1850",
    x1: 303.56,
    y1: 225.442,
    x2: 308.773,
    y2: 225.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_7_1850",
    x1: 284.818,
    y1: 218.749,
    x2: 304.749,
    y2: 218.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_7_1850",
    x1: 295.513,
    y1: 220.735,
    x2: 300.725,
    y2: 220.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_7_1850",
    x1: 291.489,
    y1: 218.382,
    x2: 296.701,
    y2: 218.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_7_1850",
    x1: 287.465,
    y1: 216.029,
    x2: 292.677,
    y2: 216.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_7_1850",
    x1: 283.441,
    y1: 213.675,
    x2: 288.654,
    y2: 213.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_7_1850",
    x1: 279.417,
    y1: 211.322,
    x2: 284.63,
    y2: 211.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_7_1850",
    x1: 275.393,
    y1: 208.968,
    x2: 280.606,
    y2: 208.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_7_1850",
    x1: 271.369,
    y1: 206.615,
    x2: 276.582,
    y2: 206.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_7_1850",
    x1: 267.345,
    y1: 204.261,
    x2: 272.558,
    y2: 204.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_7_1850",
    x1: 263.322,
    y1: 201.908,
    x2: 268.534,
    y2: 201.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_7_1850",
    x1: 235.072,
    y1: 191.532,
    x2: 330.441,
    y2: 191.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_7_1850",
    x1: 308.41,
    y1: 160.389,
    x2: 264.225,
    y2: 208.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_7_1850",
    x1: 233.643,
    y1: 154.1,
    x2: 329.655,
    y2: 154.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_7_1850",
    x1: 34.5055,
    y1: 230.815,
    x2: 94.6981,
    y2: 230.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_7_1850",
    x1: 182.664,
    y1: 203.232,
    x2: 34.86,
    y2: 203.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_7_1850",
    x1: 85.2984,
    y1: 213.219,
    x2: 80.0858,
    y2: 213.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_7_1850",
    x1: 89.3223,
    y1: 210.866,
    x2: 84.1097,
    y2: 210.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_7_1850",
    x1: 93.3462,
    y1: 208.512,
    x2: 88.1335,
    y2: 208.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_7_1850",
    x1: 97.37,
    y1: 206.159,
    x2: 92.1574,
    y2: 206.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_7_1850",
    x1: 101.394,
    y1: 203.805,
    x2: 96.1813,
    y2: 203.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_7_1850",
    x1: 105.418,
    y1: 201.452,
    x2: 100.205,
    y2: 201.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_7_1850",
    x1: 109.442,
    y1: 199.099,
    x2: 104.229,
    y2: 199.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_7_1850",
    x1: 113.466,
    y1: 196.745,
    x2: 108.253,
    y2: 196.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_7_1850",
    x1: 117.489,
    y1: 194.392,
    x2: 112.277,
    y2: 194.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_7_1850",
    x1: 121.513,
    y1: 192.038,
    x2: 116.301,
    y2: 192.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_7_1850",
    x1: 125.537,
    y1: 189.685,
    x2: 120.324,
    y2: 189.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_7_1850",
    x1: 129.561,
    y1: 187.332,
    x2: 124.348,
    y2: 187.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_7_1850",
    x1: 133.585,
    y1: 184.978,
    x2: 128.372,
    y2: 184.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_7_1850",
    x1: 137.609,
    y1: 182.625,
    x2: 132.396,
    y2: 182.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_7_1850",
    x1: 89.9166,
    y1: 216.001,
    x2: 84.704,
    y2: 216.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_7_1850",
    x1: 93.9405,
    y1: 213.647,
    x2: 88.7279,
    y2: 213.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_7_1850",
    x1: 97.9644,
    y1: 211.294,
    x2: 92.7517,
    y2: 211.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_7_1850",
    x1: 101.988,
    y1: 208.941,
    x2: 96.7756,
    y2: 208.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_7_1850",
    x1: 106.012,
    y1: 206.587,
    x2: 100.799,
    y2: 206.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_7_1850",
    x1: 110.036,
    y1: 204.234,
    x2: 104.823,
    y2: 204.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_7_1850",
    x1: 114.06,
    y1: 201.88,
    x2: 108.847,
    y2: 201.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_7_1850",
    x1: 118.084,
    y1: 199.527,
    x2: 112.871,
    y2: 199.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_7_1850",
    x1: 122.108,
    y1: 197.174,
    x2: 116.895,
    y2: 197.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_7_1850",
    x1: 126.131,
    y1: 194.82,
    x2: 120.919,
    y2: 194.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_7_1850",
    x1: 130.155,
    y1: 192.467,
    x2: 124.943,
    y2: 192.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_7_1850",
    x1: 134.179,
    y1: 190.113,
    x2: 128.967,
    y2: 190.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_7_1850",
    x1: 138.203,
    y1: 187.76,
    x2: 132.991,
    y2: 187.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_7_1850",
    x1: 142.227,
    y1: 185.407,
    x2: 137.014,
    y2: 185.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_7_1850",
    x1: 97.5962,
    y1: 217.882,
    x2: 89.3223,
    y2: 217.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_7_1850",
    x1: 98.5587,
    y1: 216.429,
    x2: 93.3461,
    y2: 216.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_7_1850",
    x1: 102.583,
    y1: 214.076,
    x2: 97.37,
    y2: 214.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_7_1850",
    x1: 106.607,
    y1: 211.723,
    x2: 101.394,
    y2: 211.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_7_1850",
    x1: 110.63,
    y1: 209.369,
    x2: 105.418,
    y2: 209.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_7_1850",
    x1: 114.654,
    y1: 207.016,
    x2: 109.442,
    y2: 207.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_7_1850",
    x1: 118.678,
    y1: 204.662,
    x2: 113.465,
    y2: 204.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_7_1850",
    x1: 122.702,
    y1: 202.309,
    x2: 117.489,
    y2: 202.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_7_1850",
    x1: 126.726,
    y1: 199.956,
    x2: 121.513,
    y2: 199.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_7_1850",
    x1: 130.75,
    y1: 197.602,
    x2: 125.537,
    y2: 197.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_7_1850",
    x1: 134.774,
    y1: 195.249,
    x2: 129.561,
    y2: 195.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_7_1850",
    x1: 138.798,
    y1: 192.895,
    x2: 133.585,
    y2: 192.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_7_1850",
    x1: 142.821,
    y1: 190.542,
    x2: 137.609,
    y2: 190.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_7_1850",
    x1: 146.845,
    y1: 189.11,
    x2: 138.511,
    y2: 189.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_7_1850",
    x1: 99.1532,
    y1: 221.565,
    x2: 93.9406,
    y2: 221.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_7_1850",
    x1: 103.177,
    y1: 219.211,
    x2: 97.9644,
    y2: 219.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_7_1850",
    x1: 107.201,
    y1: 216.858,
    x2: 101.988,
    y2: 216.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_7_1850",
    x1: 111.225,
    y1: 214.504,
    x2: 106.012,
    y2: 214.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_7_1850",
    x1: 115.249,
    y1: 212.151,
    x2: 110.036,
    y2: 212.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_7_1850",
    x1: 119.273,
    y1: 209.798,
    x2: 114.06,
    y2: 209.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_7_1850",
    x1: 123.296,
    y1: 207.444,
    x2: 118.084,
    y2: 207.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_7_1850",
    x1: 127.32,
    y1: 205.091,
    x2: 122.108,
    y2: 205.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_7_1850",
    x1: 131.344,
    y1: 202.737,
    x2: 126.132,
    y2: 202.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_7_1850",
    x1: 135.368,
    y1: 200.384,
    x2: 130.155,
    y2: 200.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_7_1850",
    x1: 139.392,
    y1: 198.031,
    x2: 134.179,
    y2: 198.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_7_1850",
    x1: 143.416,
    y1: 195.677,
    x2: 138.203,
    y2: 195.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_7_1850",
    x1: 147.44,
    y1: 193.324,
    x2: 142.227,
    y2: 193.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_7_1850",
    x1: 151.464,
    y1: 190.97,
    x2: 146.251,
    y2: 190.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_7_1850",
    x1: 103.771,
    y1: 224.347,
    x2: 98.5588,
    y2: 224.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_7_1850",
    x1: 107.795,
    y1: 221.993,
    x2: 102.583,
    y2: 221.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_7_1850",
    x1: 111.819,
    y1: 219.64,
    x2: 106.607,
    y2: 219.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_7_1850",
    x1: 115.843,
    y1: 217.286,
    x2: 110.63,
    y2: 217.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_7_1850",
    x1: 119.867,
    y1: 214.933,
    x2: 114.654,
    y2: 214.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_7_1850",
    x1: 123.891,
    y1: 212.58,
    x2: 118.678,
    y2: 212.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_7_1850",
    x1: 127.915,
    y1: 210.226,
    x2: 122.702,
    y2: 210.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_7_1850",
    x1: 131.939,
    y1: 207.873,
    x2: 126.726,
    y2: 207.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_7_1850",
    x1: 135.962,
    y1: 205.519,
    x2: 130.75,
    y2: 205.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_7_1850",
    x1: 139.986,
    y1: 203.166,
    x2: 134.774,
    y2: 203.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_7_1850",
    x1: 144.01,
    y1: 200.813,
    x2: 138.798,
    y2: 200.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_7_1850",
    x1: 148.034,
    y1: 198.459,
    x2: 142.821,
    y2: 198.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_7_1850",
    x1: 152.058,
    y1: 196.106,
    x2: 146.845,
    y2: 196.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_7_1850",
    x1: 156.082,
    y1: 193.752,
    x2: 150.869,
    y2: 193.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_7_1850",
    x1: 108.39,
    y1: 227.128,
    x2: 103.177,
    y2: 227.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_7_1850",
    x1: 112.414,
    y1: 224.775,
    x2: 107.201,
    y2: 224.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_7_1850",
    x1: 116.437,
    y1: 222.422,
    x2: 111.225,
    y2: 222.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_7_1850",
    x1: 120.461,
    y1: 220.068,
    x2: 115.249,
    y2: 220.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_7_1850",
    x1: 139.204,
    y1: 213.375,
    x2: 119.273,
    y2: 213.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_7_1850",
    x1: 128.509,
    y1: 215.361,
    x2: 123.296,
    y2: 215.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_7_1850",
    x1: 132.533,
    y1: 213.008,
    x2: 127.32,
    y2: 213.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_7_1850",
    x1: 136.557,
    y1: 210.655,
    x2: 131.344,
    y2: 210.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_7_1850",
    x1: 140.581,
    y1: 208.301,
    x2: 135.368,
    y2: 208.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_7_1850",
    x1: 144.605,
    y1: 205.948,
    x2: 139.392,
    y2: 205.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_7_1850",
    x1: 148.628,
    y1: 203.594,
    x2: 143.416,
    y2: 203.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_7_1850",
    x1: 152.652,
    y1: 201.241,
    x2: 147.44,
    y2: 201.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_7_1850",
    x1: 156.676,
    y1: 198.888,
    x2: 151.464,
    y2: 198.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_7_1850",
    x1: 160.7,
    y1: 196.534,
    x2: 155.487,
    y2: 196.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_7_1850",
    x1: 188.95,
    y1: 186.158,
    x2: 93.5808,
    y2: 186.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_7_1850",
    x1: 127.428,
    y1: 163.342,
    x2: 164.692,
    y2: 213.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_7_1850",
    x1: 190.378,
    y1: 148.726,
    x2: 94.3667,
    y2: 148.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_7_1850",
    x1: 219.025,
    y1: 296.973,
    x2: 219.025,
    y2: 254.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_7_1850",
    x1: 155.631,
    y1: 320.802,
    x2: 228.608,
    y2: 301.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_7_1850",
    x1: 240.921,
    y1: 279.103,
    x2: 260.198,
    y2: 330.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_7_1850",
    x1: 219.025,
    y1: 284.894,
    x2: 219.025,
    y2: 260.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#537E8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BA0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_7_1850",
    x1: 226.32,
    y1: 252.224,
    x2: 211.291,
    y2: 284.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_7_1850",
    x1: 217.673,
    y1: 184.378,
    x2: 220.954,
    y2: 242.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_7_1850",
    x1: 155.631,
    y1: 261.523,
    x2: 228.608,
    y2: 241.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_7_1850",
    x1: 240.921,
    y1: 219.824,
    x2: 260.198,
    y2: 271.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_7_1850",
    x1: 219.025,
    y1: 225.615,
    x2: 219.025,
    y2: 200.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#537E8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BA0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_7_1850",
    x1: 226.32,
    y1: 192.945,
    x2: 211.291,
    y2: 224.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_7_1850",
    x1: 271.339,
    y1: 397.343,
    x2: 331.532,
    y2: 397.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_7_1850",
    x1: 272.489,
    y1: 373.758,
    x2: 419.805,
    y2: 373.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_7_1850",
    x1: 358.223,
    y1: 313.058,
    x2: 262.854,
    y2: 313.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_7_1850",
    x1: 358.569,
    y1: 313.381,
    x2: 269.632,
    y2: 313.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#537E8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BA0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_7_1850",
    x1: 359.651,
    y1: 275.627,
    x2: 263.64,
    y2: 275.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_7_1850",
    x1: 419.497,
    y1: 369.76,
    x2: 271.694,
    y2: 369.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_7_1850",
    x1: 305.01,
    y1: 369.318,
    x2: 299.797,
    y2: 369.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_7_1850",
    x1: 309.034,
    y1: 366.964,
    x2: 303.821,
    y2: 366.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_7_1850",
    x1: 313.058,
    y1: 364.611,
    x2: 307.845,
    y2: 364.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_7_1850",
    x1: 317.082,
    y1: 362.257,
    x2: 311.869,
    y2: 362.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_7_1850",
    x1: 321.106,
    y1: 359.904,
    x2: 315.893,
    y2: 359.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_7_1850",
    x1: 325.129,
    y1: 357.551,
    x2: 319.917,
    y2: 357.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_7_1850",
    x1: 329.153,
    y1: 355.197,
    x2: 323.941,
    y2: 355.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_7_1850",
    x1: 333.177,
    y1: 352.844,
    x2: 327.965,
    y2: 352.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_7_1850",
    x1: 337.201,
    y1: 350.49,
    x2: 331.988,
    y2: 350.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_7_1850",
    x1: 341.225,
    y1: 348.137,
    x2: 336.012,
    y2: 348.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_7_1850",
    x1: 345.249,
    y1: 345.784,
    x2: 340.036,
    y2: 345.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_7_1850",
    x1: 349.273,
    y1: 343.43,
    x2: 344.06,
    y2: 343.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_7_1850",
    x1: 353.297,
    y1: 341.077,
    x2: 348.084,
    y2: 341.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_7_1850",
    x1: 357.32,
    y1: 338.723,
    x2: 352.108,
    y2: 338.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_7_1850",
    x1: 309.628,
    y1: 372.099,
    x2: 304.416,
    y2: 372.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_7_1850",
    x1: 313.652,
    y1: 369.746,
    x2: 308.44,
    y2: 369.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_7_1850",
    x1: 317.676,
    y1: 367.393,
    x2: 312.463,
    y2: 367.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_7_1850",
    x1: 321.7,
    y1: 365.039,
    x2: 316.487,
    y2: 365.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_7_1850",
    x1: 325.724,
    y1: 362.686,
    x2: 320.511,
    y2: 362.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_7_1850",
    x1: 329.748,
    y1: 360.332,
    x2: 324.535,
    y2: 360.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_7_1850",
    x1: 333.772,
    y1: 357.979,
    x2: 328.559,
    y2: 357.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_7_1850",
    x1: 337.795,
    y1: 355.626,
    x2: 332.583,
    y2: 355.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_7_1850",
    x1: 341.819,
    y1: 353.272,
    x2: 336.607,
    y2: 353.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_7_1850",
    x1: 345.843,
    y1: 350.919,
    x2: 340.631,
    y2: 350.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_7_1850",
    x1: 349.867,
    y1: 348.565,
    x2: 344.654,
    y2: 348.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_7_1850",
    x1: 353.891,
    y1: 346.212,
    x2: 348.678,
    y2: 346.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_7_1850",
    x1: 357.915,
    y1: 343.859,
    x2: 352.702,
    y2: 343.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_7_1850",
    x1: 361.939,
    y1: 341.505,
    x2: 356.726,
    y2: 341.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_7_1850",
    x1: 317.308,
    y1: 373.981,
    x2: 309.034,
    y2: 373.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_7_1850",
    x1: 318.271,
    y1: 372.528,
    x2: 313.058,
    y2: 372.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_7_1850",
    x1: 322.294,
    y1: 370.175,
    x2: 317.082,
    y2: 370.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_7_1850",
    x1: 326.318,
    y1: 367.821,
    x2: 321.106,
    y2: 367.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_7_1850",
    x1: 330.342,
    y1: 365.468,
    x2: 325.13,
    y2: 365.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_7_1850",
    x1: 334.366,
    y1: 363.114,
    x2: 329.153,
    y2: 363.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_7_1850",
    x1: 338.39,
    y1: 360.761,
    x2: 333.177,
    y2: 360.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_7_1850",
    x1: 342.414,
    y1: 358.407,
    x2: 337.201,
    y2: 358.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_7_1850",
    x1: 346.438,
    y1: 356.054,
    x2: 341.225,
    y2: 356.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_7_1850",
    x1: 350.462,
    y1: 353.701,
    x2: 345.249,
    y2: 353.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_7_1850",
    x1: 354.485,
    y1: 351.347,
    x2: 349.273,
    y2: 351.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_7_1850",
    x1: 358.509,
    y1: 348.994,
    x2: 353.297,
    y2: 348.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_7_1850",
    x1: 362.533,
    y1: 346.641,
    x2: 357.321,
    y2: 346.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_7_1850",
    x1: 366.557,
    y1: 345.209,
    x2: 358.223,
    y2: 345.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_7_1850",
    x1: 318.865,
    y1: 377.663,
    x2: 313.652,
    y2: 377.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_7_1850",
    x1: 322.889,
    y1: 375.31,
    x2: 317.676,
    y2: 375.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_7_1850",
    x1: 326.913,
    y1: 372.956,
    x2: 321.7,
    y2: 372.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_7_1850",
    x1: 330.936,
    y1: 370.603,
    x2: 325.724,
    y2: 370.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_7_1850",
    x1: 334.96,
    y1: 368.25,
    x2: 329.748,
    y2: 368.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_7_1850",
    x1: 338.984,
    y1: 365.896,
    x2: 333.772,
    y2: 365.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_7_1850",
    x1: 343.008,
    y1: 363.543,
    x2: 337.795,
    y2: 363.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_7_1850",
    x1: 347.032,
    y1: 361.189,
    x2: 341.819,
    y2: 361.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_7_1850",
    x1: 351.056,
    y1: 358.836,
    x2: 345.843,
    y2: 358.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_7_1850",
    x1: 355.08,
    y1: 356.483,
    x2: 349.867,
    y2: 356.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_7_1850",
    x1: 359.104,
    y1: 354.129,
    x2: 353.891,
    y2: 354.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_7_1850",
    x1: 363.127,
    y1: 351.776,
    x2: 357.915,
    y2: 351.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_7_1850",
    x1: 367.151,
    y1: 349.422,
    x2: 361.939,
    y2: 349.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_7_1850",
    x1: 371.175,
    y1: 347.069,
    x2: 365.963,
    y2: 347.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_7_1850",
    x1: 323.483,
    y1: 380.445,
    x2: 318.27,
    y2: 380.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_7_1850",
    x1: 327.507,
    y1: 378.092,
    x2: 322.294,
    y2: 378.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_7_1850",
    x1: 331.531,
    y1: 375.738,
    x2: 326.318,
    y2: 375.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_7_1850",
    x1: 335.555,
    y1: 373.385,
    x2: 330.342,
    y2: 373.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_7_1850",
    x1: 339.579,
    y1: 371.032,
    x2: 334.366,
    y2: 371.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_7_1850",
    x1: 343.602,
    y1: 368.678,
    x2: 338.39,
    y2: 368.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_7_1850",
    x1: 347.626,
    y1: 366.325,
    x2: 342.414,
    y2: 366.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_7_1850",
    x1: 351.65,
    y1: 363.971,
    x2: 346.438,
    y2: 363.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_7_1850",
    x1: 355.674,
    y1: 361.618,
    x2: 350.461,
    y2: 361.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_7_1850",
    x1: 359.698,
    y1: 359.265,
    x2: 354.485,
    y2: 359.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_7_1850",
    x1: 363.722,
    y1: 356.911,
    x2: 358.509,
    y2: 356.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_7_1850",
    x1: 367.746,
    y1: 354.558,
    x2: 362.533,
    y2: 354.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_7_1850",
    x1: 371.77,
    y1: 352.204,
    x2: 366.557,
    y2: 352.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_7_1850",
    x1: 375.793,
    y1: 349.851,
    x2: 370.581,
    y2: 349.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_7_1850",
    x1: 328.101,
    y1: 383.227,
    x2: 322.889,
    y2: 383.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_7_1850",
    x1: 332.125,
    y1: 380.874,
    x2: 326.913,
    y2: 380.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_7_1850",
    x1: 336.149,
    y1: 378.52,
    x2: 330.937,
    y2: 378.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_7_1850",
    x1: 340.173,
    y1: 376.167,
    x2: 334.96,
    y2: 376.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_7_1850",
    x1: 358.916,
    y1: 369.474,
    x2: 338.984,
    y2: 369.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_7_1850",
    x1: 348.221,
    y1: 371.46,
    x2: 343.008,
    y2: 371.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_7_1850",
    x1: 352.245,
    y1: 369.107,
    x2: 347.032,
    y2: 369.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_7_1850",
    x1: 356.269,
    y1: 366.753,
    x2: 351.056,
    y2: 366.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_7_1850",
    x1: 360.292,
    y1: 364.4,
    x2: 355.08,
    y2: 364.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_7_1850",
    x1: 364.316,
    y1: 362.046,
    x2: 359.104,
    y2: 362.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_7_1850",
    x1: 368.34,
    y1: 359.693,
    x2: 363.128,
    y2: 359.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_7_1850",
    x1: 372.364,
    y1: 357.34,
    x2: 367.151,
    y2: 357.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_7_1850",
    x1: 376.388,
    y1: 354.986,
    x2: 371.175,
    y2: 354.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_7_1850",
    x1: 380.412,
    y1: 352.633,
    x2: 375.199,
    y2: 352.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_7_1850",
    x1: 216.716,
    y1: 94.7641,
    x2: 225.315,
    y2: 94.7641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#537E8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BA0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_7_1850",
    x1: 225.29,
    y1: 89.0596,
    x2: 216.715,
    y2: 89.0596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47C3B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B8EDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_7_1850",
    x1: 239.545,
    y1: 108.289,
    x2: 248.144,
    y2: 108.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#537E8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BA0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_7_1850",
    x1: 248.119,
    y1: 102.585,
    x2: 239.544,
    y2: 102.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47C3B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B8EDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_7_1850",
    x1: 198.608,
    y1: 84.4102,
    x2: 207.208,
    y2: 84.4102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#537E8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BA0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_7_1850",
    x1: 207.182,
    y1: 78.7057,
    x2: 198.608,
    y2: 78.7057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47C3B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B8EDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_7_1850",
    x1: 208.172,
    y1: 18.0033,
    x2: 171.842,
    y2: 18.0033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_7_1850",
    x1: 240.918,
    y1: 13.9199,
    x2: 189.296,
    y2: 13.9199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_7_1850",
    x1: 301.146,
    y1: 85.9335,
    x2: 262.293,
    y2: 85.9335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_7_1850",
    x1: 287.207,
    y1: 40.371,
    x2: 219.226,
    y2: 40.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_7_1850",
    x1: 166.141,
    y1: 65.2704,
    x2: 276.51,
    y2: 65.2704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_7_1850",
    x1: 173.998,
    y1: 64.3986,
    x2: 272.615,
    y2: 64.3986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#537E8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BA0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_7_1850",
    x1: 360.214,
    y1: 331.77,
    x2: 312.683,
    y2: 298.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC28F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#D68B58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_7_1850",
    x1: 324.268,
    y1: 317.145,
    x2: 403.194,
    y2: 317.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_7_1850",
    x1: 363.714,
    y1: 302.468,
    x2: 368.206,
    y2: 339.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAD9D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_7_1850",
    x1: 350.524,
    y1: 316.542,
    x2: 351.84,
    y2: 318.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_7_1850",
    x1: 366.382,
    y1: 313.222,
    x2: 367.668,
    y2: 315.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_7_1850",
    x1: 366.382,
    y1: 318.881,
    x2: 367.668,
    y2: 321.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_7_1850",
    x1: 366.382,
    y1: 324.541,
    x2: 367.668,
    y2: 326.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_7_1850",
    x1: 366.382,
    y1: 330.58,
    x2: 367.668,
    y2: 332.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_7_1850",
    x1: 361.218,
    y1: 325.542,
    x2: 382.155,
    y2: 348.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC28F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#E09966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_7_1850",
    x1: 71.3991,
    y1: 359.073,
    x2: 62.5028,
    y2: 419.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCC5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEDF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_7_1850",
    x1: 35.947,
    y1: 393.715,
    x2: 30.3109,
    y2: 431.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCC5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEDF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_7_1850",
    x1: 50.771,
    y1: 438.592,
    x2: 145.918,
    y2: 391.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCC5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEDF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_7_1850",
    x1: 69.6891,
    y1: 370.716,
    x2: 64.2975,
    y2: 407.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#537E8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BA0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_7_1850",
    x1: 125.574,
    y1: 253.238,
    x2: 131.24,
    y2: 262.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE8B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_7_1850",
    x1: 83.2819,
    y1: 229.752,
    x2: 66.9342,
    y2: 229.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE8B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_7_1850",
    x1: 85.7846,
    y1: 220.439,
    x2: 67.0657,
    y2: 220.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262847"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_7_1850",
    x1: 65.8415,
    y1: 378.209,
    x2: 54.4082,
    y2: 378.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262847"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_7_1850",
    x1: 92.0292,
    y1: 388.955,
    x2: 75.4146,
    y2: 388.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262847"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_7_1850",
    x1: 69.0101,
    y1: 337.68,
    x2: 53.4964,
    y2: 337.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262847"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_7_1850",
    x1: 39.4413,
    y1: 245.24,
    x2: 62.7159,
    y2: 284.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#537E8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BA0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_7_1850",
    x1: 45.4542,
    y1: 268.928,
    x2: 87.856,
    y2: 268.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_7_1850",
    x1: 84.3408,
    y1: 272.971,
    x2: 95.5452,
    y2: 263.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#537E8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BA0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_7_1850",
    x1: 114.512,
    y1: 278.672,
    x2: 107.823,
    y2: 272.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#537E8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BA0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_7_1850",
    x1: 87.963,
    y1: 344.218,
    x2: 69.4862,
    y2: 344.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262847"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImg);
export default __webpack_public_path__ + "static/media/loginImg.ba2c28d0eb4291a6833f85606835d168.svg";
export { ForwardRef as ReactComponent };